'use strict';

angular.module('app', ['app.altair', 'app.datatables', 'app.routes', 'app.templates', 'app.controllers', 'app.filters', 'app.services', 'app.factories', 'app.providers', 'app.directives', 'app.config']);

angular.module('app.altair', ['selectize', 'icheck', 'textarea-autosize', 'ui.calendar', 'dragularModule', 'chart.js']);
angular.module('app.datatables', ['datatables', 'datatables.buttons', 'datatables.colreorder', 'datatables.columnfilter']);
angular.module('app.routes', ['ui.router', 'ui.router.state.events', 'ngStorage']);
angular.module('app.templates', []);
angular.module('app.controllers', ['ui.router', 'ngStorage', 'restangular', /*'ngAnimate',*/'pascalprecht.translate']);
angular.module('app.filters', []);
angular.module('app.services', ['ui.router', 'ngStorage', 'restangular']);
angular.module('app.factories', []);
angular.module('app.providers', []);
angular.module('app.directives', []);
angular.module('app.config', ['pascalprecht.translate']);
'use strict';

angular.module('app').run(function ($rootScope, $window, $translate, $timeout, $sessionStorage, $injector, preloaders, variables, app, PrintToConsole) {
    PrintToConsole.init();

    // fastclick (eliminate the 300ms delay between a physical tap and the firing of a click event on mobile browsers)
    FastClick.attach(document.body);

    $rootScope.appVer = app.version;
    $rootScope.debug = app.debug;
    $rootScope.$session = $sessionStorage.$default({
        area: {}
    });
    $rootScope.mainTheme = variables.default_theme;
    $rootScope.highContrastActive = variables.default_high_contrast;
    $rootScope.miniSidebarActive = variables.default_mini_sidebar;
    $rootScope.boxedLayoutActive = variables.default_boxed_layout;

    // wstrzykujemy usługi aby zapobiec pętli zależności
    $injector.invoke(function (UserService, selectize) {
        UserService.setupUser();
        selectize.initConfig();
    });

    // input mask
    $timeout(function () {
        Inputmask.extendAliases({
            currency_pln: {
                alias: 'currency',
                prefix: 'PLN ',
                autoUnmask: true
            },
            'gg:mm': {
                alias: 'hh:mm',
                placeholder: 'gg:mm',
                separator: ':'
            },
            'rrrr-mm-dd': {
                alias: 'yyyy-mm-dd',
                placeholder: 'rrrr-mm-dd',
                separator: '-'
            }
        });
    });

    // json
    $rootScope.json = function (data) {
        if ('string' === typeof data) {
            return angular.fromJson(data);
        } else {
            return angular.toJson(data);
        }
    };

    // get window width
    var w = angular.element($window);
    $rootScope.largeScreen = w.width() >= 1220;

    w.on('resize', function () {
        var width = w.width();
        variables.mobileMode = width < 1100;
        $rootScope.largeScreen = width >= 1220;
    });

    // show/hide main menu on page load
    $rootScope.primarySidebarOpen = !!$rootScope.largeScreen;
    $rootScope.pageLoading = true;
    $rootScope.goBack = function () {
        $window.history.go(-1);
    };

    // false dla <x a=0 b=false> true dla <x c>
    $rootScope.isParamFalse = function (value) {
        var isUndefined = 'undefined' === typeof value;
        var isZero = 0 === value || 0.0 === value;
        var isFalse = 'false' === value;
        var isEmpty = '' === value;

        return isUndefined || isZero || isFalse || !isEmpty;
    };

    if (!app.debug) {
        $window.onbeforeunload = function (e) {
            if (!e) e = window.event;
            e.cancelBubble = true;
            e.returnValue = $translate.instant('system.sure_to_leave');

            if (e.stopPropagation) {
                e.stopPropagation();
                e.preventDefault();
            }
        };
    }
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.routes').run(function ($rootScope, $state, $stateParams, $localStorage, $timeout, $log, $window, UserService) {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.breadcrumbs = [];

    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
        // scroll view to top
        $('html, body').animate({
            scrollTop: 0
        }, 200);

        $timeout(function () {
            $rootScope.pageLoading = false;
            $rootScope.pageLoaded = true;

            $('[data-inputmask]').inputmask({});
            $.UIkit.rebuild();

            $($window).resize();
        }, 500);

        // breadcrumbs
        var breadcrumbs = [];
        var state = toState;
        var safe = 20;
        while (state && 'object' === _typeof(state.data) && 0 < safe--) {
            if (UserService.isAllowed(state.data.permissions || {})) {
                breadcrumbs.push({
                    link: state.name,
                    label: state.data.pageTitle
                });
            }

            state = $state.get(state.data.parent);
        }
        breadcrumbs.push({
            link: 'restricted.dashboard_main',
            label: 'dashboard'
        });

        $timeout(function () {
            $rootScope.breadcrumbs = breadcrumbs.reverse();
        });

        // hashe dla tabów
        jQuery('body').off('click').on('click', '.uk-tab-link a', function (e) {
            var hash = jQuery(e.currentTarget).data('hash') || '';
            $localStorage.lastTab = $state.current.name + ':' + hash;
            $log.debug('last tab', $localStorage.lastTab);
        });

        // przełączanie tabów zgodnie z hashem
        if ($localStorage.lastTab) {
            $timeout(function () {
                var tab = ($localStorage.lastTab || '').split(':');
                $log.debug('try to restore last tab', $localStorage.lastTab);
                if (tab[0] == $state.current.name && tab[1]) {
                    var selector = 'a[data-hash="' + tab[1] + '"]';
                    var link = jQuery(selector);

                    if (link.length && link.is(':visible')) {
                        link.trigger('click');
                    }
                }
            }, 2000);
        }
    });

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        var isAuthenticated = UserService.isAuthenticated();

        if (isAuthenticated && 'login' === toState.name) {
            event.preventDefault();
            $rootScope.referenceState = fromState;
            $rootScope.referenceStateParams = fromParams;
            $state.go('check-session');

            return false;
        } else if (!isAuthenticated && 'login' !== toState.name && 'check-session' !== toState.name) {
            event.preventDefault();
            $rootScope.referenceState = toState;
            $rootScope.referenceStateParams = toParams;
            $state.go('check-session');

            return false;
        }

        // main search
        $rootScope.mainSearchActive = false;
        // single card
        $rootScope.headerDoubleHeightActive = false;
        // top bar
        $rootScope.topBarActive = false;
        // top menu
        $rootScope.topMenuActive = false;
        // full header
        $rootScope.fullHeaderActive = false;
        // full height
        $rootScope.page_full_height = false;
        // secondary sidebar
        $rootScope.sidebar_secondary = false;
        $rootScope.secondarySidebarHiddenLarge = false;
        // active link (wszelkie akcje edit kierują na listę)
        $rootScope.activeAsideLink = toState.name.replace('_edit', '');

        if ($($window).width() < 1220) {
            $rootScope.primarySidebarActive = false;
            $rootScope.hide_content_sidebar = false;
        }

        $rootScope.pageLoading = true;
        $rootScope.pageLoaded = false;
    });
});
'use strict';

jQuery.migrateMute = true;

angular.module('app.config').constant('variables', {
    default_theme: 'app_theme_a',
    default_mini_sidebar: false,
    default_boxed_layout: false,
    default_high_contrast: false,

    mobileMode: $(document).width() < 1100,

    header__main_height: 48,
    easing_swiftOut: [0.4, 0, 0.2, 1],
    bez_easing_swiftOut: $.bez([0.4, 0, 0.2, 1]),

    cacheLifetime: {
        fixed: {
            areas: 3600000, // 1h,
            users: 3600000, // 1h,
            notifications: 60000, // 1min
            reminders: 60000 // 1min
        },
        regexp: {
            'dictionaries/*': 3600000 // 1h,
        },
        default: 0 // none
    },

    defaults: {
        group_admin: 1,
        currency_id: 54,
        country_id: 46,
        unit_piece_id: 42,
        interest_status_id: 16,
        interest_win_id: 19,
        interest_loss_id: 20,
        task_status_id: 36,
        task_unfinished_id: 38,
        task_category_id: 21,
        project_status_started: 228,
        project_status_closed: 229,
        phase_status_started: 32,
        phase_status_closed: 35,
        crew_id_measurement: 17,
        crew_id_installation: 18,
        crew_id_service: 12,
        crew_id_transport: 11
    },

    colors: {
        // css classes
        primary: '#2196f3',
        danger: '#e53935',
        warning: '#ffa000',
        success: '#7cb342',
        muted: '#bdbdbd',
        // types
        measurement: '#ffa000',
        installation: '#7cb342',
        transport: '#2196f3',
        service: '#e53935'
    }
});

angular.module('app.config').config(function ($logProvider, $sceDelegateProvider, $translateProvider, $sceProvider, $windowProvider, ChartJsProvider, app) {
    $logProvider.debugEnabled(app.debug);

    // translations
    $translateProvider.preferredLanguage(app.lang);

    // sanitize for angular
    $sceProvider.enabled(false);
    $sceDelegateProvider.resourceUrlWhitelist(['self']);

    // chart colors
    ChartJsProvider.setOptions({
        colours: ['#1976d2', '#e53935', '#ffa000', '#8bc34a', '#0097a7']
    });

    // timeago.js
    // https://github.com/hustcc/timeago.js/blob/master/locales/pl.js
    var $window = $windowProvider.$get();
    $window.timeago = timeago();
    $window.timeago.register('pl_PL', function (number, index) {
        var locale = [['w tej chwili', 'za chwilę'], ['%s sekund temu', 'za %s sekund'], ['minutę temu', 'za minutę'], ['%s minut temu', 'za %s minut'], ['godzinę temu', 'za godzinę'], ['%s godzin temu', 'za %s godzin'], ['wczoraj', 'jutro'], // ['1 dzień temu', 'za 1 dzień'],
        ['%s dni temu', 'za %s dni'], ['tydzień temu', 'za tydzień'], ['%s tygodni temu', 'za %s tygodni'], ['miesiąc temu', 'za miesiąc'], ['%s miesięcy temu', 'za %s miesięcy'], ['rok temu', 'za rok'], ['%s lat temu', 'za %s lat'], ['%s sekundy temu', 'za %s sekundy'], ['%s minuty temu', 'za %s minuty'], ['%s godziny temu', 'za %s godziny'], ['%s dni temu', 'za %s dni'], ['%s tygodnie temu', 'za %s tygodnie'], ['%s miesiące temu', 'za %s miesiące'], ['%s lata temu', 'za %s lata']];
        return locale[index & 1 ? number % 10 > 4 || number % 10 < 2 || 1 === ~~(number / 10) % 10 ? index : ++index / 2 + 13 : index];
    });
    $window.timeago.setLocale('pl_PL');
});
'use strict';

angular.module('app.config').config(function (RestangularProvider) {
    RestangularProvider.setBaseUrl('/api/1/');
});
'use strict';

angular.module('app.routes').constant('routeResolver', {
    emptyArray: function emptyArray() {
        return [];
    },
    areasList: function areasList(areasService) {
        return areasService.getAll();
    },
    areasListForUser: function areasListForUser(areasService, $sessionStorage) {
        return _.filter(areasService.getAll(), function (area) {
            return $sessionStorage.User.areas.includes(area.id);
        });
    },
    filterAreasOptions: function filterAreasOptions($translate, areasService) {
        var areas = areasService.getAll();
        var options = [];

        options.push({
            value: 'from:0',
            label: $translate.instant('filter.area_from_any')
        });
        angular.forEach(areas, function (area) {
            options.push({
                value: 'from:' + area.id,
                label: $translate.instant('filter.area_from_prefix') + area.symbol + ' ' + area.name
            });
        });
        options.push({
            value: 'to:0',
            label: $translate.instant('filter.area_to_any')
        });
        angular.forEach(areas, function (area) {
            options.push({
                value: 'to:' + area.id,
                label: $translate.instant('filter.area_to_prefix') + area.symbol + ' ' + area.name
            });
        });

        return options;
    },
    areasOptions: function areasOptions(areasService) {
        return areasService.selectize();
    },
    usersOptions: function usersOptions(usersService) {
        return usersService.selectize();
    },
    allUserOptions: function allUserOptions(usersService) {
        var users = usersService.selectize({
            data: {
                all: true
            }
        });

        return users.then(function (data) {
            return _.map(data, function (user) {
                user.areas_id = _.map(user.areas, function (area) {
                    return area.id;
                });

                return user;
            });
        });
    },
    permissionsList: function permissionsList(permissionsService) {
        return permissionsService.getAll();
    },
    currencyOptions: function currencyOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('currencies');
    },
    countryOptions: function countryOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('countries');
    },
    locationOptions: function locationOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('locations');
    },
    installationOptions: function installationOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('installation_type');
    },
    unitOptions: function unitOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('units');
    },
    woodworkOptions: function woodworkOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('woodwork');
    },
    taskStatusOptions: function taskStatusOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('task_status');
    },
    projectStatusOptions: function projectStatusOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('project_status');
    },
    phaseStatusOptions: function phaseStatusOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('phase_status');
    },
    interestStatusOptions: function interestStatusOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('interest_phases');
    },
    userStatusOptions: function userStatusOptions($translate) {
        return [{ value: 'user_active', label: $translate.instant('user_active') }, { value: 'user_inactive', label: $translate.instant('user_inactive') }, { value: 'user_deleted', label: $translate.instant('user_deleted') }, { value: 'user_suspended', label: $translate.instant('user_suspended') }];
    },
    projectTypeOptions: function projectTypeOptions($translate) {
        return [{ value: 'measurement', label: $translate.instant('projects.measurement') }, { value: 'installation', label: $translate.instant('projects.installation') }, { value: 'transport', label: $translate.instant('projects.transport') }, { value: 'service', label: $translate.instant('projects.service') }];
    },
    categoryOptions: function categoryOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('task_types');
    },
    lossOptions: function lossOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('interest_loss');
    },
    serviceWorkOptions: function serviceWorkOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('service_work');
    },
    serviceTypeOptions: function serviceTypeOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('service_type');
    },
    transportTypeOptions: function transportTypeOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('transport_type');
    },
    packagingMethodOptions: function packagingMethodOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('packaging_method');
    },
    usersList: function usersList(usersService) {
        return usersService.getAll();
    },
    jobsOptions: function jobsOptions(dictionaryItemsService) {
        return dictionaryItemsService.selectize('jobs');
    },
    allGroupsOptions: function allGroupsOptions(groupsService) {
        return groupsService.selectize({
            data: {
                all: true
            }
        });
    },
    groupsOptions: function groupsOptions(groupsService) {
        return groupsService.selectize();
    },
    clientOptionsForProjectsFilter: function clientOptionsForProjectsFilter(projectsListFilterFactory, clientsService) {
        var filterValues = projectsListFilterFactory.prefill().getValues();
        var clientId = parseInt(filterValues['client_id'].id || 0);

        return clientId ? clientsService.findForFilter(clientId) : [];
    },
    clientOptionsForPhasesFilter: function clientOptionsForPhasesFilter(phasesListFilterFactory, clientsService) {
        var filterValues = phasesListFilterFactory.prefill().getValues();
        var clientId = parseInt(filterValues['project.client_id'].id || 0);

        return clientId ? clientsService.findForFilter(clientId) : [];
    },
    clientOptionsForInterestFilter: function clientOptionsForInterestFilter(interestsListFilterFactory, clientsService) {
        var filterValues = interestsListFilterFactory.prefill().getValues();
        var clientId = parseInt(filterValues['client_id'].id || 0);

        return clientId ? clientsService.findForFilter(clientId) : [];
    },
    clientsList: function clientsList(clientsService, clientsListFilterFactory) {
        var filterValues = clientsListFilterFactory.prefill().getValues();
        return clientsService.getFiltered(filterValues);
    },
    clientsListFilter: function clientsListFilter($q, clientsListFilterFactory) {
        var deferred = $q.defer();

        clientsListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },
    investmentOptionsForProjectsFilter: function investmentOptionsForProjectsFilter($q, api) {
        var deferred = $q.defer();

        api('investments').list().then(function (response) {
            deferred.resolve(response.data.map(function (investment) {
                return {
                    value: investment.id,
                    label: investment.name
                };
            }));
        });

        return deferred.promise;
    },
    usersListFilter: function usersListFilter($q, usersListFilterFactory) {
        var deferred = $q.defer();

        usersListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },
    interestsList: function interestsList(interestsService, interestsListFilterFactory) {
        var filterValues = interestsListFilterFactory.prefill().getValues();
        return interestsService.getFiltered(filterValues);
    },
    interestsListFilter: function interestsListFilter($q, interestsListFilterFactory) {
        var deferred = $q.defer();

        interestsListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },
    phasesList: function phasesList(phasesService, phasesListFilterFactory) {
        var filterValues = phasesListFilterFactory.prefill().getValues();
        return phasesService.getFiltered(filterValues);
    },
    phasesListFilter: function phasesListFilter($q, phasesListFilterFactory) {
        var deferred = $q.defer();

        phasesListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },
    projectsList: function projectsList(projectsService, projectsListFilterFactory) {
        var filterValues = projectsListFilterFactory.prefill().getValues();
        return projectsService.getFiltered(filterValues);
    },
    projectsListFilter: function projectsListFilter($q, projectsListFilterFactory) {
        var deferred = $q.defer();

        projectsListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },
    tasksList: function tasksList(tasksService, tasksListFilterFactory) {
        var filterValues = tasksListFilterFactory.prefill().getValues();
        return tasksService.getFiltered(filterValues);
    },
    tasksListFilter: function tasksListFilter($q, tasksListFilterFactory) {
        var deferred = $q.defer();

        tasksListFilterFactory.getProviders(deferred);

        return deferred.promise;
    },
    userData: function userData($stateParams, usersService) {
        if ($stateParams.id) {
            return usersService.find($stateParams.id);
        } else {
            return {
                id: 0
            };
        }
    }
});
'use strict';

angular.module('app.routes').config(function ($stateProvider, $urlRouterProvider, $httpProvider, $locationProvider, $provide, routeResolver) {
    var getView = function getView(viewName) {
        return '/app/' + viewName + '.html';
    };

    // Use $urlRouterProvider to configure any redirects (when) and invalid urls (otherwise).
    $urlRouterProvider.when('/dashboard', '/').otherwise('/login');

    // allow to use anchors
    $locationProvider.html5Mode(true);

    // obsługa filtrow
    $provide.decorator('$state', function ($delegate) {
        $delegate.applyFilter = function (filterValues) {
            return $delegate.go($delegate.current, { filter: filterValues }, {
                reload: false,
                inherit: false,
                notify: false
            });
        };
        return $delegate;
    });

    $stateProvider

    // -- ERROR PAGES --

    .state('error', {
        url: '/error',
        templateUrl: getView('error/default'),
        permissions: true
    }).state('error.404', {
        url: '/404',
        templateUrl: getView('error/404'),
        permissions: true
    }).state('error.500', {
        url: '/500',
        templateUrl: getView('error/500'),
        permissions: true
    })

    // -- LOGIN PAGE --

    .state('login', {
        url: '/login',
        templateUrl: getView('auth/login'),
        controller: 'AuthLoginCtrl',
        controllerAs: 'AuthLogin',
        permissions: true
    }).state('check-session', {
        url: '/check-session',
        template: '<!-- -->',
        controller: 'AuthCheckCtrl',
        controllerAs: 'AuthCheck',
        permissions: false
    })

    // -- RESTRICTED --

    .state('restricted', {
        abstract: true,
        url: '',
        views: {
            main_header: {
                templateUrl: getView('header/main_header'),
                controller: 'MainHeaderCtrl',
                controllerAs: 'MainHeader'
            },
            main_sidebar: {
                templateUrl: getView('aside/main_aside'),
                controller: 'MainAsideCtrl',
                controllerAs: 'MainAside'
            },
            '': {
                templateUrl: getView('app/restricted')
            }
        },
        resolve: {
            areasListForUser: routeResolver.areasListForUser
        }
    })

    // dashboards

    .state('restricted.dashboard_main', {
        url: '/',
        views: {
            '': {
                templateUrl: getView('dashboard/dashboard_default'),
                controller: 'DashboardDefaultCtrl',
                controllerAs: 'DashboardDefault'
            }
        },
        resolve: {
            usersOptions: routeResolver.usersOptions
        },
        data: {
            pageTitle: 'dashboard_main',
            permissions: true
        }
    }).state('restricted.dashboard_tasks', {
        url: '/dashboard/tasks',
        views: {
            '': {
                templateUrl: getView('dashboard/dashboard_tasks'),
                controller: 'DashboardTasksCtrl',
                controllerAs: 'DashboardTasks'
            }
        },
        resolve: {
            usersOptions: routeResolver.usersOptions
        },
        data: {
            pageTitle: 'dashboard_tasks',
            permissions: { tasks__read_all: 0, tasks__read: 'CUID' }
        }
    }).state('restricted.dashboard_measurement', {
        url: '/dashboard/measurement',
        views: {
            '': {
                templateUrl: getView('dashboard/dashboard_phase'),
                controller: 'DashboardPhaseCtrl',
                controllerAs: 'DashboardPhase'
            }
        },
        resolve: {
            usersOptions: routeResolver.usersOptions,
            groupsOptions: routeResolver.groupsOptions,
            phaseStatusOptions: routeResolver.phaseStatusOptions
        },
        data: {
            pageTitle: 'dashboard_measurement',
            permissions: { dashboard_measurement__read_all: 0, dashboard_measurement__read: 'CUID' },
            dashboardType: 'measurement'
        }
    }).state('restricted.dashboard_installation', {
        url: '/dashboard/installation',
        views: {
            '': {
                templateUrl: getView('dashboard/dashboard_phase'),
                controller: 'DashboardPhaseCtrl',
                controllerAs: 'DashboardPhase'
            }
        },
        resolve: {
            usersOptions: routeResolver.usersOptions,
            groupsOptions: routeResolver.groupsOptions,
            phaseStatusOptions: routeResolver.phaseStatusOptions
        },
        data: {
            pageTitle: 'dashboard_installation',
            permissions: { dashboard_installation__read_all: 0, dashboard_installation__read: 'CUID' },
            dashboardType: 'installation'
        }
    }).state('restricted.dashboard_transport', {
        url: '/dashboard/transport',
        views: {
            '': {
                templateUrl: getView('dashboard/dashboard_phase'),
                controller: 'DashboardPhaseCtrl',
                controllerAs: 'DashboardPhase'
            }
        },
        resolve: {
            usersOptions: routeResolver.usersOptions,
            groupsOptions: routeResolver.groupsOptions,
            phaseStatusOptions: routeResolver.phaseStatusOptions
        },
        data: {
            pageTitle: 'dashboard_transport',
            permissions: { dashboard_transport__read_all: 0, dashboard_transport__read: 'CUID' },
            dashboardType: 'transport'
        }
    }).state('restricted.dashboard_service', {
        url: '/dashboard/service',
        views: {
            '': {
                templateUrl: getView('dashboard/dashboard_phase'),
                controller: 'DashboardPhaseCtrl',
                controllerAs: 'DashboardPhase'
            }
        },
        resolve: {
            usersOptions: routeResolver.usersOptions,
            groupsOptions: routeResolver.groupsOptions,
            phaseStatusOptions: routeResolver.phaseStatusOptions
        },
        data: {
            pageTitle: 'dashboard_service',
            permissions: { dashboard_service__read_all: 0, dashboard_service__read: 'CUID' },
            dashboardType: 'service'
        }
    })

    // users

    .state('restricted.users', {
        url: '/users',
        views: {
            '': {
                templateUrl: getView('users/users_list'),
                controller: 'UsersListCtrl',
                controllerAs: 'UsersList'
            }
        },
        resolve: {
            usersList: routeResolver.usersList,
            usersListFilter: routeResolver.usersListFilter
        },
        data: {
            pageTitle: 'users',
            permissions: { users__read_all: 0, users__read: 'CUID' }
        }
    }).state('restricted.users_add', {
        url: '/users/add',
        views: {
            '': {
                templateUrl: getView('users/users_edit'),
                controller: 'EditUserCtrl',
                controllerAs: 'EditUser'
            }
        },
        resolve: {
            userStatusOptions: routeResolver.userStatusOptions,
            permissionsList: routeResolver.permissionsList,
            groupsOptions: routeResolver.groupsOptions,
            areasOptions: routeResolver.areasOptions,
            jobsOptions: routeResolver.jobsOptions,
            userData: routeResolver.userData
        },
        data: {
            pageTitle: 'users.add',
            parent: 'restricted.users',
            permissions: { users__write_all: 0, users__write: 'CUID' }
        }
    }).state('restricted.users_edit', {
        url: '/users/edit/:id',
        views: {
            '': {
                templateUrl: getView('users/users_edit'),
                controller: 'EditUserCtrl',
                controllerAs: 'EditUser'
            }
        },
        resolve: {
            userStatusOptions: routeResolver.userStatusOptions,
            permissionsList: routeResolver.permissionsList,
            groupsOptions: routeResolver.groupsOptions,
            areasOptions: routeResolver.areasOptions,
            jobsOptions: routeResolver.jobsOptions,
            userData: routeResolver.userData
        },
        data: {
            pageTitle: 'users.edit',
            parent: 'restricted.users'
        }
    }).state('restricted.users_mass', {
        url: '/users/mass-edit',
        views: {
            '': {
                templateUrl: getView('users/users_mass_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'users.mass_edit',
            parent: 'restricted.users'
        }
    })

    // profile

    .state('restricted.profile', {
        url: '/profile',
        views: {
            '': {
                templateUrl: getView('users/profile')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'users.profile',
            parent: 'restricted.users'
        }
    })

    // groups

    .state('restricted.groups', {
        url: '/groups',
        views: {
            '': {
                templateUrl: getView('groups/groups_list'),
                controller: 'GroupsListCtrl',
                controllerAs: 'GroupsList'
            }
        },
        resolve: {
            usersOptions: routeResolver.usersOptions
        },
        data: {
            pageTitle: 'groups'
        }
    })

    // dictionaries

    .state('restricted.dictionaries', {
        url: '/dictionaries',
        views: {
            '': {
                templateUrl: getView('dictionaries/dictionaries_list')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'dictionaries'
        }
    })

    // attachments

    .state('restricted.attachments', {
        url: '/attachments',
        views: {
            '': {
                templateUrl: getView('attachments/attachments_list')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'attachments'
        }
    })

    // clients

    .state('restricted.clients', {
        url: '/clients',
        views: {
            '': {
                templateUrl: getView('clients/clients_list'),
                controller: 'ClientsCtrl',
                controllerAs: 'Clients'
            }
        },
        params: {
            filter: {}
        },
        resolve: {
            clientsList: routeResolver.clientsList,
            clientsListFilter: routeResolver.clientsListFilter
        },
        data: {
            pageTitle: 'clients'
        }
    }).state('restricted.clients_add', {
        url: '/clients/add',
        views: {
            '': {
                templateUrl: getView('clients/clients_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'clients.add',
            parent: 'restricted.clients'
        }
    }).state('restricted.clients_edit', {
        url: '/clients/edit/:id',
        views: {
            '': {
                templateUrl: getView('clients/clients_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'clients.edit',
            parent: 'restricted.clients'
        }
    }).state('restricted.investments', {
        url: '/clients/investments',
        views: {
            '': {
                templateUrl: getView('clients/client_investments')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'investments',
            parent: 'restricted.clients'
        }
    })

    // intrests

    .state('restricted.interests', {
        url: '/interests',
        views: {
            '': {
                templateUrl: getView('interests/interests_list'),
                controller: 'InterestsCtrl',
                controllerAs: 'Interests'
            }
        },
        params: {
            filter: {}
        },
        resolve: {
            interestsListFilter: routeResolver.interestsListFilter,
            interestsList: routeResolver.interestsList
        },
        data: {
            pageTitle: 'interests'
        }
    }).state('restricted.interests_add', {
        url: '/interests/add',
        views: {
            '': {
                templateUrl: getView('interests/interests_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'interests.add',
            parent: 'restricted.interests'
        },
        params: {
            task: null,
            client: null,
            project: null
        }
    }).state('restricted.interests_edit', {
        url: '/interests/edit/:id',
        views: {
            '': {
                templateUrl: getView('interests/interests_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'interests.edit',
            parent: 'restricted.interests'
        }
    })

    // tasks

    .state('restricted.tasks', {
        url: '/tasks',
        views: {
            '': {
                templateUrl: getView('tasks/tasks_list'),
                controller: 'TasksCtrl',
                controllerAs: 'Tasks'
            }
        },
        params: {
            filter: {}
        },
        resolve: {
            tasksList: routeResolver.tasksList,
            tasksListFilter: routeResolver.tasksListFilter
        },
        data: {
            pageTitle: 'tasks'
        }
    }).state('restricted.tasks_add', {
        url: '/tasks/add',
        views: {
            '': {
                templateUrl: getView('tasks/tasks_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'tasks.add',
            parent: 'restricted.tasks'
        },
        params: {
            client: null,
            interest: null,
            project: null
        }
    }).state('restricted.tasks_edit', {
        url: '/tasks/edit/:id',
        views: {
            '': {
                templateUrl: getView('tasks/tasks_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'tasks.edit',
            parent: 'restricted.tasks'
        }
    })

    // projects

    .state('restricted.projects', {
        url: '/projects',
        views: {
            '': {
                templateUrl: getView('projects/projects_list'),
                controller: 'ProjectsCtrl',
                controllerAs: 'Projects'
            }
        },
        params: {
            filter: {}
        },
        resolve: {
            projectsList: routeResolver.projectsList,
            projectsListFilter: routeResolver.projectsListFilter
        },
        data: {
            pageTitle: 'projects'
        }
    }).state('restricted.projects_add', {
        url: '/projects/add',
        views: {
            '': {
                templateUrl: getView('projects/projects_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'projects.add',
            parent: 'restricted.projects'
        },
        params: {
            type: 'measurement',
            task: null,
            client: null,
            interest: null
        }
    }).state('restricted.projects_edit', {
        url: '/projects/edit/:id',
        views: {
            '': {
                templateUrl: getView('projects/projects_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'projects.edit',
            parent: 'restricted.projects'
        }
    })

    // phases

    .state('restricted.phases', {
        url: '/phases',
        views: {
            '': {
                templateUrl: getView('phases/phases_list'),
                controller: 'PhasesCtrl',
                controllerAs: 'Phases'
            }
        },
        params: {
            filter: {}
        },
        resolve: {
            phasesList: routeResolver.phasesList,
            phasesListFilter: routeResolver.phasesListFilter
        },
        data: {
            pageTitle: 'phases'
        }
    }).state('restricted.phases_add', {
        url: '/phases/add/:pid',
        views: {
            '': {
                templateUrl: getView('phases/phases_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'phases.add',
            parent: 'restricted.phases'
        },
        params: {
            task: null,
            client: null,
            interest: null,
            project: null
        }
    }).state('restricted.phases_edit', {
        url: '/phases/edit/:id',
        views: {
            '': {
                templateUrl: getView('phases/phases_edit')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'phases.edit',
            parent: 'restricted.phases'
        }
    }).state('restricted.phases_print', {
        url: '/phases/print',
        views: {
            '': {
                templateUrl: getView('phases/phases_print'),
                controller: 'PrintPhasesCtrl',
                controllerAs: 'PrintPhases'
            }
        },
        resolve: {
            usersOptions: routeResolver.usersOptions,
            groupsOptions: routeResolver.groupsOptions
        },
        data: {
            pageTitle: 'phases.print',
            parent: 'restricted.phases'
        }
    }).state('restricted.phases_approval', {
        url: '/phases/approval/:type/:week',
        params: {
            type: {
                value: 'installation'
            },
            week: {
                value: moment().week().toString()
            }
        },
        views: {
            '': {
                templateUrl: getView('phases/phases_approval'),
                controller: 'ApprovePhasesCtrl',
                controllerAs: 'ApprovePhases'
            }
        },
        resolve: {},
        data: {
            pageTitle: 'phases.approvals',
            parent: 'restricted.phases'
        }
    })

    // reports

    .state('restricted.reports_period_summary', {
        url: '/reports/period_summary',
        views: {
            '': {
                templateUrl: getView('reports/reports_period_summary'),
                controller: 'ReportsPeriodSummaryCtrl',
                controllerAs: 'ReportsPeriodSummary'
            }
        },
        resolve: {
            usersOptions: routeResolver.usersOptions,
            groupsOptions: routeResolver.groupsOptions,
            phaseStatusOptions: routeResolver.phaseStatusOptions
        },
        data: {
            pageTitle: 'reports.period_summary',
            parent: 'restricted.reports'
        }
    })

    // areas

    .state('restricted.areas', {
        url: '/areas',
        views: {
            '': {
                templateUrl: getView('areas/areas_list'),
                controller: 'AreasListCtrl',
                controllerAs: 'AreasList'
            }
        },
        resolve: {
            areasList: routeResolver.areasList
        },
        data: {
            pageTitle: 'areas'
        }
    }).state('restricted.areas_add', {
        url: '/areas/add',
        views: {
            '': {
                templateUrl: getView('areas/areas_edit'),
                controller: 'EditAreaCtrl',
                controllerAs: 'EditArea'
            }
        },
        resolve: {
            area: function area() {
                return {
                    id: 0
                };
            },

            allUserOptions: routeResolver.emptyArray,
            allGroupsOptions: routeResolver.emptyArray,
            installationOptions: routeResolver.emptyArray,
            woodworkOptions: routeResolver.emptyArray,
            currencyOptions: routeResolver.emptyArray,
            countryOptions: routeResolver.emptyArray,
            unitOptions: routeResolver.emptyArray,
            interestStatusOptions: routeResolver.emptyArray,
            taskStatusOptions: routeResolver.emptyArray,
            categoryOptions: routeResolver.emptyArray,
            projectStatusOptions: routeResolver.emptyArray,
            phaseStatusOptions: routeResolver.emptyArray
        },
        data: {
            pageTitle: 'areas.add',
            parent: 'restricted.areas'
        },
        params: {}
    }).state('restricted.areas_edit', {
        url: '/areas/edit/:id',
        views: {
            '': {
                templateUrl: getView('areas/areas_edit'),
                controller: 'EditAreaCtrl',
                controllerAs: 'EditArea'
            }
        },
        resolve: {
            area: function area($stateParams, areasService) {
                return areasService.find($stateParams.id);
            },

            allUserOptions: routeResolver.allUserOptions,
            allGroupsOptions: routeResolver.allGroupsOptions,
            installationOptions: routeResolver.installationOptions,
            woodworkOptions: routeResolver.woodworkOptions,
            currencyOptions: routeResolver.currencyOptions,
            countryOptions: routeResolver.countryOptions,
            unitOptions: routeResolver.unitOptions,
            interestStatusOptions: routeResolver.interestStatusOptions,
            taskStatusOptions: routeResolver.taskStatusOptions,
            categoryOptions: routeResolver.categoryOptions,
            projectStatusOptions: routeResolver.projectStatusOptions,
            phaseStatusOptions: routeResolver.phaseStatusOptions
        },
        data: {
            pageTitle: 'areas.edit',
            parent: 'restricted.areas'
        }
    })

    // help

    .state('restricted.help', {
        url: '/help',
        views: {
            '': {
                templateUrl: getView('help/help')
            }
        },
        resolve: {},
        data: {
            pageTitle: 'help'
        }
    });

    // obsługa błędów
    $httpProvider.interceptors.push(function ($q, $sessionStorage) {
        return {
            responseError: function responseError(response) {
                var deferred = $q.defer();

                // 401 unauthorized
                if ('.html' !== response.config.url.substr(-5, 5)) {
                    if (401 === response.status) {
                        delete $sessionStorage.User;
                        deferred.reject(response);
                        window.location.reload();

                        return deferred.promise;
                    }
                }

                deferred.resolve(response);

                return deferred.promise;
            }
        };
    });
});
'use strict';

angular.module('app.config').config(function ($logProvider, app) {
    $logProvider.debugEnabled(app.debug);
});
'use strict';

angular.module('app.factories').factory('PrintToConsole', function ($rootScope, $state, $stateParams, $log, app) {
    var handler = {
        active: app.debug,

        toggle: function toggle() {
            handler.active = !handler.active;
        },
        init: function init() {
            if (handler.active) {
                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    $log.debug('$stateChangeStart --->> event, toState, toParams, fromState, fromParams');
                    $log.debug(event, toState, toParams, fromState, fromParams);
                });
                $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                    $log.debug('$stateChangeError ---!! event, toState, toParams, fromState, fromParams, error');
                    $log.debug(event, toState, toParams, fromState, fromParams, error);
                });
                $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    $log.debug('$stateChangeSuccess ---OK event, toState, toParams, fromState, fromParams');
                    $log.debug(event, toState, toParams, fromState, fromParams);
                });
                $rootScope.$on('$viewContentLoading', function (event, viewConfig) {
                    $log.debug('$viewContentLoading ---~~ event, viewConfig');
                    $log.debug(event, viewConfig);
                });
                $rootScope.$on('$viewContentLoaded', function (event) {
                    $log.debug('$viewContentLoaded ---ok event');
                    $log.debug(event);
                });
                $rootScope.$on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
                    $log.debug('$stateNotFound ---!! event, unfoundState, fromState, fromParams');
                    $log.debug(event, unfoundState, fromState, fromParams);
                });
            }
        }
    };

    return handler;
});
'use strict';

(function () {
    'use strict';

    angular.module('app.directives')
    // page title
    .directive('pageTitle', function ($rootScope, $timeout, $translate) {
        return {
            restrict: 'A',
            link: function link() {
                var listener = function listener(event, toState) {
                    var default_title = 'vPlaner';
                    $timeout(function () {
                        $rootScope.page_title = toState.data && toState.data.pageTitle ? default_title + ' - ' + $translate.instant(toState.data.pageTitle) : $translate.instant(default_title);
                    });
                };
                $rootScope.$on('$stateChangeSuccess', listener);
            }
        };
    })
    // add width/height properities to Image
    .directive('addImageProp', ['$timeout', 'utils', function ($timeout, utils) {
        return {
            restrict: 'A',
            link: function link(scope, elem, attrs) {
                elem.on('load', function () {
                    $timeout(function () {
                        var w = !utils.isHighDensity() ? $(elem).width() : $(elem).width() / 2,
                            h = !utils.isHighDensity() ? $(elem).height() : $(elem).height() / 2;
                        $(elem).attr('width', w).attr('height', h);
                    });
                });
            }
        };
    }])
    // print page
    .directive('printPage', [function () {
        return {
            restrict: 'A',
            link: function link(scope, elem, attrs) {
                var message = attrs['printMessage'];
                $(elem).on('click', function (e) {
                    e.preventDefault();
                    UIkit.modal.confirm(message ? message : 'Do you want to print this page?', function () {
                        // wait for dialog to fully hide
                        setTimeout(function () {
                            window.print();
                        }, 300);
                    }, {
                        labels: {
                            Ok: 'print'
                        }
                    });
                });
            }
        };
    }])
    // full screen
    .directive('fullScreenToggle', [function () {
        return {
            restrict: 'A',
            link: function link(scope, elem, attrs) {
                $(elem).on('click', function (e) {
                    e.preventDefault();
                    screenfull.toggle();
                });
            }
        };
    }])
    // single card
    .directive('singleCard', ['$window', '$timeout', function ($window, $timeout) {
        return {
            restrict: 'A',
            link: function link(scope, elem, attrs) {
                var $md_card_single = $(elem),
                    w = angular.element($window);

                function md_card_content_height() {
                    var content_height = w.height() - (48 * 2 + 12);
                    $md_card_single.find('.md-card-content').innerHeight(content_height);
                }

                $timeout(function () {
                    md_card_content_height();
                }, 100);

                w.on('resize', function (e) {
                    // Reset timeout
                    $timeout.cancel(scope.resizingTimer);
                    // Add a timeout to not call the resizing function every pixel
                    scope.resizingTimer = $timeout(function () {
                        md_card_content_height();
                        return scope.$apply();
                    }, 280);
                });
            }
        };
    }])
    // outside list
    .directive('listOutside', ['$window', '$timeout', function ($window, $timeout) {
        return {
            restrict: 'A',
            link: function link(scope, elem, attr) {
                var $md_list_outside_wrapper = $(elem),
                    w = angular.element($window);

                function md_list_outside_height() {
                    var content_height = w.height() - (48 * 2 + 10);
                    $md_list_outside_wrapper.height(content_height);
                }

                md_list_outside_height();

                w.on('resize', function (e) {
                    // Reset timeout
                    $timeout.cancel(scope.resizingTimer);
                    // Add a timeout to not call the resizing function every pixel
                    scope.resizingTimer = $timeout(function () {
                        md_list_outside_height();
                        return scope.$apply();
                    }, 280);
                });
            }
        };
    }])
    // callback on last element in ng-repeat
    .directive('onLastRepeat', function ($timeout) {
        return function (scope, element, attrs) {
            if (scope.$last) {
                $timeout(function () {
                    scope.$emit('onLastRepeat', element, attrs);
                });
            }
        };
    })
    // content sidebar
    .directive('contentSidebar', ['$rootScope', '$document', function ($rootScope, $document) {
        return {
            restrict: 'A',
            link: function link(scope, el, attr) {
                if (!$rootScope.header_double_height) {
                    $rootScope.$watch('hide_content_sidebar', function () {
                        if ($rootScope.hide_content_sidebar) {
                            $('#page_content').css('max-height', $('html').height() - 40);
                            $('html').css({
                                paddingRight: scrollbarWidth(),
                                overflow: 'hidden'
                            });
                        } else {
                            $('#page_content').css('max-height', '');
                            $('html').css({
                                paddingRight: '',
                                overflow: ''
                            });
                        }
                    });
                }
            }
        };
    }])
    // attach events to document
    .directive('documentEvents', ['$rootScope', '$window', '$timeout', 'variables', function ($rootScope, $window, $timeout, variables) {
        return {
            restrict: 'A',
            link: function link(scope, el, attr) {
                var hidePrimarySidebar = function hidePrimarySidebar() {
                    $rootScope.primarySidebarActive = false;
                    $rootScope.primarySidebarOpen = false;
                    $rootScope.hide_content_sidebar = false;
                    $rootScope.primarySidebarHiding = true;
                    $timeout(function () {
                        $rootScope.primarySidebarHiding = false;
                    }, 280);
                };

                var hideSecondarySidebar = function hideSecondarySidebar() {
                    $rootScope.secondarySidebarActive = false;
                };

                var hideMainSearch = function hideMainSearch() {
                    var $header_main = $('#header_main');
                    $header_main.children('.header_main_search_form').velocity('transition.slideUpBigOut', {
                        duration: 280,
                        easing: variables.easing_swiftOut,
                        begin: function begin() {
                            $header_main.velocity('reverse');
                            $rootScope.mainSearchActive = false;
                        },
                        complete: function complete() {
                            $header_main.children('.header_main_content').velocity('transition.slideDownBigIn', {
                                duration: 280,
                                easing: variables.easing_swiftOut,
                                complete: function complete() {
                                    $('.header_main_search_input').blur().val('');
                                }
                            });
                        }
                    });
                };

                // hide components on $document click
                scope.onClick = function ($event) {
                    // primary sidebar
                    if ($rootScope.primarySidebarActive && !$($event.target).closest('#sidebar_main').length && !$($event.target).closest('#sSwitch_primary').length && !$rootScope.largeScreen) {
                        hidePrimarySidebar();
                    }
                    // secondary sidebar
                    if ($rootScope.secondarySidebarActive && !$($event.target).closest('#sidebar_secondary').length && !$($event.target).closest('#sSwitch_secondary').length) {
                        hideSecondarySidebar();
                    }
                    // main search form
                    if ($rootScope.mainSearchActive && !$($event.target).closest('.header_main_search_form').length && !$($event.target).closest('#main_search_btn').length) {
                        hideMainSearch();
                    }
                    // style switcher
                    if ($rootScope.styleSwitcherActive && !$($event.target).closest('#style_switcher').length) {
                        $rootScope.styleSwitcherActive = false;
                    }
                };

                // hide components on key press (esc)
                scope.onKeyUp = function ($event) {
                    // primary sidebar
                    if ($rootScope.primarySidebarActive && !$rootScope.largeScreen && $event.keyCode == 27) {
                        hidePrimarySidebar();
                    }
                    // secondary sidebar
                    if ($rootScope.secondarySidebarActive && $event.keyCode == 27) {
                        hideSecondarySidebar();
                    }
                    // main search form
                    if ($rootScope.mainSearchActive && $event.keyCode == 27) {
                        hideMainSearch();
                    }
                    // style switcher
                    if ($rootScope.styleSwitcherActive && $event.keyCode == 27) {
                        $rootScope.styleSwitcherActive = false;
                    }
                };
            }
        };
    }])
    // main search show
    .directive('mainSearchShow', ['$rootScope', '$window', '$timeout', function ($rootScope, $window, variables) {
        return {
            restrict: 'E',
            template: '<a href="#" id="main_search_btn" class="user_action_icon" ng-click="showSearch($event)"><i class="material-icons md-24 md-light">&#xE8B6;</i></a>',
            replace: true,
            scope: true,
            link: function link(scope, el, attr) {
                scope.showSearch = function ($event) {
                    $event.preventDefault();

                    $('#header_main').children('.header_main_content').velocity('transition.slideUpBigOut', {
                        duration: 280,
                        easing: variables.easing_swiftOut,
                        begin: function begin() {
                            $rootScope.mainSearchActive = true;
                        },
                        complete: function complete() {
                            $('#header_main').children('.header_main_search_form').velocity('transition.slideDownBigIn', {
                                duration: 280,
                                easing: variables.easing_swiftOut,
                                complete: function complete() {
                                    $('.header_main_search_input').focus();
                                }
                            });
                        }
                    });
                };
            }
        };
    }])
    // main search hide
    .directive('mainSearchHide', ['$rootScope', '$window', 'variables', function ($rootScope, $window, variables) {
        return {
            restrict: 'E',
            template: '<i class="md-icon header_main_search_close material-icons" ng-click="hideSearch($event)">&#xE5CD;</i>',
            replace: true,
            scope: true,
            link: function link(scope, el, attr) {
                scope.hideSearch = function ($event) {
                    $event.preventDefault();

                    var $header_main = $('#header_main');

                    $header_main.children('.header_main_search_form').velocity('transition.slideUpBigOut', {
                        duration: 280,
                        easing: variables.easing_swiftOut,
                        begin: function begin() {
                            $header_main.velocity('reverse');
                            $rootScope.mainSearchActive = false;
                        },
                        complete: function complete() {
                            $header_main.children('.header_main_content').velocity('transition.slideDownBigIn', {
                                duration: 280,
                                easing: variables.easing_swiftOut,
                                complete: function complete() {
                                    $('.header_main_search_input').blur().val('');
                                }
                            });
                        }
                    });
                };
            }
        };
    }])

    // primary sidebar
    .directive('sidebarPrimary', ['$rootScope', '$window', '$timeout', 'variables', function ($rootScope, $window, $timeout, variables) {
        return {
            restrict: 'A',
            link: function link(scope, el, attr) {
                scope.submenuToggle = function ($event) {
                    $event.preventDefault();

                    var $this = $($event.currentTarget),
                        $sidebar_main = $('#sidebar_main'),
                        slideToogle = $this.next('ul').is(':visible') ? 'slideUp' : 'slideDown';

                    $this.next('ul').velocity(slideToogle, {
                        duration: 400,
                        easing: variables.easing_swiftOut,
                        begin: function begin() {
                            if (slideToogle == 'slideUp') {
                                $(this).closest('.submenu_trigger').removeClass('act_section');
                            } else {
                                $(this).closest('.submenu_trigger').addClass('act_section');
                            }
                        },
                        complete: function complete() {
                            if (slideToogle !== 'slideUp') {
                                var scrollContainer = $sidebar_main.find('.scroll-content').length ? $sidebar_main.find('.scroll-content') : $sidebar_main.find('.scrollbar-inner');
                                $this.closest('.act_section').velocity('scroll', {
                                    duration: 500,
                                    easing: variables.easing_swiftOut,
                                    container: scrollContainer
                                });
                            }
                        }
                    });
                };
            }
        };
    }])
    // toggle primary sidebar
    .directive('sidebarPrimaryToggle', ['$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template: '<a id="sSwitch_primary" href="#" ng-click="togglePrimarySidebar($event)" ng-hide="miniSidebarActive || topMenuActive" style="line-height: 48px; float: left; margin-right: 15px;"><span class="material-icons md-color-white md-24">menu</span></a>',
            link: function link(scope, el, attrs) {
                scope.togglePrimarySidebar = function ($event) {
                    $event.preventDefault();

                    if ($rootScope.primarySidebarActive) {
                        $rootScope.primarySidebarHiding = true;
                        if ($rootScope.largeScreen) {
                            $timeout(function () {
                                $rootScope.primarySidebarHiding = false;
                                $(window).resize();
                            }, 280);
                        }
                    } else {
                        if ($rootScope.largeScreen) {
                            $timeout(function () {
                                $(window).resize();
                            });
                        }
                    }

                    $rootScope.primarySidebarActive = !$rootScope.primarySidebarActive;

                    if (!$rootScope.largeScreen) {
                        $rootScope.hide_content_sidebar = $rootScope.primarySidebarActive ? true : false;
                    }

                    if ($rootScope.primarySidebarOpen) {
                        $rootScope.primarySidebarOpen = false;
                        $rootScope.primarySidebarActive = false;
                    }
                };
            }
        };
    }])
    // secondary sidebar
    .directive('sidebarSecondary', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
        return {
            restrict: 'A',
            link: function link(scope, el, attrs) {
                $rootScope.sidebar_secondary = true;
                if (attrs.toggleHidden == 'large') {
                    $rootScope.secondarySidebarHiddenLarge = true;
                }
            }
        };
    }])
    // toggle secondary sidebar
    .directive('sidebarSecondaryToggle', ['$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
        return {
            restrict: 'E',
            replace: true,
            template: '<a href="#" id="sSwitch_secondary" class="sSwitch sSwitch_right" ng-show="sidebar_secondary" ng-click="toggleSecondarySidebar($event)"><span class="sSwitchIcon"></span></a>',
            link: function link(scope, el, attrs) {
                scope.toggleSecondarySidebar = function ($event) {
                    $event.preventDefault();
                    $rootScope.secondarySidebarActive = !$rootScope.secondarySidebarActive;
                };
            }
        };
    }])
    // activate card fullscreen
    .directive('cardFullscreenActivate', ['$rootScope', 'variables', function ($rootScope, variables) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template: '<i class="md-icon material-icons md-card-fullscreen-activate" ng-click="cardFullscreenActivate($event)">&#xE5D0;</i>',
            link: function link(scope, el, attrs) {
                scope.cardFullscreenActivate = function ($event) {
                    $event.preventDefault();

                    var $thisCard = $(el).closest('.md-card'),
                        mdCard_h = $thisCard.height(),
                        mdCard_w = $thisCard.width();

                    // create placeholder for card
                    $thisCard.after('<div class="md-card-placeholder" style="width:' + mdCard_w + 'px;height:' + mdCard_h + 'px;"/>');
                    // add overflow hidden to #page_content (fix for ios)
                    //$body.addClass('md-card-fullscreen-active');
                    // add width/height to card (preserve original size)
                    $thisCard.addClass('md-card-fullscreen').css({
                        width: mdCard_w,
                        height: mdCard_h
                    })
                    // animate card to top/left position
                    .velocity({
                        left: 0,
                        top: 0
                    }, {
                        duration: 600,
                        easing: variables.easing_swiftOut,
                        begin: function begin(elements) {
                            $rootScope.card_fullscreen = true;
                            $rootScope.hide_content_sidebar = true;
                            // add back button
                            //$thisCard.find('.md-card-toolbar').prepend('<span class="md-icon md-card-fullscreen-deactivate material-icons uk-float-left">&#xE5C4;</span>');
                            //altair_page_content.hide_content_sidebar();
                        }
                    })
                    // resize card to full width/height
                    .velocity({
                        height: '100%',
                        width: '100%'
                    }, {
                        duration: 600,
                        easing: variables.easing_swiftOut,
                        complete: function complete(elements) {
                            // activate onResize callback for some js plugins
                            //$(window).resize();
                            // show fullscreen content
                            $thisCard.find('.md-card-fullscreen-content').velocity('transition.slideUpBigIn', {
                                duration: 600,
                                easing: variables.easing_swiftOut,
                                complete: function complete(elements) {
                                    // activate onResize callback for some js plugins
                                    $(window).resize();
                                }
                            });
                        }
                    });
                };
            }
        };
    }])
    // deactivate card fullscreen
    .directive('cardFullscreenDeactivate', ['$rootScope', '$window', 'variables', function ($rootScope, $window, variables) {
        return {
            restrict: 'E',
            replace: true,
            template: '<span class="md-icon md-card-fullscreen-deactivate material-icons uk-float-left" ng-show="card_fullscreen" ng-click="cardFullscreenDeactivate($event)">&#xE5C4;</span>',
            link: function link(scope, el, attrs) {
                scope.cardFullscreenDeactivate = function ($event) {
                    $event.preventDefault();

                    // get card placeholder width/height and offset
                    var $thisPlaceholderCard = $('.md-card-placeholder'),
                        mdPlaceholderCard_h = $thisPlaceholderCard.height(),
                        mdPlaceholderCard_w = $thisPlaceholderCard.width(),
                        mdPlaceholderCard_offset_top = $thisPlaceholderCard.offset().top,
                        mdPlaceholderCard_offset_left = $thisPlaceholderCard.offset().left,
                        $thisCard = $('.md-card-fullscreen');

                    $thisCard
                    // resize card to original size
                    .velocity({
                        height: mdPlaceholderCard_h,
                        width: mdPlaceholderCard_w
                    }, {
                        duration: 600,
                        easing: variables.easing_swiftOut,
                        begin: function begin(elements) {
                            // hide fullscreen content
                            $thisCard.find('.md-card-fullscreen-content').velocity('transition.slideDownOut', {
                                duration: 280,
                                easing: variables.easing_swiftOut
                            });
                            $rootScope.card_fullscreen = false;
                        },
                        complete: function complete(elements) {
                            $rootScope.hide_content_sidebar = false;
                        }
                    })
                    // move card to original position
                    .velocity({
                        left: mdPlaceholderCard_offset_left,
                        top: mdPlaceholderCard_offset_top
                    }, {
                        duration: 600,
                        easing: variables.easing_swiftOut,
                        complete: function complete(elements) {
                            // remove some styles added by velocity.js
                            $thisCard.removeClass('md-card-fullscreen').css({
                                width: '',
                                height: '',
                                left: '',
                                top: ''
                            });
                            // remove card placeholder
                            $thisPlaceholderCard.remove();
                            $(window).resize();
                        }
                    });
                };
            }
        };
    }])
    // card close
    .directive('cardClose', ['utils', function (utils) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template: '<i class="md-icon material-icons md-card-toggle" ng-click="cardClose($event)">&#xE14C;</i>',
            link: function link(scope, el, attrs) {
                scope.cardClose = function ($event) {
                    $event.preventDefault();

                    var $this = $(el),
                        thisCard = $this.closest('.md-card'),
                        removeCard = function removeCard() {
                        $(thisCard).remove();
                    };

                    utils.card_show_hide(thisCard, undefined, removeCard);
                };
            }
        };
    }])
    // card toggle
    .directive('cardToggle', ['variables', function (variables) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            template: '<i class="md-icon material-icons md-card-toggle" ng-click="cardToggle($event)">&#xE316;</i>',
            link: function link(scope, el, attrs) {
                scope.cardToggle = function ($event) {
                    $event.preventDefault();

                    var $this = $(el),
                        thisCard = $this.closest('.md-card');

                    $(thisCard).toggleClass('md-card-collapsed').children('.md-card-content').slideToggle('280', variables.bez_easing_swiftOut);

                    $this.velocity({
                        scale: 0,
                        opacity: 0.2
                    }, {
                        duration: 280,
                        easing: variables.easing_swiftOut,
                        complete: function complete() {
                            $(thisCard).hasClass('md-card-collapsed') ? $this.html('&#xE313;') : $this.html('&#xE316;');
                            $this.velocity('reverse');
                        }
                    });
                };
            }
        };
    }])
    // card overlay toggle
    .directive('cardOverlayToggle', [function () {
        return {
            restrict: 'E',
            template: '<i class="md-icon material-icons" ng-click="toggleOverlay($event)">&#xE5D4;</i>',
            replace: true,
            scope: true,
            link: function link(scope, el, attrs) {
                if (el.closest('.md-card').hasClass('md-card-overlay-active')) {
                    el.html('&#xE5CD;');
                }

                scope.toggleOverlay = function ($event) {
                    $event.preventDefault();

                    if (!el.closest('.md-card').hasClass('md-card-overlay-active')) {
                        el.html('&#xE5CD;').closest('.md-card').addClass('md-card-overlay-active');
                    } else {
                        el.html('&#xE5D4;').closest('.md-card').removeClass('md-card-overlay-active');
                    }
                };
            }
        };
    }])
    // custom scrollbar
    .directive('customScrollbar', ['$rootScope', function ($rootScope) {
        return {
            restrict: 'A',
            scope: true,
            link: function link(scope, el, attrs) {
                // check if mini sidebar is enabled
                if (attrs['id'] == 'sidebar_main' && $rootScope.miniSidebarActive) {
                    return;
                }

                $(el).wrapInner("<div class='scrollbar-inner'></div>");
                if (Modernizr.touch) {
                    $(el).children('.scrollbar-inner').addClass('touchscroll');
                } else {
                    $(el).children('.scrollbar-inner').scrollbar({
                        disableBodyScroll: true,
                        scrollx: false,
                        duration: 100
                    });
                }
            }
        };
    }])
    // material design inputs
    .directive('mdInput', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            scope: {
                ngModel: '='
            },
            controller: function controller($scope, $element) {
                var $elem = $($element);
                $scope.updateInput = function () {
                    // clear wrapper classes
                    $elem.closest('.md-input-wrapper').removeClass('md-input-wrapper-danger md-input-wrapper-success md-input-wrapper-disabled');

                    if ($elem.hasClass('md-input-danger')) {
                        $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-danger');
                    }
                    if ($elem.hasClass('md-input-success')) {
                        $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-success');
                    }
                    if ($elem.prop('disabled')) {
                        $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-disabled');
                    }
                    if ($elem.val() != '') {
                        $elem.closest('.md-input-wrapper').addClass('md-input-filled');
                    }
                };
            },
            link: function link(scope, elem, attrs) {
                var $elem = $(elem);

                $timeout(function () {
                    if (!$elem.hasClass('md-input-processed')) {
                        if ($elem.prev('label').length) {
                            $elem.prev('label').addBack().wrapAll('<div class="md-input-wrapper"/>');
                        } else if ($elem.siblings('[data-uk-form-password]').length) {
                            $elem.siblings('[data-uk-form-password]').addBack().wrapAll('<div class="md-input-wrapper"/>');
                        } else {
                            $elem.wrap('<div class="md-input-wrapper"/>');
                        }
                        $elem.addClass('md-input-processed').closest('.md-input-wrapper').append('<span class="md-input-bar"/>');
                    }

                    scope.updateInput();
                });

                /* scope.$watch(function () {
                        return elem.attr('class');
                    },
                    function (newValue, oldValue) {
                        if (newValue != oldValue) {
                            scope.updateInput();
                        }
                    }
                ); */

                scope.$watch('ngModel', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        scope.updateInput();
                    }
                });

                $elem.on('focus', function () {
                    $elem.closest('.md-input-wrapper').addClass('md-input-focus');
                }).on('blur', function () {
                    $(this).closest('.md-input-wrapper').removeClass('md-input-focus');
                    if ($(this).val() == '') {
                        $timeout(function () {
                            $(this).closest('.md-input-wrapper').removeClass('md-input-filled');
                        });
                    } else {
                        $timeout(function () {
                            $(this).closest('.md-input-wrapper').addClass('md-input-filled');
                        });
                    }
                });
            }
        };
    }])
    // material design fab speed dial
    .directive('mdFabSpeedDial', ['variables', function (variables) {
        return {
            restrict: 'A',
            scope: true,
            link: function link(scope, elem, attrs) {
                $(elem).append('<i class="material-icons md-fab-action-close" style="display:none">&#xE5CD;</i>').on('click', function (e) {
                    e.preventDefault();

                    var $this = $(this),
                        $this_wrapper = $this.closest('.md-fab-wrapper');

                    if (!$this_wrapper.hasClass('md-fab-active')) {
                        $this_wrapper.addClass('md-fab-active');
                    } else {
                        $this_wrapper.removeClass('md-fab-active');
                    }

                    $this.velocity({
                        scale: 0
                    }, {
                        duration: 140,
                        easing: variables.easing_swiftOut,
                        complete: function complete() {
                            $this.children().toggle();
                            $this.velocity({
                                scale: 1
                            }, {
                                duration: 140,
                                easing: variables.easing_swiftOut
                            });
                        }
                    });
                }).closest('.md-fab-wrapper').find('.md-fab-small').on('click', function () {
                    $(this).closest('.md-fab-wrapper').removeClass('md-fab-active');
                });
            }
        };
    }])
    // material design fab toolbar
    .directive('mdFabToolbar', ['variables', '$document', function (variables, $document) {
        return {
            restrict: 'A',
            scope: true,
            link: function link(scope, elem, attrs) {
                var $fab_toolbar = $(elem);

                $fab_toolbar.children('i').on('click', function (e) {
                    e.preventDefault();

                    var toolbarItems = $fab_toolbar.children('.md-fab-toolbar-actions').children().length;

                    $fab_toolbar.addClass('md-fab-animated');

                    var FAB_padding = !$fab_toolbar.hasClass('md-fab-small') ? 16 : 24,
                        FAB_size = !$fab_toolbar.hasClass('md-fab-small') ? 64 : 44;

                    setTimeout(function () {
                        $fab_toolbar.width(toolbarItems * FAB_size + FAB_padding);
                    }, 140);

                    setTimeout(function () {
                        $fab_toolbar.addClass('md-fab-active');
                    }, 420);
                });

                $($document).on('click scroll', function (e) {
                    if ($fab_toolbar.hasClass('md-fab-active')) {
                        if (!$(e.target).closest($fab_toolbar).length) {
                            $fab_toolbar.css('width', '').removeClass('md-fab-active');

                            setTimeout(function () {
                                $fab_toolbar.removeClass('md-fab-animated');
                            }, 140);
                        }
                    }
                });
            }
        };
    }])
    // material design fab sheet
    .directive('mdFabSheet', ['variables', '$document', function (variables, $document) {
        return {
            restrict: 'A',
            scope: true,
            link: function link(scope, elem, attrs) {
                var $fab_sheet = $(elem);

                $fab_sheet.children('i').on('click', function (e) {
                    e.preventDefault();

                    var sheetItems = $fab_sheet.children('.md-fab-sheet-actions').children('a').length;

                    $fab_sheet.addClass('md-fab-animated');

                    setTimeout(function () {
                        $fab_sheet.width('240px').height(sheetItems * 40 + 8);
                    }, 140);

                    setTimeout(function () {
                        $fab_sheet.addClass('md-fab-active');
                    }, 280);
                });

                $($document).on('click scroll', function (e) {
                    if ($fab_sheet.hasClass('md-fab-active')) {
                        if (!$(e.target).closest($fab_sheet).length) {
                            $fab_sheet.css({
                                height: '',
                                width: ''
                            }).removeClass('md-fab-active');

                            setTimeout(function () {
                                $fab_sheet.removeClass('md-fab-animated');
                            }, 140);
                        }
                    }
                });
            }
        };
    }])
    // hierarchical show
    .directive('hierarchicalShow', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
        return {
            restrict: 'A',
            scope: true,
            link: function link(scope, elem, attrs) {
                var parent_el = $(elem),
                    baseDelay = 60;

                var add_animation = function add_animation(children, length) {
                    children.each(function (index) {
                        $(this).css({
                            '-webkit-animation-delay': index * baseDelay + 'ms',
                            'animation-delay': index * baseDelay + 'ms'
                        });
                    }).end().waypoint({
                        element: elem[0],
                        handler: function handler() {
                            parent_el.addClass('hierarchical_show_inView');
                            setTimeout(function () {
                                parent_el.removeClass('hierarchical_show hierarchical_show_inView fast_animation').children().css({
                                    '-webkit-animation-delay': '',
                                    'animation-delay': ''
                                });
                            }, length * baseDelay + 1200);
                            this.destroy();
                        },
                        context: window,
                        offset: '90%'
                    });
                };

                $rootScope.$watch('pageLoaded', function () {
                    if ($rootScope.pageLoaded) {
                        var children = parent_el.children(),
                            children_length = children.length;

                        $timeout(function () {
                            add_animation(children, children_length);
                        }, 560);
                    }
                });
            }
        };
    }])
    // hierarchical slide in
    .directive('hierarchicalSlide', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
        return {
            restrict: 'A',
            scope: true,
            link: function link(scope, elem, attrs) {
                var $this = $(elem),
                    baseDelay = 100;

                var add_animation = function add_animation(children, context, childrenLength) {
                    children.each(function (index) {
                        $(this).css({
                            '-webkit-animation-delay': index * baseDelay + 'ms',
                            'animation-delay': index * baseDelay + 'ms'
                        });
                    });
                    $this.waypoint({
                        handler: function handler() {
                            $this.addClass('hierarchical_slide_inView');
                            $timeout(function () {
                                $this.removeClass('hierarchical_slide hierarchical_slide_inView');
                                children.css({
                                    '-webkit-animation-delay': '',
                                    'animation-delay': ''
                                });
                            }, childrenLength * baseDelay + 1200);
                            this.destroy();
                        },
                        context: context[0],
                        offset: '90%'
                    });
                };

                $rootScope.$watch('pageLoaded', function () {
                    if ($rootScope.pageLoaded) {
                        var thisChildren = attrs['slideChildren'] ? $this.children(attrs['slideChildren']) : $this.children(),
                            thisContext = attrs['slideContext'] ? $this.closest(attrs['slideContext']) : 'window',
                            thisChildrenLength = thisChildren.length;

                        if (thisChildrenLength >= 1) {
                            $timeout(function () {
                                add_animation(thisChildren, thisContext, thisChildrenLength);
                            }, 560);
                        }
                    }
                });
            }
        };
    }])
    // preloaders
    .directive('mdPreloader', [function () {
        return {
            restrict: 'E',
            scope: {
                width: '=',
                height: '=',
                strokeWidth: '=',
                style: '@?'
            },
            template: '<div class="md-preloader{{style}}"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" ng-attr-height="{{ height }}" ng-attr-width="{{ width }}" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" ng-attr-stroke-width="{{ strokeWidth }}"/></svg></div>',
            link: function link(scope, elem, attr) {
                scope.width = scope.width ? scope.width : 48;
                scope.height = scope.height ? scope.height : 48;
                scope.strokeWidth = scope.strokeWidth ? scope.strokeWidth : 4;

                attr.$observe('warning', function () {
                    scope.style = ' md-preloader-warning';
                });

                attr.$observe('success', function () {
                    scope.style = ' md-preloader-success';
                });

                attr.$observe('danger', function () {
                    scope.style = ' md-preloader-danger';
                });
            }
        };
    }]).directive('preloader', ['$rootScope', 'utils', function ($rootScope, utils) {
        return {
            restrict: 'E',
            scope: {
                width: '=',
                height: '=',
                style: '@?'
            },
            template: '<img src="/img/spinners/{{style}}{{imgDensity}}.gif" alt="" ng-attr-width="{{width}}" ng-attr-height="{{height}}">',
            link: function link(scope, elem, attrs) {
                scope.width = scope.width ? scope.width : 32;
                scope.height = scope.height ? scope.height : 32;
                scope.style = scope.style ? scope.style : 'spinner';
                scope.imgDensity = utils.isHighDensity() ? '@2x' : '';

                attrs.$observe('warning', function () {
                    scope.style = 'spinner_warning';
                });

                attrs.$observe('success', function () {
                    scope.style = 'spinner_success';
                });

                attrs.$observe('danger', function () {
                    scope.style = 'spinner_danger';
                });

                attrs.$observe('small', function () {
                    scope.style = 'spinner_small';
                });

                attrs.$observe('medium', function () {
                    scope.style = 'spinner_medium';
                });

                attrs.$observe('large', function () {
                    scope.style = 'spinner_large';
                });
            }
        };
    }])
    // uikit components
    .directive('ukHtmlEditor', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            link: function link(scope, elem, attrs) {
                $timeout(function () {
                    UIkit.htmleditor(elem[0], {
                        toolbar: '',
                        height: '240'
                    });
                });
            }
        };
    }]).directive('ukNotification', ['$window', function ($window) {
        return {
            restrict: 'A',
            scope: {
                message: '@',
                status: '@?',
                timeout: '@?',
                group: '@?',
                position: '@?',
                callback: '&?'
            },
            link: function link(scope, elem, attrs) {
                var w = angular.element($window),
                    $element = $(elem);

                scope.showNotify = function () {
                    var thisNotify = UIkit.notify({
                        message: scope.message,
                        status: scope.status ? scope.status : '',
                        timeout: scope.timeout ? scope.timeout : 5000,
                        group: scope.group ? scope.group : '',
                        pos: scope.position ? scope.position : 'top-center',
                        onClose: function onClose() {
                            $('body').find('.md-fab-wrapper').css('margin-bottom', '');
                            clearTimeout(thisNotify.timeout);

                            if (scope.callback) {
                                if (angular.isFunction(scope.callback())) {
                                    scope.$apply(scope.callback());
                                } else {
                                    console.log('Callback is not a function');
                                }
                            }
                        }
                    });
                    if (w.width() < 768 && (scope.position == 'bottom-right' || scope.position == 'bottom-left' || scope.position == 'bottom-center') || scope.position == 'bottom-right') {
                        var thisNotify_height = $(thisNotify.element).outerHeight(),
                            spacer = w.width() < 768 ? -6 : 8;
                        $('body').find('.md-fab-wrapper').css('margin-bottom', thisNotify_height + spacer);
                    }
                };

                $element.on('click', function () {
                    if ($('body').find('.uk-notify-message').length) {
                        $('body').find('.uk-notify-message').click();
                        setTimeout(function () {
                            scope.showNotify();
                        }, 450);
                    } else {
                        scope.showNotify();
                    }
                });
            }
        };
    }])
    // magnific popup
    .directive('magnific-popup', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            link: function link(scope, elem, attrs) {}
        };
    }]);
})();
'use strict';

(function () {
    angular.module('app.directives').directive('vpAttr', function () {
        return {
            restrict: 'A',

            link: function link(scope, element, attrs) {
                scope.$watch(function () {
                    return attrs.vpAttr;
                }, function (nv, ov) {
                    if (nv) {
                        var pair = nv.split(':');
                        if (1 < pair.length) {
                            var attributeName = pair.splice(0, 1)[0];
                            var attributeValue = pair.join(':');

                            angular.element(element).attr(attributeName, attributeValue);
                        }
                    }
                });
            }
        };
    });
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.directives').directive('isAllowed', function (UserService) {
    return {
        restrict: 'A',

        link: function link(scope, element, attrs) {
            scope.$watch(attrs.isAllowed, function (isAllowed) {
                var permissions = {};

                // ujednolicony format: {key1: value1, key2: [value2, value3], ...}
                if ('string' === typeof isAllowed) {
                    permissions = {};
                    _.forEach((isAllowed || '').split('|'), function (element) {
                        permissions[element.replace(/\s+/g, '')] = 0;
                    });
                } else if ('object' === (typeof isAllowed === 'undefined' ? 'undefined' : _typeof(isAllowed))) {
                    permissions = isAllowed;
                }

                if (!UserService.isAllowed(permissions, scope.model ? scope.model.area_id : 0)) {
                    element.hide();
                } else {
                    element.show();
                }
            });
        }
    };
});
'use strict';

angular.module('app.directives').directive('isDeleted', function () {
    return {
        restrict: 'E',

        scope: {
            model: '=model'
        },

        controller: function controller($scope) {
            $scope.$watch('model._deleted', function (value) {
                $scope.isDeleted = value;
            });
        },


        template: ['<span ng-class="{\'uk-text-danger\': isDeleted}">', '<em class="material-icons md-24" ng-show="isDeleted">delete</em> &nbsp;', '<ng-transclude></ng-transclude>', '</span>'].join(''),

        transclude: true
    };
});
'use strict';

angular.module('app.factories').factory('DialogService', function ($mdDialog) {
    return {
        fromTemplate: function fromTemplate(template, $scope) {
            var options = {
                templateUrl: './views/dialogs/' + template + '/' + template + '.html'
            };

            if ($scope) {
                options.scope = $scope.$new();
            }

            return $mdDialog.show(options);
        },
        hide: function hide() {
            return $mdDialog.hide();
        },
        alert: function alert(title, content) {
            $mdDialog.show($mdDialog.alert().title(title).content(content).ok('Ok'));
        }
    };
});
'use strict';

angular.module('app.factories').factory('formValidator', function ($translate, notify) {
    return function (formSelector, scope) {
        var fv = {
            scope: scope,
            form: angular.element(formSelector),

            isValid: function isValid(dontClearTabs) {
                if (!dontClearTabs) {
                    jQuery('.uk-tab-error').removeClass('uk-tab-error');
                }

                return this.form.parsley().validate();
            }
        };

        fv.form.parsley().on('form:submit', function () {
            if (!fv.isValid()) {
                notify.danger($translate.instant('fill_all_fields'));
            }

            // zawsze blokujemy wysłanie formularza
            return false;
        }).on('form:validated', function (Parsley) {
            // @todo: refactor
            if (fv.scope.$apply && !fv.scope.$$phase && !fv.scope.$root.$$phase) {
                fv.scope.$apply();
            }

            if (!Parsley.validationResult) {
                notify.danger($translate.instant('fill_all_fields'));

                // zaznacz odp. tab
                var tabId = Parsley.$element.closest('li.uk-tab-content').first().data('tabId');
                if (tabId) {
                    jQuery('li.uk-tab-link[data-tab-id="' + tabId + '"]').addClass('uk-tab-error');
                }
            }
        }).on('field:validated', function (parsleyField) {
            if ($(parsleyField.$element).hasClass('md-input')) {
                // @todo: refactor
                if (fv.scope.$apply && !fv.scope.$$phase && !fv.scope.$root.$$phase) {
                    fv.scope.$apply();
                }
            }
        });

        fv.form.find('[required]').each(function (i, input) {
            var label = jQuery(input).parent().find('label:first');

            // add styles for required labels
            label.addClass('required-input');
        });

        // tabsy
        jQuery('.user_content .uk-tab').each(function (i, tab) {
            jQuery(tab).find('li').each(function (j, li) {
                jQuery(li).addClass('uk-tab-link').attr('data-tab-id', i + ':' + j);
            });
            jQuery('#' + jQuery(tab).attr('id') + '_content').find('li').each(function (j, li) {
                jQuery(li).addClass('uk-tab-content').attr('data-tab-id', i + ':' + j);
            });
        });

        return fv;
    };
});
'use strict';

angular.module('app.factories').factory('selectize', function ($rootScope, $translate, $compile, $templateCache, api, notify) {
    var templates = {
        default: {
            create: false,
            maxItems: 1,
            placeholder: $translate.instant('choose'),
            optgroupField: 'parent_id',
            optgroupValueField: 'id',
            optgroupLabelField: 'title',
            valueField: 'value',
            labelField: 'label',
            searchField: 'label'
        }
    };

    var selectize = {
        createConfig: function createConfig(overrides) {},
        createConfigFromTemplate: function createConfigFromTemplate(templateName, overrides) {
            var config = templates[templateName] || {};

            if (config.include) {
                angular.forEach(config.include, function (templateToInclude) {
                    angular.extend({}, config, templates[templateToInclude] || {});
                });
            }

            return angular.extend({}, config, overrides || {});
        },
        createConfigFromDefault: function createConfigFromDefault(overrides) {
            return this.createConfigFromTemplate('default', overrides);
        },
        createAjaxConfig: function createAjaxConfig(path, overrides) {
            var ajax = {
                valueField: 'id',
                labelField: 'name',
                searchField: 'name',
                load: function load(query, callback) {
                    if (!query.length) {
                        return callback();
                    }

                    $.ajax({
                        url: '/api/1/' + path,
                        type: 'GET',
                        data: {
                            query: query
                        },
                        error: function error() {
                            callback();
                        },
                        success: function success(res) {
                            callback(res.slice(0, 10));
                        }
                    });
                }
            };

            return angular.extend({}, templates.default, ajax, overrides || {});
        },
        initConfig: function initConfig() {
            if ('undefined' !== typeof $rootScope.selectize_config) {
                return false;
            }

            $rootScope.selectize_config = selectize.createConfigFromDefault();

            $rootScope.selectize_config_multi = selectize.createConfigFromDefault({
                maxItems: 999
            });

            $rootScope.selectize_config_client_readonly = selectize.createAjaxConfig('select/clients', {
                searchField: ['name', 'address'],
                render: {
                    option: function option(data, escape) {
                        return '<div>\n\t\t\t\t\t\t\t<span>' + escape(data.name) + '</span><br>\n\t\t\t\t\t\t\t' + (data.address ? '<span class="uk-text-muted uk-text-small">' + escape(data.address) + '</span>' : '') + '\n\t\t\t\t\t\t</div>';
                    }
                },
                persist: false,
                create: false
            });

            $rootScope.selectize_config_client = angular.extend({}, $rootScope.selectize_config_client_readonly, {
                searchField: ['name', 'address'],
                render: {
                    option: function option(data, escape) {
                        return '<div>\n\t\t\t\t\t\t\t<span>' + escape(data.name) + '</span><br>\n\t\t\t\t\t\t\t' + (data.address ? '<span class="uk-text-muted uk-text-small">' + escape(data.address) + '</span>' : '') + '\n\t\t\t\t\t\t</div>';
                    },
                    option_create: function option_create(data, escape) {
                        return '<div class="create">' + $translate.instant('add') + ': &nbsp; <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                    }
                },
                persist: true,
                create: function create(input) {
                    var selectize = this;
                    var newName = input.replace(/^\s+|\s+$/, '');

                    var newClient = {
                        id: -1,
                        name: newName
                    };

                    if (!newClient) {
                        return false;
                    }

                    var container = $('.add-client-form');
                    if (!container.length) {
                        var html = $templateCache.get('/directives/client/quick_add_client.html');
                        var clientScope = $rootScope.$new(true);

                        clientScope.name = input;
                        clientScope.saveClient = function () {
                            clientScope.name = clientScope.name.replace(/^\s+|\s+$/);

                            if (clientScope.name.length < 2) {
                                notify.danger($translate.instant('clients.wrong_name'));
                                return false;
                            }
                            var ClientModel = api('clients');
                            var info = notify.info($translate.instant('saving'));

                            var clientData = {
                                name: clientScope.name,
                                email: clientScope.email,
                                phone: clientScope.phone
                            };

                            notify.global(1);

                            ClientModel.save(0, clientData).then(function (response) {
                                ClientModel.clearCache();

                                info.close();
                                notify.success($translate.instant('saved'));
                                notify.global(0);

                                selectize.updateOption(-1, {
                                    id: response.id,
                                    name: response.name
                                });
                                selectize.trigger('change');
                                UIkit.modal('#quick-add-client').hide();
                            }, function () {
                                selectize.removeOption(-1);
                                selectize.clear();
                                UIkit.modal('#quick-add-client').hide();
                            });
                        };
                        container = $('<div class="add-client-form"/>').html($compile(html)(clientScope));
                        $('body').append(container);
                    }
                    UIkit.modal('#quick-add-client').show();

                    return newClient;
                }
            });

            $rootScope.selectize_config_interests = selectize.createAjaxConfig('select/interests', {
                searchField: ['name', 'client'],
                render: {
                    option: function option(data, escape) {
                        return ['<div>', '<span>', escape(data.name), '</span><br>', '<span class="uk-text-muted uk-text-small">', escape(data.client), '</span>', '</div>'].join('');
                    }
                }
            });

            $rootScope.selectize_config_projects = selectize.createAjaxConfig('select/projects', {
                searchField: ['name', 'client'],
                render: {
                    option: function option(data, escape) {
                        return ['<div>', '<span>', escape(data.symbol), ': ', escape(data.name), '</span><br>', '<span class="uk-text-muted uk-text-small">', escape(data.client), '</span>', '</div>'].join('');
                    }
                }
            });
        }
    };

    return selectize;
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.factories').factory('UserService', function ($rootScope, $sessionStorage, $http, $q, $log, $timeout, $injector, variables) {
    var expireTime = 12 * 3600 * 1000; // 12h

    var now = new Date().getTime();

    var DefaultUser = {
        auth: false,
        data: {},
        permissions: {},
        groups: [],
        expire: 0
    };

    $sessionStorage.$default({
        User: DefaultUser
    });

    if ($sessionStorage.User.auth && $sessionStorage.User.expire > now) {
        $sessionStorage.User.expire = now + expireTime;
    } else {
        $sessionStorage.User = DefaultUser;
    }

    return {
        afterSuccess: function afterSuccess(response, deferred) {
            var changeArea = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            $log.debug('--> Login:afterSuccess', response, 'changeArea = ', changeArea);
            if (response.data && response.data.result) {
                $sessionStorage.User.auth = true;
                $sessionStorage.User.data = response.data.user;
                $sessionStorage.User.permissions = response.data.permissions;
                $sessionStorage.User.groups = response.data.groups;
                $sessionStorage.User.areas = response.data.areas;
                $sessionStorage.User.expire = now + expireTime;

                if (changeArea) {
                    $injector.invoke(function (areasService) {
                        areasService.changeArea(response.data.area_id);
                    });
                }

                this.setupUser();

                deferred.resolve();
            } else {
                $sessionStorage.User = DefaultUser;

                deferred.reject({
                    message: response.data.message
                });
            }
        },
        afterFailure: function afterFailure(response, deferred) {
            $sessionStorage.User = DefaultUser;

            deferred.reject({
                message: 'request_error'
            });
        },
        login: function login(credentials) {
            var deferred = $q.defer();
            var that = this;

            $http({
                method: 'post',
                url: '/api/1/auth',
                data: credentials
            }).then(function (response) {
                that.afterSuccess(response, deferred, true);
            }, function (response) {
                that.afterFailure(response, deferred);
            });

            return deferred.promise;
        },
        checkSessions: function checkSessions() {
            $log.debug('--> Login:checkSessions');
            var deferred = $q.defer();
            var that = this;

            $http({
                method: 'post',
                url: '/api/1/auth/autologin'
            }).then(function (response) {
                that.afterSuccess(response, deferred, true);
            }, function (response) {
                that.afterFailure(response, deferred);
            });

            return deferred.promise;
        },
        refreshData: function refreshData(userData) {
            $log.debug('--> Login:refreshData');
            var deferred = $q.defer();
            var that = this;

            if ('undefined' === typeof userData) {
                $http({
                    method: 'post',
                    url: '/api/1/auth/userdata'
                }).then(function (response) {
                    that.afterSuccess(response, deferred, true);
                }, function (response) {
                    that.afterFailure(response, deferred);
                });

                return deferred.promise;
            } else {
                that.afterSuccess(userData, deferred);
            }
        },
        logout: function logout(callback) {
            $sessionStorage.User.auth = false;
            $sessionStorage.$reset({
                User: DefaultUser
            });

            $timeout(function () {
                $http({
                    method: 'post',
                    url: '/api/1/auth/logout'
                }).then(function () {
                    if ('function' === typeof callback) {
                        callback();
                    }
                });
            }, 250);

            return true;
        },
        isAuthenticated: function isAuthenticated() {
            return $sessionStorage.User.auth || false;
        },
        isAllowed: function isAllowed(permission, modelAreaId) {
            if (!this.isAuthenticated() || 'object' !== _typeof($sessionStorage.User.permissions)) {
                $log.debug('--> Check permissions: not authenticated / bad permissions');
                return false;
            }

            // grupa adminów?
            // @todo: rethink+refactor (security)
            if ($sessionStorage.User.permissions.indexOf('admin_group') || $sessionStorage.User.permissions.indexOf('admin_system')) {
                $log.debug('--> Check permissions: admin');
                return true;
            }

            var isAllowed = false;
            var validArea = 0 === modelAreaId || modelAreaId === $rootScope.$session.area.id;

            _.map(permission, function (validFor, permissionName) {
                // używamy do zastąpienia - current user id
                if ('CUID' === validFor) {
                    validFor = $sessionStorage.User.data.id;
                }

                // występuje takie uprawnienie, np. profile__read
                var keyMatch = $sessionStorage.User.permissions.includes(permissionName);
                // występuje wartość, np. task__write__all:0 lub task__write:[1, 2]
                var valueMatch = 0 == validFor || validFor == $sessionStorage.User.data.id || validFor.length && validFor.includes($sessionStorage.User.data.id);
                // stała
                var isTrue = 'true' === permissionName;

                isAllowed = isAllowed || isTrue || validArea && keyMatch && valueMatch;
            });

            $log.debug('--> Check permissions:', isAllowed, modelAreaId, permission);

            return isAllowed;
        },


        // @TODO: test and rewrite
        getUser: function getUser(forceRefresh) {
            var toRefresh = forceRefresh || false;
            var userObject = angular.extend({}, $sessionStorage.User.data);

            if (toRefresh) {
                $http({
                    method: 'post',
                    url: '/api/1/auth/userdata'
                }).then(function (response) {
                    $sessionStorage.User.data = response.data.user;
                    $sessionStorage.User.permissions = response.data.permissions;
                    $sessionStorage.User.groups = response.data.groups;
                    $sessionStorage.User.areas = response.data.areas;
                    $sessionStorage.User.auth = response.result;

                    $timeout(function () {
                        userObject = angular.extend({}, $sessionStorage.User.data);
                    });
                });
            }

            return userObject;
        },
        getUserGroups: function getUserGroups() {
            return angular.extend([], $sessionStorage.User.groups || []);
        },
        setUser: function setUser(data) {
            $sessionStorage.User.data = data;

            this.setupUser();
        },
        passwordReset: function passwordReset(email) {
            var deferred = $q.defer();

            $http({
                method: 'post',
                url: 'password/email',
                data: { email: email }
            }).then(function (response) {
                if (200 === response.status) {
                    deferred.resolve(response.data);
                } else {
                    deferred.reject(response.data);
                }
            });

            return deferred.promise;
        },
        setupUser: function setupUser(forceSettings) {
            if (!this.isAuthenticated()) {
                return false;
            }

            var settings = angular.extend({}, $sessionStorage.User.data.settings || {}, forceSettings || {});
            $sessionStorage.User.data.settings = settings;

            $rootScope.mainTheme = settings.theme || variables.default_theme;
            $rootScope.highContrastActive = settings.highContrast || variables.default_high_contrast;
            $rootScope.miniSidebarActive = settings.miniSidebar || variables.default_mini_sidebar;
            $rootScope.boxedLayoutActive = settings.boxedLayout || variables.default_boxed_layout;
            $rootScope.userAreaId = $sessionStorage.User.data.area_id;
        }
    };
});
'use strict';

angular.module('app.factories').factory('utils', function () {
    return {
        // Util for finding an object by its 'id' property among an array
        findByItemId: function findByItemId(a, id) {
            for (var i = 0; i < a.length; i++) {
                if (a[i].item_id == id) return a[i];
            }
            return null;
        },


        // serialize form
        serializeObject: function serializeObject(form) {
            var _this = this;

            var o = {};
            var a = form.serializeArray();
            $.each(a, function () {
                if (o[_this.name] !== undefined) {
                    if (!o[_this.name].push) {
                        o[_this.name] = [o[_this.name]];
                    }
                    o[_this.name].push(_this.value || '');
                } else {
                    o[_this.name] = _this.value || '';
                }
            });
            return o;
        },


        // high density test
        isHighDensity: function isHighDensity() {
            return window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
        },


        // touch device test
        isTouchDevice: function isTouchDevice() {
            return !!('ontouchstart' in window);
        },


        // local storage test
        lsTest: function lsTest() {
            var test = 'test';
            try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                return true;
            } catch (e) {
                return false;
            }
        },


        // show/hide card
        card_show_hide: function card_show_hide(card, begin_callback, complete_callback, callback_element) {
            $(card).velocity({
                scale: 0,
                opacity: 0.2
            }, {
                duration: 400,
                easing: [0.4, 0, 0.2, 1],
                // on begin callback
                begin: function begin() {
                    if (typeof begin_callback !== 'undefined') {
                        begin_callback(callback_element);
                    }
                },

                // on complete callback
                complete: function complete() {
                    if (typeof complete_callback !== 'undefined') {
                        complete_callback(callback_element);
                    }
                }
            }).velocity('reverse');
        }
    };
});
'use strict';

angular.module('app.factories').factory('windowDimensions', function ($window) {
    return {
        height: function height() {
            return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        },
        width: function width() {
            return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        }
    };
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.filters').filter('count', function () {
    return function (items) {
        if (null === items || !items) {
            return 0;
        } else if ('object' === (typeof items === 'undefined' ? 'undefined' : _typeof(items))) {
            return Object.keys(items).length;
        } else if ('undefined' !== typeof items) {
            return items.length || 0;
        }

        return 0;
    };
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.filters').filter('exists', function () {
    return function (haystack, needle, castTo, notEmpty) {
        switch (castTo) {
            case 'string':
                needle = needle.toString();
                break;
            case 'int':
                needle = parseInt(needle);
                break;
        }

        if (!haystack) {
            return false;
        } else if ('string' === typeof haystack) {
            return haystack.includes(needle);
        } else if (_.isArray(haystack)) {
            var pos = haystack.indexOf(needle);
            return -1 !== pos ? notEmpty ? haystack[pos] : true : false;
        } else if ('object' === (typeof haystack === 'undefined' ? 'undefined' : _typeof(haystack))) {
            return 'undefined' !== typeof haystack[needle] ? notEmpty ? haystack[needle] : true : false;
        }

        return false;
    };
});
'use strict';

angular.module('app.filters').filter('getById', function () {
    return function (items, id, key, newValue) {
        var found = null;
        var insert = 'undefined' !== typeof newValue;
        key = key || 'id';

        angular.forEach(items, function (item, i) {
            if (id == item[key]) {
                if (insert) {
                    items[i] = angular.copy(newValue);
                }

                found = angular.copy(item);
            }
        });

        if (insert && null === found) {
            items.push(newValue);
            found = angular.copy(newValue);
        }

        return found;
    };
});
'use strict';

angular.module('app.filters').filter('initials', function () {
    return function (x) {
        if (x) {
            return x.split(' ').map(function (s) {
                return s.charAt(0);
            }).join('');
        } else {
            return null;
        }
    };
});
'use strict';

angular.module('app.filters').filter('max', function () {
    return function (items) {
        if (items && items.length) {
            var max = items[0];
            for (var i = 1; i < items.length; ++i) {
                if (max < items[i]) {
                    max = items[i];
                }
            }
            return max;
        }

        return 0;
    };
});
'use strict';

angular.module('app.filters').filter('merge', function ($timeout) {
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var result = {};

        angular.forEach(args, function (obj) {
            angular.extend(result, obj);
        });

        return result;
    };
});
'use strict';

angular.module('app.filters').filter('min', function () {
    return function (items) {
        if (items && items.length) {
            var min = items[0];
            for (var i = 1; i < items.length; ++i) {
                if (min > items[i]) {
                    min = items[i];
                }
            }
            return min;
        }

        return 0;
    };
});
'use strict';

angular.module('app.filters').filter('money', function () {
    return function (amount) {
        return Math.round(amount).toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
});
'use strict';

angular.module('app.filters').filter('paginate', function () {
    return function (items, page, perPage) {
        var start = (page - 1) * perPage;
        var end = page * perPage;

        return items.slice(start, end);
    };
});
'use strict';

angular.module('app.filters').filter('parseKey', function () {
    return function (model, key) {
        var parts = (key || '').split('.');
        var target = angular.copy(model);
        var found = false;

        for (var i = 0; i < parts.length; ++i) {
            if (target && 'undefined' !== typeof target[parts[i]]) {
                target = target[parts[i]];
                found = true;
            }
        }

        return found ? target : key;
    };
});
'use strict';

angular.module('app.filters').filter('photo', function () {
    return function (type, id, photo, size, refresh) {
        type = type || 'default';
        size = size || 'sm';
        refresh = refresh || false;

        switch (type) {
            case 'client':
                if (0 < photo) {
                    return '/img/uploaded/clients/' + id + '-' + size + '.png' + (refresh ? '?' + new Date().getTime() : '');
                } else {
                    return '/img/avatars/user-alt.png' + (refresh ? '?' + new Date().getTime() : '');
                }

            case 'user':
                if (0 < photo) {
                    return '/img/uploaded/users/' + id + '-' + size + '.png' + (refresh ? '?' + new Date().getTime() : '');
                } else {
                    return '/img/avatars/user-alt.png' + (refresh ? '?' + new Date().getTime() : '');
                }
        }

        return '/img/avatars/avatar_01_tn.png';
    };
});
'use strict';

angular.module('app.filters').filter('reverse', function () {
  return function (items) {
    return items.slice().reverse();
  };
});
'use strict';

angular.module('app.filters').filter('trustHtml', function ($sce) {
  return function (html) {
    return $sce.trustAsHtml(html);
  };
});
'use strict';

angular.module('app.filters').filter('ucfirst', function () {
    return function (input) {
        if (!input) {
            return null;
        }
        return input.substring(0, 1).toUpperCase() + input.substring(1);
    };
});
'use strict';

var language = {
    // common
    'app': 'Aplikacja',
    'request_error': 'Wystąpił błąd - spróbuj ponownie',
    'request_error_refresh': 'Wystąpił błąd - odśwież stronę, by spróbować ponownie',
    'version': 'Wersja',
    'dev_mode': 'Tryb Deweloperski',
    'yes': 'Tak',
    'no': 'Nie',
    'turned_on': 'włączony',
    'turned_off': 'wyłączony',
    'nd': 'n/d',
    'back': 'Powrót',
    'forward': 'Dalej',
    'none': 'Brak',
    'email': 'E-Mail',
    'password': 'Hasło',
    'preview': 'Podgląd',
    'search': 'Szukaj',
    'search_in': 'Szukaj w',
    'refresh': 'Odśwież',
    'add': 'Dodaj',
    'adding': 'Trwa dodawanie...',
    'added': 'Dodano',
    'edit': 'Edytuj',
    'sure_to_remove': 'Czy na pewno chcesz usunąć ten element?',
    'remove': 'Usuń',
    'removing': 'Trwa usuwanie...',
    'removed': 'Usunięto',
    'removed_element': 'Uwaga, ten element jest usunięty i zablokowany do dalszej edycji. Możesz go jednak przywrócić.',
    'sure_to_restore': 'Czy na pewno chcesz przywrócić ten element?',
    'restore': 'Przywróć',
    'restoring': 'Trwa przywracanie...',
    'restored': 'Przywrócono',
    'save': 'Zapisz',
    'saving': 'Trwa zapisywanie...',
    'saved': 'Zapisano',
    'send': 'Wyślij',
    'sending': 'Wysyłanie...',
    'sent': 'Wysłano',
    'change': 'Zmień',
    'changing': 'Trwa zmienianie...',
    'changed': 'Zmieniono',
    'load': 'Wczytaj',
    'loading': 'Wczytywanie...',
    'loading_what': 'Wczytywanie: ',
    'loaded': 'Wczytano',
    'loaded_what': 'Wczytano: ',
    'clear': 'Wyczyść',
    'cleared': 'Wyczyszczono',
    'choose': 'Wybierz',
    'chose': 'Wybrano',
    'open': 'Otwórz',
    'opening': 'Otwieranie',
    'opened': 'Otworzono',
    'close': 'Zamknij',
    'closing': 'Zamykanie',
    'closed': 'Zamyknięto',
    'cancel': 'Anuluj',
    'cancelling': 'Anulowanie',
    'cancelled': 'Anulowano',
    'print_options': 'Opcje wydruku',
    'print': 'Drukuj',
    'print_all': 'Drukuj wszystko',
    'print_with_att': 'Drukuj wraz z załącznikami',
    'as_pdf': 'Pobierz PDF',
    'order_by': 'Sortowanie po',
    'reverse': 'Odwrotnie',
    'all_results': 'Wszystkie',
    'sum': 'Suma',
    'confirm': 'Potwierdź',
    'more': 'Więcej...',
    'get_more_stats': 'Pokaż więcej statystyk',
    'work_in_progress': 'Moduł w trakcie budowy',
    'op_progress': 'Operacja w toku...',
    'op_success': 'Operacja zakończona sukcesem.',
    'op_error': 'Operacja zakończona niepowodzeniem!',
    'description': 'Opis',
    'actions': 'Akcje',
    'fill_all_fields': 'Uzupełnij wszystkie wymagane pola poprawnie.',
    'remember_my_choice': 'Zapamiętaj mój wybór',
    'autosave': 'Autozapis',
    'autosaved': 'Ostatni zapis',
    'new_value': 'Nowa wartość',
    'available_after_save': 'Wybrane akcje dostępne są dopiero po zapisaniu zmian',
    'from': 'od',
    'to': 'do',
    'changes': 'Zmiany',
    'before': 'przed',
    'after': 'po',
    'created_at': 'Czas utworzenia',
    'updated_at': 'Czas zmiany',
    'deleted_at': 'Czas usunięcia',
    'area': 'Obszar',
    'previous_area': 'Poprzedni obszar',
    'area_id': 'Obszar',
    'symbol': 'Kod',
    'amount': 'Liczba',
    'width': 'Szerokość',
    'height': 'Wysokość',
    'depth': 'Długość',

    // pagination
    'pagination.page': 'strona',
    'pagination.from': 'z',
    'pagination.pages': 'stron',
    'pagination.to': 'do',

    // auth
    'auth.sign_in': 'Zaloguj',
    'auth.sign_out': 'Wyloguj',
    'auth.remember_me': 'Zapamiętaj',
    'auth.reset_password': 'Resetuj hasło',
    'auth.reset_password_error': 'Wystąpił błąd. Czy podałeś poprawny email?',
    'auth.reset_password_sent': 'Dalsze instrukcje zostały wysłane na podany adres email. Na ich realizację masz dokładnie jedną godzinę.',
    'auth.reset_password_title': 'VPlaner - Resetowanie hasła do konta',
    'auth.reset_password_bad_token': 'Niepoprawny klucz zmiany hasła. Sprawdź link lub rozpocznij procedurę od początku.',
    'auth.reset_password_expired_token': 'Nieaktualny klucz zmiany hasła. Rozpocznij procedurę od początku.',
    'auth.reset_password_success': 'Hasło zostało poprawnie zresetowane. Twoje nowe hasło to:',
    'auth.signing': 'Trwa logowanie',
    'auth.signin_ok': 'Zalogowano poprawnie, trwa wczytywani aplikacji...',
    'auth.signin_bad_credentials': 'Nieprawidłowe dane',
    'auth.signin_disabled': 'Konto jest zablokowane',
    'auth.signin_too_many_bad_attempts': 'Konto zostało chwilowo zablokowane - zbyt dużo prób logowania się',
    'auth.signin_check_remembered': 'Sprawdzanie zapamiętanych sesji...',
    'auth.no_auth': 'Brak autoryzacji',

    // statuses
    'status.active': 'Aktywny',
    'status.inactive': 'Nieaktywny',
    'status.deleted': 'Usunięty',
    'status.disabled': 'Zablokowany',

    // dashboard
    'dashboard': 'Panel',
    'dashboard.calendars': 'Kalendarze',
    'dashboard.no_data': 'Brak danych',
    'dashboard.task_all': 'Realizacja zadań (cały okres)',
    'dashboard.task_month': 'Realizacja zadań (ostatnie 30 dni)',
    'dashboard.interests_all': 'Realizacja interesów (cały okres)',
    'dashboard.interests_month': 'Realizacja interesów (ostatnie 30 dni)',
    'dashboard.chose_target': 'Wybierz użytkownika, którego dane chcesz zobaczyć',
    'dashboard.chose_crews': 'Wybierz ekipy, których obciążenie chcesz zobaczyć',
    'dashboard.usage': 'Obciążenie (%)',
    'dashboard.time_available': 'Dostępnych minut',
    'dashboard.time_used': 'Zaplanowanych minut',
    'dashboard.time_day': '(dzień)',
    'dashboard.time_week': '(tydzień)',
    'dashboard.time_month': '(miesiąc)',
    'dashboard.main': 'Panel główny',
    'dashboard.stats': 'Statystyki',
    'dashboard.tasks': 'Zadania',
    'dashboard.measurement': 'Pomiary',
    'dashboard.installation': 'Montaż',
    'dashboard.transport': 'Transport',
    'dashboard.service': 'Serwis',

    'dashboard_main': 'Panel główny',
    'dashboard_tasks': 'Kalendarz - zadania',
    'dashboard_measurement': 'Kalendarz - Pomiary',
    'dashboard_installation': 'Kalendarz - Montaż',
    'dashboard_transport': 'Kalendarz - Transport',
    'dashboard_service': 'Kalendarz - Serwis',

    // statusy
    'statuses': 'Statusy',
    'statuses.active': 'Aktywny',
    'statuses.disabled': 'Zablokowany',
    'statuses.deleted': 'Usunięty',

    // users
    'users': 'Użytkownicy',
    'users.list': 'Lista użytkowników',
    'users.add': 'Dodaj użytkownika',
    'users.edit': 'Edytuj użytkownika',
    'users.mass_edit': 'Edytuj masowa',
    'users.mass_action': 'Akcja',
    'users.preview': 'Podgląd danych użytkownika',
    'users.sure_to_delete': 'Czy na pewno chcesz usunąć tego użytkownika?',
    'users.single': 'Pracownik',
    'users.basic': 'Podstawowe',
    'users.groups': 'Grupy',
    'users.permissions': 'Uprawnienia',
    'users.general': 'Dane podstawowe',
    'users.contact': 'Dane kontaktowe',
    'users.email': 'E-Mail',
    'users.password': 'Hasło',
    'users.name': 'Imię',
    'users.surname': 'Nazwisko',
    'users.fullname': 'Imię, Nazwisko',
    'users.stolcad_name': 'Stolcad',
    'users.job_id': 'Stanowisko',
    'users.address': 'Adres',
    'users.alternate_address': 'Adres alternatywny',
    'users.company_phone': 'Tel. służbowy',
    'users.company_cellphone': 'Kom. służbowa',
    'users.private_phone': 'Tel. prywatny',
    'users.skype': 'Skype',
    'users.fax': 'Fax',
    'users.areas': 'Obszary',
    'users.status': 'Status',
    'user_active': 'Aktywny',
    'user_inactive': 'Nieaktywny',
    'user_deleted': 'Usunięty',
    'user_suspended': 'Zawieszony',
    'users.photo': 'Zdjęcie',
    'users.profile': 'Moje konto',
    'users.change_password': 'Zmień hasło',
    'users.new_password': 'Nowe hasło (min. 8 znaków)',
    'users.repeat_new_password': 'Powtórz nowe hasło',
    'users.password_too_easy': 'Wpisane hasło jest zbyt proste!',
    'users.password_doesnt_match': 'Wpisane hasła nie są identyczne!',
    'users.password_changed': 'Hasło zostało zmienione',
    'settings': 'Ustawienia',
    'users.settings': 'Ustawienia',
    'users.settings_colors': 'Kolory',
    'users.settings_high_contrast': 'Wysoki kontrast',
    'users.settings_sidebar': 'Panel boczny',
    'users.settings_sidebar_mini': 'Małe ikony',
    'users.settings_layout': 'Układ strony',
    'users.settings_layout_boxed': 'Stała szerokość',
    'users.remember_to_save': 'Pamiętaj o zapisaniu wprowadzonych zmian.',
    'users.duplicated_email': 'Użytkownik o takim adresie email już istnieje - wybierz inny!',

    // groups
    'groups': 'Grupy',
    'groups.add': 'Dodaj grupę',
    'groups.edit': 'Edytuj grupę',
    'groups.user_description': 'Przypisywanie użytkowników do grup odbywa się w panelu użytkowników (edycja).',
    'groups.name': 'Nazwa grupy',
    'groups.description': 'Opis',
    'groups.author_id': 'Autor',
    'groups.owner_id': 'Zarządca',
    'groups.is_admin': 'Grupa administratorów',
    'groups.status': 'Status',
    'group_active': 'Aktywna',
    'group_inactive': 'Zawieszona',
    'group_disabled': 'Zablokowana',
    'group_deleted': 'Usunięta',

    // dictionaries
    'dictionaries': 'Słowniki',
    'dictionaries.name': 'Nazwa skrócona słownika',
    'dictionaries.description': 'Opis słownika',
    'dictionaries.status': 'Status',
    'dictionaries.key': 'Identyfikator',
    'dictionaries.value': 'Wartość',
    'dictionaries.add_instruction': 'Podaj wartość dla nowej pozycji - lub anuluj operację',
    'dictionaries.list_help': 'Przeciągnij, by zmienić kolejność.',
    'dictionaries.dirty': 'Pamiętaj o zapisaniu zmian.',
    'dictionary_items.key': 'Identyfikator pola słownikowego',
    'dictionary_items.value': 'Wartość pola słownikowego',
    'dictionary_items.order': 'Kolejność',

    // clients
    'clients': 'Baza klientów',
    'clients.list': 'Lista klientów',
    'clients.add': 'Dodaj klienta',
    'clients.edit': 'Edytuj klienta',
    'clients.base_info': 'Dane podstawowe',
    'clients.name': 'Nazwa',
    'clients.nip': 'NIP',
    'clients.other_id': 'Inny nr identyfikujący',
    'clients.author_id': 'Autor wpisu',
    'clients.address_name': 'Adresat',
    'clients.address_city': 'Miasto',
    'clients.address_street': 'Ulica',
    'clients.address_postcode': 'Kod pocztowy',
    'clients.address_country_id': 'Państwo',
    'clients.contact_info': 'Dane kontaktowe',
    'clients.contact_name': 'Adresat',
    'clients.contact_city': 'Miasto',
    'clients.contact_street': 'Ulica',
    'clients.contact_postcode': 'Kod pocztowy',
    'clients.contact_country_id': 'Państwo',
    'clients.email': 'E-Mail',
    'clients.skype': 'Skype',
    'clients.website': 'Strona www',
    'clients.phone': 'Telefon',
    'clients.alternative_phone': 'Telefon(2)',
    'clients.fax': 'Fax',
    'clients.notes': 'Notatki',
    'clients.status': 'Status',
    'clients.photo': 'Zdjęcie',
    'clients.preview': 'Szybki podgląd',
    'clients.are_you_sure': 'Czy na pewno chcesz dodać nowego klienta do bazy?',
    'clients.copy_data': 'Skopiuj z danych klienta',
    'clients.copy_data_empty': 'Brak prawidłowych danych do skopiowania',
    'clients.wrong_name': 'Nazwa klienta powinna być dłuższa!',

    'client_active': 'Aktywny',
    'client_inactive': 'Nieaktywny',
    'client_deleted': 'Usunięty',
    'client_suspended': 'Zawieszony',

    'investments': 'Inwestycje',
    'investments.name': 'Inwestycja',
    'investments.client_id': 'Klient',
    'investments.status': 'Status',
    'investments.description': 'Opis inwestycji',
    'investments.add': 'Dodaj inwestycję',
    'investments.edit': 'Edytuj inwestycję',

    // interests
    'interests': 'Interesy',
    'interests.list': 'Lista interesów',
    'interests.add': 'Dodaj interes',
    'interests.edit': 'Edycja interesu',
    'interests.preview': 'Podgląd interesu',
    'interests.base_info': 'Informacje podstawowe',
    'interests.project_id': 'Zlecenie',
    'interests.related_projects': 'Powiązane zlecenia',
    'interests.relation_type': 'Rodzaj relacji',
    'interests.relation_type_direct': 'Na bazie interesu',
    'interests.relation_type_related': 'Powiązany',
    'interests.symbol_code': 'Symbol globalny',
    'interests.area_code': 'Symbol w obszarze',
    'interests.phase_id': 'Etap',
    'interests.name': 'Nazwa skrócona',
    'interests.client_id': 'Klient',
    'interests.author_id': 'Autor',
    'interests.owner_id': 'Koordynator',
    'interests.manager_id': 'Realizuje',
    'interests.notification_recipients': 'Odbiorcy powiadomień',
    'interests.woodwork_id': 'Stolarka',
    'interests.value': 'Wartość w PLN',
    'interests.currency_id': 'Waluta faktury',
    'interests.estimated': 'Szac. wartość w PLN',
    'interests.notes': 'Notatki',
    'interests.status_id': 'Status',
    'interests.loss_id': 'Powód przegranej',
    'interests.description': 'Opis',

    // tasks
    'tasks': 'Zadania',
    'tasks.list': 'Lista zadań',
    'tasks.add': 'Dodaj zadanie',
    'tasks.edit': 'Edycja zadania',
    'tasks.preview': 'Podgląd zadania',
    'tasks.base_info': 'Dane podstawowe',
    'tasks.about_who': 'Dotyczy',
    'tasks.symbol_code': 'Symbol globalny',
    'tasks.area_code': 'Symbol w obszarze',
    'tasks.name': 'Zadanie',
    'tasks.client_id': 'Klient',
    'tasks.interest_id': 'Interes',
    'tasks.category_id': 'Kategoria',
    'tasks.status_id': 'Status',
    'tasks.author_id': 'Autor',
    'tasks.owner_id': 'Realizuje',
    'tasks.notification_recipients': 'Odbiorcy powiadomień',
    'tasks.date_from': 'Realizacja od',
    'tasks.date_to': 'Realizacja do',
    'tasks.notes': 'Notatki',
    'tasks.color': 'Kolor',
    'tasks.about_choose': 'Wybierz podmiot',

    // reminders
    'reminders': 'Przypomnienia',
    'reminders.reminder': 'Przypomnienie',
    'reminders.task': 'Zadanie',
    'reminders.no_results': 'Brak zdefiniowanych przypomnień dla tego zadania.',
    'reminders.legend': 'Np. aby otrzymywać powiadomienia co 2 dni, należy wybrać odpowiednio: <b>dzień</b>, <b>2</b> oraz zakres dat i godzinę wystąpienia powiadomienia. Można też wskazać dni kalendarzowe (<b>wybrane dni</b>, <b>1,10</b> - każdy 1 i 10 dzień miesiąca).',
    'reminders.add': 'Dodaj przypomnienie',
    'reminders.edit': 'Edytuj przypomnienie',
    'reminders.name': 'Treść',
    'reminders.task_id': 'Dla zadania',
    'reminders.repeat': 'Powtarzaj',
    'reminders.day': 'Dzień',
    'reminders.week': 'Tydzień',
    'reminders.month': 'Miesiąc',
    'reminders.year': 'Rok',
    'reminders.days': 'Wybrane dni miesiąca',
    'reminders.repeat_by': 'Powtarzaj co/w',
    'reminders.start_from': 'Zacznij od',
    'reminders.at_time': 'O godzinie',
    'reminders.until': 'Aż do',
    'reminders.system': 'Wyświetlaj w systemie',
    'reminders.email': 'Wysyłaj na mail',
    'reminders.evaluated_count': 'Pozostało do wysłania',

    // notifications
    'notifications': 'Powiadomienia',
    'notifications.set_as_readed': 'Oznacz jako przeczytana',
    'notifications.set_as_readed_all': 'Oznacz wszystkie jako przeczytane',
    'notifications.readed': 'Przeczytana',
    'notifications.goto': 'Zobacz',
    'notifications.no_desc': 'brak opisu',
    'notifications.create': 'Utworzono',
    'notifications.update': 'Zmieniono',
    'notifications.remove': 'Usunięto',
    'notifications.restore': 'Przywrócono',
    'notifications.info': 'Informacja',

    'notifications.tasks': 'zadanie',
    'notifications.interests': 'interes',
    'notifications.projects': 'zlecenie',
    'notifications.interests_projects': 'powiązane zlecenie',
    'notifications.phases': 'etap',
    'notifications.phases_related': 'powiązany etap',
    'notifications.phase_crews': 'wykonującą ekipę',
    'notifications.phase_woodworks': 'stolarkę',
    'notifications.clients': 'klienta',
    'notifications.users': 'użytkownika',
    'notifications.groups': 'grupę',

    'descriptions.project': '%s <strong>%s</strong> %s dla %s',
    'descriptions.phase': '%s <strong>%s</strong> %s dla %s dnia <strong>%s</strong> o <strong>%s</strong>',
    'descriptions.task': '<strong>%s</strong> %s dla %s dnia <strong>%s</strong>',
    'descriptions.interest': '<strong>%s</strong> %s dla %s',

    // projects
    'projects': 'Zlecenia',
    'projects.list': 'Lista zleceń',
    'projects.add': 'Dodaj zlecenie',
    'projects.edit': 'Edycja zlecenia',
    'projects.show': 'Podgląd zlecenia',
    'projects.preview': 'Podgląd zlecenia',
    'projects.base_info': 'Dane podstawowe zlecenia',
    'projects.phases': 'Etapy',
    'projects.about_who': 'Dotyczy',
    'projects.based_on_interest': 'Zlecenie na bazie interesu:',
    'projects.name': 'Nazwa skrócona',
    'projects.no_name': '(brak nazwy)',
    'projects.project_name': 'Nazwa skrócona zlecenia',
    'projects.symbol': 'Symbol',
    'projects.symbol_code': 'Symbol globalny',
    'projects.area_code': 'Symbol w obszarze',
    'projects.client_id': 'Klient',
    'projects.investment_id': 'Inwestycja',
    'projects.interest_id': 'Interes',
    'projects.related_interests': 'Powiązane interesy',
    'projects.status_id': 'Status',
    'projects.author_id': 'Autor',
    'projects.owner_id': 'Realizuje',
    'projects.notification_recipients': 'Odbiorcy powiadomień',
    'projects.started': 'Realizacja od',
    'projects.notes': 'Notatki',
    'projects.description': 'Notatki',
    'projects.color': 'Kolor',
    'projects.type': 'Rodzaj zlecenia',
    'projects.project': 'Zlecenie',
    'projects.no_project': 'Błąd wczytywania: brak zlecenia',
    'projects.not_all_phases_ready': 'Nie zakończono jeszcze wszystkich etapów zlecenia!',
    'projects.measurement': 'Pomiar',
    'projects.measurement_short': 'P',
    'projects.installation': 'Montaż',
    'projects.installation_short': 'M',
    'projects.transport': 'Transport',
    'projects.transport_short': 'T',
    'projects.service': 'Serwis',
    'projects.service_short': 'S',

    // phases
    'phases': 'Etapy',
    'phases.list': 'Lista etapów',
    'phases.add': 'Dodaj etap',
    'phases.edit': 'Edycja etapu',
    'phases.preview': 'Podgląd etapu',
    'phases.back': 'Powrót',
    'phases.related': 'Powiązane etapy',
    'phases.base_info': 'Dane podstawowe etapu',
    'phases.phases': 'Etapy',
    'phases.about_who': 'Dotyczy',
    'phases.name': 'Nazwa skrócona etapu',
    'phases.client_id': 'Klient',
    'phases.interest_id': 'Interes',
    'phases.category_id': 'Typ',
    'phases.project_id': 'Zlecenie',
    'phases.status_id': 'Status',
    'phases.grade_id': 'Ocena',
    'phases.author_id': 'Autor',
    'phases.owner_id': 'Koordynator',
    'phases.manager_id': 'Realizuje',
    'phases.notification_recipients': 'Odbiorcy powiadomień',
    'phases.date_from': 'Realizacja od',
    'phases.date_from_limit_can_confirm_transport': 'Uwaga! Transport w danym dniu niemożliwy. Wymagana akceptacja przez dział transportu i logistyki.',
    'phases.date_from_limit_can_confirm_installation': 'Uwaga! Montaż w danym dniu niemożliwy. Wymagana akceptacja przez dział montażu.',
    'phases.date_from_limit_needs_confirmation': 'Uwaga! Etap w tym terminie jedynie za akceptacją administratorów:',
    'phases.date_approved': 'Akceptacja',
    'phases.date_to': 'Realizacja do',
    'phases.date_range': 'Realizacja od-do',
    'phases.time_of_service': 'Ustalona godzina usługi',
    'phases.phone': 'Telefon',
    'phases.time_calculated': 'Wyliczony czas realizacji (minuty)',
    'phases.time_needed': 'Szacowany czas realizacji (minuty)',
    'phases.time_recorded': 'Rzeczywisty czas realizacji (minuty)',
    'phases.notes': 'Notatki',
    'phases.description': 'Notatki',
    'phases.color': 'Kolor',
    'phases.type': 'Rodzaj zlecenia',
    'phases.realisation': 'Realizacja',
    'phases.realisation_conditional': 'Warunkowa',
    'phases.realisation_unconditional': 'Bezwarunkowa',
    'phases.symbol': 'Symbol etapu',
    'phases.symbol_code': 'Symbol globalny',
    'phases.area_code': 'Symbol w obszarze',
    'phases.number': 'Numer etapu',
    'phases.stolcad_number': 'Nr Stolcad',
    'phases.crew_id': 'Ekipy',
    'phases.crew_ids': 'Ekipy',
    'phases.show_crew_calendar': 'Pokaż kalendarz',
    'phases.woodwork_id': 'Typ stolarki',
    'phases.woodwork_unit_id': 'Jednostka',
    'phases.woodwork_type_id': 'Typ montażu',
    'phases.woodwork_value': 'Ilość',
    'phases.address': 'Adres odbiorcy',
    'phases.address_delivery': 'Adres dostawy',
    'phases.country_id': 'Kraj usługi',
    'phases.location_id': 'Miasto usługi',
    'phases.value': 'Wartość',
    'phases.value_measurement': 'Koszt pomiaru',
    'phases.value_installation': 'Montaż NETTO',
    'phases.value_installation_gross': 'Montaż BRUTTO',
    'phases.value_transport': 'Koszt transportu',
    'phases.value_service': 'Koszt serwisu',
    'phases.currency_id': 'Waluta',
    'phases.vat_id': 'Stawka VAT',
    'phases.measurement': 'Pomiar',
    'phases.installation': 'Montaż',
    'phases.transport': 'Transport',
    'phases.service': 'Serwis',
    'phases.service_type_id': 'Rodzaj serwisu',
    'phases.service_work_id': 'Prace serwisowe',
    'phases.service_work_value': 'Koszt',
    'phases.service_work_value_sum': 'Suma',
    'phases.service_reason_id': 'Powód uszkodzenia',
    'phases.warranty_reason_id': 'Powód reklamacji',
    'phases.service_work_templates': 'Szablony dodawania prac',
    'phases.transport_type_id': 'Rodzaj transportu',
    'phases.packaging_method_id': 'Sposób pakowania',
    'phases.transport_details': 'Transport',
    'phases.transport_emails': 'E-Mail',
    'phases.transport_email_to': 'Do',
    'phases.transport_email_title': 'Tytuł',
    'phases.transport_email_body': 'Treść',
    'phases.transport_email_save_first': 'Zapisz etap, aby móc wysłać e-mail.',
    'phases.transport_email_to_required': 'Podaj adres odbiorcy (Do).',
    'phases.transport_email_sent_list': 'Wysłane e-maile',
    'phases.transport_email_sent_at': 'Data wysłania',
    'phases.transport_email_sent_by': 'Wysłane przez',
    'phases.transport_email_no_logs': 'Brak wysłanych e-maili dla tego etapu.',
    'phases.transport_email_template_title': 'Informacja o wysyłce i dostawie zamówienia ',
    'phases.transport_email_template_body': 'Uprzejmie informujemy, że wysyłka Państwa zamówienia została zaplanowana.\nPlanowana data dostawy: %date%\nNumer telefonu do kierowcy: %phone%\nNumery zamówienia Stolcad:\n- %stolcad%\n\nW razie pytań lub potrzeby dodatkowych informacji pozostajemy do Państwa dyspozycji.',
    'phases.stands': 'Stojaki',
    'phases.waybill': 'List przewozowy',
    'phases.carrier_id': 'Przewoźnik',
    'phases.carrier_plate': 'Nr Rejestracyjny',
    'phases.dispatched_woodwork': 'Wysłana stolarka',

    'phases.print': 'Wydruki zbiorcze',
    'phases.print_for_day': 'Wydruk dzienny',
    'phases.user_or_crew': 'Ekipa/Pracownik',
    'phases.date': 'Wydruk dla daty',
    'phases.person_from': 'Osoba zlecająca',
    'phases.person_to': 'Osoba przyjmująca zlecenie',
    'phases.default_unit': 'szt.',

    'phases.approvals': 'Akceptacja zleceń',
    'phases.approvals_week': 'Tydzień nr:',
    'phases.approvals_lock': 'Zablokuj',
    'phases.approvals_unlock': 'Odblokuj',
    'phases.approvals_status': 'Status zlecenia',
    'phases.approvals_day_locked': 'Dzień, na który zlecono montaż/transport, jest zablokowany. Nie można już edytować stolarki.',

    // attachments
    'attachments': 'Załączniki',
    'attachments.droparea_message': 'Upuść pliki do przesłania w tym obszarze lub kliknij tutaj:',
    'attachments.choose': 'Wybierz',
    'attachments.uploading': 'Trwa przesyłanie plików...',
    'attachments.uploaded': 'Pliki zostały przesłane.',
    'attachments.download': 'Pobierz',
    'attachments.as_pdf': 'Pobierz jako PDF',
    'attachments.as_csv': 'Pobierz jako CSV',
    'attachments.inline': 'Otwórz w przeglądarce',
    'attachments.file_name': 'Nazwa',
    'attachments.file_ext': 'Rozszerzenie',
    'attachments.file_type': 'Typ',
    'attachments.size': 'Rozmiar',
    'attachments.author': 'Dodał',
    'attachments.created': 'Dodano',
    'attachments.no_results': 'Brak dodanych załączników',
    'attachments.add_after_save': 'Dodawanie załączników możliwe dopiero po zapisaniu aktualnych zmian',

    // areas
    'areas': 'Obszary',
    'areas.list': 'Lista obszarów',
    'areas.add': 'Dodaj obszar',
    'areas.edit': 'Edytuj obszar',
    'areas.move_to': 'Przekaż',
    'areas.move_to_label': 'Przekaż do wskazanego obszaru',
    'areas.move_to_desc': 'Uwaga! Po przekazaniu stracisz możliwość dokonywania wszelkich zmian!',
    'areas.read_only': 'Uwaga! Obiekt przekazany do innego obszaru - obecnie tylko do odczytu!',
    'areas.current_area': 'Obecnie obiekt należy do obszaru',
    'areas.choose_area': 'Wybierz obszar',
    'areas.will_be_moved': 'Obiekt zostanie przekazany do',
    'areas.moved': 'Obiekt został przekazany do wybranego obszaru.',
    'areas.belongs_to': 'Obiekt należy do obszaru',
    'areas.base_info': 'Dane podstawowe',
    'areas.to_default': 'Przywróć domyślną',
    'areas.area_id': 'Obszar',
    'areas.symbol': 'Kod',
    'areas.name': 'Nazwa',
    'areas.description': 'Opis',
    'areas.settings': 'Ustawienia',
    'areas.managers': 'Osoby odpowiedzialne za przydzielanie przekazanych obiektów',
    'areas.no_users': 'Uwaga! Najpierw należy przypisać użytkowników do obszaru.',
    'areas.user_bind_do': 'Uwaga! Użytkownik na stałe będzie przypisany do tego obszaru:',
    'areas.group_bind_do': 'Uwaga! Grupa na stałe będzie przypisana do tego obszaru:',
    'areas.defaults': 'Wartości domyślne',
    'areas.defaults_currency_id': 'Waluta',
    'areas.defaults_country_id': 'Kraj',
    'areas.defaults_unit_piece_id': 'Jednostka',
    'areas.defaults_interest_status_id': 'Status nowego interesu',
    'areas.defaults_interest_win_id': 'Wygrany interes',
    'areas.defaults_interest_loss_id': 'Przegrany interes',
    'areas.defaults_task_status_id': 'Status nowego zadania',
    'areas.defaults_task_unfinished_id': 'Status niedokończonego zadania',
    'areas.defaults_task_category_id': 'Kategoria nowego zadania',
    'areas.defaults_project_status_started': 'Status rozpoczętego zlecenia',
    'areas.defaults_project_status_closed': 'Status zakończonego zlecenia',
    'areas.defaults_phase_status_started': 'Status rozpoczętego etapu',
    'areas.defaults_phase_status_closed': 'Status zakończonego etapu',
    'areas.defaults_crew_id_measurement': 'Ekipa dla pomiaru',
    'areas.defaults_crew_id_installation': 'Ekipa dla montażu',
    'areas.defaults_crew_id_service': 'Ekipa dla serwisu',
    'areas.defaults_crew_id_transport': 'Ekipa dla transportu',
    'areas.defaults_phase_daily_limit_installation': 'Liczba Montaży bez akceptacji na dzień',
    'areas.defaults_phase_daily_limit_transport': 'Liczba Transportów bez akceptacji na dzień',
    'areas.defaults_phase_daily_limit_transport_message': 'Komunikat dot. akceptacji Transportów',
    'areas.defaults_phase_minimum_days_buffer_installation': 'Min. liczba dni kalendarzowych przed dozwoloną datą zlecenia Montażu',
    'areas.defaults_notify_about_complaint': 'Przypomnij o reklamacji po x dniach',
    'areas.calculations': 'Tabele przeliczników',
    'areas.calculations_grid': 'Tabela przeliczników - usługi',
    'areas.calculations_description': 'Podaj przybliżony czas montażu (w minutach).',
    'areas.woodwork_type': 'Typ stolarki',
    'areas.woodwork_unit': 'Jednostka',
    'areas.installations': 'Rodzaj montażu',
    'areas.calculations_workers': 'Tabela przeliczników - pracownicy',
    'areas.workers_description': 'Podaj ilość pracowników oraz ich przybliżony czas pracy (w minutach).',
    'areas.workers_time': 'Dostępny czas pracy pracownika (w minutach).',
    'areas.workers_measurement': 'Ilość pomiarowców',
    'areas.workers_installation': 'Ilość montażystów',
    'areas.workers_transport': 'Ilość kierowców',
    'areas.workers_service': 'Ilość serwisantów',

    // help
    'help': 'Pomoc',
    'help.save_pdf': 'Pobierz instrukcję użytkownika',

    // profil
    'profile': 'Moje konto',

    // header
    'header.clear_cache': 'Wyczyść cache',

    // filter
    'filter': 'Filtr',
    'filter.simple': 'Filtr',
    'filter.quick_search': 'Szybkie wyszukiwanie',
    'filter.name': 'Nazwa filtru:',
    'filter.saved': 'Filtr został zapisany',
    'filter.no_saved': 'Brak zapisanych filtrów',
    'filter.last_used': 'Ostatnio użyty',
    'filter.results': 'Wyników',
    'filter.max_results': 'Ograniczenie wyników',
    'filter.no_results': 'Brak wyników',
    'filter.area_from_any': 'Przekazane Z dowolnego obszaru',
    'filter.area_from_prefix': 'Przekazane Z: ',
    'filter.area_to_any': 'Skierowane DO dowolnego obszaru',
    'filter.area_to_prefix': 'Skierowane DO: ',
    'filter.date_from': 'Od',
    'filter.date_to': 'Do',
    'filter.created_at_from': 'Utworzony od',
    'filter.created_at_to': 'Utworzony do',
    'filter.updated_at_from': 'Modyfikowany od',
    'filter.updated_at_to': 'Modyfikowany do',
    'filter.deleted_at_from': 'Usunięty od',
    'filter.deleted_at_to': 'Usunięty do',
    'filter.with_deleted': 'Usunięte',
    'filter.with_deleted_none': 'Nie pokazuj',
    'filter.with_deleted_also': 'Wraz z innymi',
    'filter.with_deleted_only': 'Tylko usunięte',
    'filter.run': 'Zastosuj',
    'filter.active': 'Filtr aktywny',
    'filter.toggle': 'Pokaż/ukryj filtr',
    'filter.show': 'Pokaż filtr',
    'filter.clear': 'Resetuj',
    'filter.refresh': 'Odśwież filtr',
    'filter.loading': 'Trwa filtrowanie...',
    'filter.global': 'Szukaj wszędzie',
    'filter.global_no_results': 'Brak wyników - spróbuj zastosować inne kryteria wyszukiwania',

    // datatables
    'datatables.show_columns': 'Kolumny',

    // permissions
    'permissions': 'Uprawnienia',
    'permissions.read': 'przeglądanie',
    'permissions.read_all': 'przeglądanie wszystkich',
    'permissions.write': 'uzupełnianie',
    'permissions.write_all': 'uzupełnianie wszystkich',
    'permissions.manage': 'zarządzanie (możliwość usuwania)',
    'permissions.manage_all': 'zarządzanie wszystkimi (możliwość usuwania)',
    'permissions.administrator': 'administrator',
    'permissions.period_summary': 'Raport okresowy',
    'permissions.phases_approval': 'akceptacja zleceń',

    // history
    'history': 'Historia zmian',
    'history.no_results': 'Brak zarejestrowanych zmian',
    'history.author_id': 'Autor zmian',
    'history.default_author': 'System',
    'history.from': 'Przed zmianą',
    'history.to': 'Po zmianie',
    'history.change': 'Zmiana pola: ',
    'history.insert': 'Utworzono',
    'history.update': 'Zmieniono',
    'history.delete': 'Usunięto',
    'history.restore': 'Przywrócono',

    // print
    'print.print': 'Generuj wydruk',
    'print.print_display': 'Wyświetl PDF w przeglądarce',
    'print.generated': 'Wygenerowano',
    'print.author': 'Wygenerował',
    'print.choose_attachments': 'Wybierz załączniki:',
    'print.with_attachments': 'Pobierz PDF wraz z załącznikami typu PDF',
    'print.can_take_a_while': 'Generowanie dokumentu może zająć trochę czasu - prosimy o cierpliwość.',

    // statistics
    'statistics': 'Statystyki',
    'statistics.no_data': 'Brak danych',

    // reports
    'reports': 'Zestawienia',
    'reports.period_summary': 'Wydruk okresowy',
    'reports.service_costs': 'Koszty serwisu',
    'reports.details': 'Dołącz szczegóły',
    'reports.dates': 'Zakres dat',
    'reports.statuses': 'Statusy uwzględnionych prac',
    'reports.all_of_woodworks': 'Pokaż całą stolarkę',
    'reports.grades': 'Oceny za okres',

    // system messages
    'system.sure_to_leave': 'Czy na pewno chcesz odświeżyć/zamknąć aplikację? Możesz utracić wprowadzone zmiany'
};

if ('undefined' !== typeof angular) {
    angular.module('app.config').config(function ($translateProvider) {
        $translateProvider.translations('pl', language);
    });
}
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.services').service('api', function ($rootScope, $q, $http, $httpParamSerializerJQLike, $localStorage, $timeout, Restangular, variables) {
    return function (path) {
        var baseUrl = '/api/1/';
        var cachePrefix = 'cache';
        var getObjectValueByPath = function getObjectValueByPath(object, path) {
            var parts = path.split('.');
            for (var i in parts) {
                var key = parts[i];
                if (object[key]) {
                    object = object[key];
                }
            }
            return object;
        };

        var api = {
            requestDefer: null,

            model: function model() {
                return Restangular.all(path);
            },
            stop: function stop() {
                this.requestDefer && this.requestDefer.resolve();

                return this;
            },
            buildCacheKey: function buildCacheKey(path) {
                var areaId = $rootScope.$session.area ? $rootScope.$session.area.id : 0;

                return cachePrefix + '_' + areaId + '_' + path;
            },
            _matchLifetimeOptionForKey: function _matchLifetimeOptionForKey(path) {
                if ('undefined' !== typeof variables.cacheLifetime.fixed[path]) {
                    return variables.cacheLifetime.fixed[path];
                } else {
                    for (var pattern in variables.cacheLifetime.regexp) {
                        if (variables.cacheLifetime.regexp.hasOwnProperty(pattern)) {
                            var regexp = new RegExp(pattern, 'g');
                            if (regexp.test(path)) {
                                return variables.cacheLifetime.regexp[pattern];
                            }
                        }
                    }
                }

                return variables.cacheLifetime.default;
            },
            list: function list(userOptions) {
                var defaults = {
                    data: {},
                    method: 'get',
                    pathPrefix: '',
                    pathSuffix: '',
                    cacheLifetime: this._matchLifetimeOptionForKey(path)
                };

                var options = angular.extend({}, defaults, userOptions);

                var deferred = $q.defer();
                var params = $httpParamSerializerJQLike(options.data);
                var suffix = params ? '?' + params : '';
                var url = baseUrl + options.pathPrefix + path + options.pathSuffix + suffix;
                var now = new Date().getTime();

                var cacheKey = this.buildCacheKey(url);
                var storage = $localStorage;

                if (options.cacheLifetime && 'object' === _typeof(storage[cacheKey]) && storage[cacheKey].lifetime > now) {
                    deferred.resolve({ data: storage[cacheKey].data });
                    return deferred.promise;
                }

                this.requestDefer = $q.defer();
                $http({
                    timeout: this.requestDefer.promise,
                    method: options.method,
                    url: url
                }).then(function (response) {
                    if (200 === response.status && response.data) {
                        if (options.cacheLifetime) {
                            storage[cacheKey] = {
                                lifetime: now + options.cacheLifetime,
                                data: response.data
                            };
                        }
                        deferred.resolve({ data: response.data });
                    } else {
                        deferred.reject();
                    }
                }, function () {
                    deferred.reject();
                });

                return deferred.promise;
            },


            // coś jak sprintf()
            parse: function parse(data, format) {
                if (!format.includes(':')) {
                    return data[format];
                }

                var keys = format.match(/\:[a-zA-Z_.]+/gi);
                for (var i in keys) {
                    if (keys.hasOwnProperty(i)) {
                        var _path = keys[i].substr(1);
                        format = format.replace(keys[i], getObjectValueByPath(data, _path));
                    }
                }

                return format;
            },
            select: function select(userOptions) {
                var defaults = {
                    data: {},
                    pathPrefix: 'select/',
                    cacheLifetime: this._matchLifetimeOptionForKey(path),
                    transform: { id: 'id', value: 'value' }
                };

                var options = angular.extend({}, defaults, userOptions);
                var that = this;

                return that.list(options).then(function (response) {
                    var pairs = {};

                    angular.forEach(response.data, function (row) {
                        pairs[row[options.transform.id]] = that.parse(row, options.transform.value);
                    });

                    return {
                        data: pairs
                    };
                });
            },
            selectize: function selectize(userOptions) {
                var defaults = {
                    data: {},
                    pathPrefix: 'select/',
                    cacheLifetime: this._matchLifetimeOptionForKey(path),
                    transform: { id: 'id', value: 'value' }
                };

                var options = angular.extend({}, defaults, userOptions);
                var that = this;

                return that.list(options).then(function (response) {
                    var list = [];

                    // must be the same as at selectize.js and angular-selectize.js
                    angular.forEach(response.data, function (row) {
                        var baseValues = {
                            value: row[options.transform.id],
                            label: that.parse(row, options.transform.value),
                            order: row.order
                        };

                        list.push(angular.extend({}, row, baseValues));
                    });

                    return {
                        data: list
                    };
                });
            },
            filter: function filter(userOptions) {
                var defaults = {
                    data: {},
                    pathPrefix: 'filter/'
                };

                var options = angular.extend({}, defaults, userOptions);

                return this.list(options);
            },
            get: function get(id, userOptions) {
                var defaults = {
                    data: {},
                    pathPrefix: '',
                    pathSuffix: '',
                    cacheLifetime: this._matchLifetimeOptionForKey(path)
                };

                var options = angular.extend({}, defaults, userOptions);
                var params = $httpParamSerializerJQLike(options.data);
                var suffix = params ? '?' + params : '';
                var url = baseUrl + options.pathPrefix + path + '/' + id + options.pathSuffix + suffix;

                var deferred = $q.defer();

                // todo: cache
                this.requestDefer = $q.defer();
                $http({
                    timeout: this.requestDefer.promise,
                    method: 'get',
                    url: url
                }).then(function (response) {
                    if (response.data) {
                        deferred.resolve(response.data);
                    } else {
                        deferred.reject();
                    }
                }, function () {
                    deferred.reject();
                });

                return deferred.promise;
            },
            save: function save(id, data) {
                var deferred = $q.defer();

                this.requestDefer = $q.defer();
                $http({
                    timeout: this.requestDefer.promise,
                    method: 'put',
                    url: baseUrl + path + '/' + id,
                    data: data
                }).then(function (response) {
                    if (200 === response.status && response.data) {
                        deferred.resolve(response.data);
                    } else {
                        deferred.reject(response.data);
                    }
                }, function (response) {
                    deferred.reject(response.data);
                });

                return deferred.promise;
            },
            post: function post(data, userOptions) {
                var defaults = {
                    pathPrefix: '',
                    pathSuffix: '',
                    params: {},
                    method: 'post'
                };

                var options = angular.extend({}, defaults, userOptions || {});
                var params = $httpParamSerializerJQLike(options.params);
                var suffix = params ? '?' + params : '';
                var url = baseUrl + options.pathPrefix + path + options.pathSuffix + suffix;

                var deferred = $q.defer();

                this.requestDefer = $q.defer();
                $http({
                    timeout: this.requestDefer.promise,
                    method: options.method,
                    url: url,
                    data: data
                }).then(function (response) {
                    if (200 === response.status && response.data) {
                        deferred.resolve(response.data);
                    } else {
                        deferred.reject(response.data);
                    }
                }, function (response) {
                    deferred.reject(response.data);
                });

                return deferred.promise;
            },
            remove: function remove(id, userOptions) {
                var options = angular.extend({
                    method: 'post',
                    pathSuffix: '/delete/' + id
                }, userOptions);

                return this.post({}, options);
            },
            restore: function restore(id, userOptions) {
                var options = angular.extend({
                    method: 'post',
                    pathSuffix: '/restore/' + id
                }, userOptions);

                return this.post({}, options);
            },
            clearCache: function clearCache() {
                var url = baseUrl + path;
                var keyToDelete = this.buildCacheKey(path ? url : '');

                for (var cacheKey in $localStorage) {
                    if (0 === cacheKey.indexOf(keyToDelete)) {
                        $localStorage[cacheKey] = '';
                        delete $localStorage[cacheKey];
                    }
                }

                return this;
            },
            cancel: function cancel(promise) {
                return $q.cancel(promise);
            }
        };

        return api;
    };
});
'use strict';

angular.module('app.services').service('notify', function ($rootScope) {
    var _config = {
        timeoutFlash: 2000,
        timeoutDefault: 5000,
        timeoutLong: 10000,
        timeoutVeryLong: 30000
    };

    return {
        config: function config(key) {
            return _config[key] || null;
        },
        info: function info(content, timeout, position) {
            return UIkit.notify({
                message: content,
                status: 'info',
                timeout: timeout || _config.timeoutDefault,
                pos: position || 'bottom-right'
            });
        },
        success: function success(content, timeout, position) {
            return UIkit.notify({
                message: content,
                status: 'success',
                timeout: timeout || _config.timeoutDefault,
                pos: position || 'bottom-right'
            });
        },
        warning: function warning(content, timeout, position) {
            return UIkit.notify({
                message: content,
                status: 'warning',
                timeout: timeout || _config.timeoutDefault,
                pos: position || 'bottom-right'
            });
        },
        danger: function danger(content, timeout, position) {
            return UIkit.notify({
                message: content,
                status: 'danger',
                timeout: timeout || _config.timeoutDefault,
                pos: position || 'bottom-right'
            });
        },
        global: function global(status) {
            return status ? $rootScope.content_preloader_show() : $rootScope.content_preloader_hide();
        },
        overlay: function overlay(status) {
            var $overlay = angular.element('body > .notify-overlay');

            if (!$overlay.length) {
                $overlay = angular.element('<div class="notify-overlay"></div>');
                angular.element('body').append($overlay);
            }

            if (status) {
                $overlay.addClass('show');
            } else {
                $overlay.removeClass('show');
            }
        }
    };
});
'use strict';

angular.module('app.services').service('preloaders', function ($rootScope, $timeout, utils) {
    $rootScope.content_preloader_show = function (style, container) {
        var $body = $('body');
        $body.addClass('content_preloader');

        if (!$body.find('.content-preloader').length) {
            var image_density = utils.isHighDensity() ? '@2x' : '';

            var preloader_content = typeof style !== 'undefined' && style == 'regular' ? '<img src="/img/spinners/spinner' + image_density + '.gif" alt="" width="32" height="32">' : '<div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="32" width="32" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/></svg></div>';

            var thisContainer = typeof container !== 'undefined' ? container : $body;

            thisContainer.append('<div class="content-preloader">' + preloader_content + '</div>');
            $timeout(function () {
                $('.content-preloader').addClass('preloader-active');
            });
        }
    };

    $rootScope.content_preloader_hide = function () {
        var $body = $('body');
        $body.removeClass('content_preloader');

        if ($body.find('.content-preloader').length) {
            // hide preloader
            $('.content-preloader').removeClass('preloader-active');
            // remove preloader
            $timeout(function () {
                $('.content-preloader').remove();
            }, 500);
        }
    };
});
'use strict';

angular.module('app.controllers').controller('AppCtrl', function () {});
'use strict';

angular.module('app.controllers').controller('EditAreaCtrl', function ($rootScope, $state, $translate, notify, formValidator, areasService, area, allUserOptions, allGroupsOptions, installationOptions, woodworkOptions, currencyOptions, countryOptions, unitOptions, interestStatusOptions, taskStatusOptions, categoryOptions, projectStatusOptions, phaseStatusOptions) {
    var vm = this;

    vm.area = area;
    vm.unitOptions = unitOptions;
    vm.woodworkOptions = woodworkOptions;
    vm.installationOptions = installationOptions;

    // tylko użytkownicy przypisani do danego obszaru
    vm.userOptions = _.filter(allUserOptions, function (user) {
        return user.areas_id.includes(vm.area.id);
    });

    // tylko grupy przypisane do danego obszaru
    var groupOptions = _.filter(allGroupsOptions, function (group) {
        return $rootScope.$session.area.id === parseInt(group.area_id);
    });

    vm.managerKeys = ['projects.measurement', 'projects.installation', 'projects.service', 'projects.transport', 'tasks', 'interests'];
    vm.defaultsKeys = {
        currency_id: currencyOptions,
        country_id: countryOptions,
        unit_piece_id: unitOptions,
        interest_status_id: interestStatusOptions,
        interest_win_id: interestStatusOptions,
        interest_loss_id: interestStatusOptions,
        task_status_id: taskStatusOptions,
        task_unfinished_id: taskStatusOptions,
        task_category_id: categoryOptions,
        project_status_started: projectStatusOptions,
        project_status_closed: projectStatusOptions,
        phase_status_started: phaseStatusOptions,
        phase_status_closed: phaseStatusOptions,
        crew_id_measurement: groupOptions,
        crew_id_installation: groupOptions,
        crew_id_service: groupOptions,
        crew_id_transport: groupOptions,
        phase_daily_limit_transport: 'number',
        phase_daily_limit_transport_message: 'text',
        phase_daily_limit_installation: 'number',
        phase_minimum_days_buffer_installation: 'number',
        notify_about_complaint: 'number'
    };

    // form validation
    var fv1 = formValidator('#AreaBaseForm', vm);

    var fv2 = formValidator('#AreaSettingsForm', vm);
    var fv3 = formValidator('#AreaCalculationsForm', vm);

    vm.saveArea = function () {
        // wymuszamy obliczenie dla wszystkich formularzy
        var errors = void 0;
        if (vm.area.id) {
            errors = _.sum([fv1.isValid(false) ? 0 : 1, fv2.isValid(true) ? 0 : 1, fv3.isValid(true) ? 0 : 1]);
        } else {
            errors = fv1.isValid(false) ? 0 : 1;
        }
        if (errors) {
            return;
        }
        // @todo: po aktualizacji obszarów powinny się odświeżyć dane użytkownika

        var redirectAfterSave = 0 == vm.area.id;
        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        areasService.save(vm.area).then(function (response) {
            vm.area = response;

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
            $rootScope.$broadcast('edit-panel-ready');

            if (redirectAfterSave) {
                $state.go('restricted.areas_edit', { id: vm.area.id });
            }
        });
    };
});
'use strict';

angular.module('app.controllers').controller('AreasListCtrl', function ($translate, areasList) {
    var vm = this;

    // własna metoda do filtrowania listy
    vm.listFilter = function (area) {
        if (!area || !vm.search) {
            return true;
        }

        var parts = vm.search.split('+');
        var regExp = new RegExp(parts.join('|'), 'i');
        var subject = [area.name, area.symbol, area.description].join(' ');

        return regExp.test(subject);
    };

    vm.areas = areasList;
});
'use strict';

angular.module('app.controllers').controller('MainAsideCtrl', function ($rootScope, $timeout, $translate) {
    var _this = this;

    var vm = this;

    $rootScope.$on('$stateChangeSuccess', function () {
        $timeout(function () {
            if (!$rootScope.miniSidebarActive) {
                // activate current section
                $('#sidebar_main').find('.current_section:not(.act_section ) > a').trigger('click');
            } else {
                // add tooltips to mini sidebar
                var tooltip_elem = $('#sidebar_main').find('.menu_tooltip');
                tooltip_elem.each(function () {
                    var element = $(_this);
                    element.attr('title', element.find('.menu_title').text());
                    UIkit.tooltip(element, {});
                });
            }
        }, 500);
    });

    // language switcher
    vm.langSwitcherModel = 'pl';
    var langData = vm.langSwitcherOptions = [{ id: 1, title: 'English', value: 'gb' }, { id: 7, title: 'German', value: 'de' }, { id: 8, title: 'Polish', value: 'pl' }];
    vm.langSwitcherConfig = {
        maxItems: 1,
        render: {
            option: function option(langData, escape) {
                return '<div class="option"><i class="item-icon flag-' + escape(langData.value).toUpperCase() + '"></i><span>' + escape(langData.title) + '</span></div>';
            },
            item: function item(langData, escape) {
                return '<div class="item"><i class="item-icon flag-' + escape(langData.value).toUpperCase() + '"></i></div>';
            }
        },
        valueField: 'value',
        labelField: 'title',
        searchField: 'title',
        create: false,
        onInitialize: function onInitialize(selectize) {
            $('#lang_switcher').next().children('.selectize-input').find('input').attr('readonly', true);
        }
    };

    // menu entries
    vm.sections = [{
        id: 0,
        title: $translate.instant('dashboard.calendars'),
        icon: 'event',
        allow: 'true',
        submenu: [{
            link: 'restricted.dashboard_main',
            title: $translate.instant('dashboard.main'),
            allow: 'true'
        }, {
            link: 'restricted.dashboard_tasks',
            title: $translate.instant('dashboard.tasks'),
            allow: 'dashboard_tasks__read | dashboard_tasks__read_all'
        }, {
            link: 'restricted.dashboard_measurement',
            title: $translate.instant('dashboard.measurement'),
            allow: 'dashboard_measurement__read | dashboard_measurement__read_all'
        }, {
            link: 'restricted.dashboard_installation',
            title: $translate.instant('dashboard.installation'),
            allow: 'dashboard_installation__read | dashboard_installation__read_all'
        }, {
            link: 'restricted.dashboard_transport',
            title: $translate.instant('dashboard.transport'),
            allow: 'dashboard_transport__read | dashboard_transport__read_all'
        }, {
            link: 'restricted.dashboard_service',
            title: $translate.instant('dashboard.service'),
            allow: 'dashboard_service__read | dashboard_service__read_all'
        }]
    }, {
        id: 9,
        title: $translate.instant('projects'),
        icon: 'build',
        allow: 'projects__read | projects__read_all | projects__write | projects__write_all | phases__read | phases__read_all',
        submenu: [{
            link: 'restricted.projects',
            title: $translate.instant('projects.list'),
            allow: 'projects__read | projects__read_all'
        }, {
            link: 'restricted.projects_add',
            title: $translate.instant('projects.add'),
            allow: 'projects__write | projects__write_all'
        }, {
            link: 'restricted.phases',
            title: $translate.instant('phases.list'),
            allow: 'projects__read | projects__read_all'
        }, {
            link: 'restricted.phases_print',
            title: $translate.instant('phases.print'),
            allow: 'projects__read | projects__read_all'
        }, {
            link: 'restricted.phases_approval',
            title: $translate.instant('phases.approvals'),
            allow: 'projects__phases_approval'
        }]
    }, {
        id: 6,
        title: $translate.instant('interests'),
        icon: 'grade',
        allow: 'interests__read | interests__read_all | interests__write | interests__write_all',
        submenu: [{
            link: 'restricted.interests',
            title: $translate.instant('interests.list'),
            allow: 'interests__read | interests__read_all'
        }, {
            link: 'restricted.interests_add',
            title: $translate.instant('interests.add'),
            allow: 'interests__write | interests__write_all'
        }]
    }, {
        id: 7,
        title: $translate.instant('tasks'),
        icon: 'query_builder',
        allow: 'tasks__read | tasks__read_all | tasks__write | tasks__write_all',
        submenu: [{
            link: 'restricted.tasks',
            title: $translate.instant('tasks.list'),
            allow: 'tasks__read | tasks__read_all'
        }, {
            link: 'restricted.tasks_add',
            title: $translate.instant('tasks.add'),
            allow: 'tasks__write | tasks__write_all'
        }]
    }, {
        id: 5,
        title: $translate.instant('clients'),
        icon: 'people',
        allow: 'clients__read | clients__read_all | clients__write | clients__write_all',
        submenu: [{
            link: 'restricted.clients',
            title: $translate.instant('clients.list'),
            allow: 'clients__read | clients__read_all'
        }, {
            link: 'restricted.clients_add',
            title: $translate.instant('clients.add'),
            allow: 'clients__write | clients__write_all'
        }, {
            link: 'restricted.investments',
            title: $translate.instant('investments'),
            allow: 'clients__write | clients__write_all'
        }]
    }, {
        id: 1,
        title: $translate.instant('users'),
        icon: 'face',
        allow: 'users__read | users__manage',
        submenu: [{
            link: 'restricted.users',
            title: $translate.instant('users.list'),
            allow: 'users__read'
        }, {
            link: 'restricted.users_add',
            title: $translate.instant('users.add'),
            allow: 'users__manage' /*,
                                      {
                                      link: 'restricted.users_mass',
                                      title: $translate.instant('users.mass_edit'),
                                      allow: 'users__manage'
                                      }*/
        }]
    }, {
        id: 13,
        title: $translate.instant('areas'),
        icon: 'account_balance',
        allow: 'areas__read | areas__manage',
        submenu: [{
            link: 'restricted.areas',
            title: $translate.instant('areas.list'),
            allow: 'areas__read'
        }, {
            link: 'restricted.areas_add',
            title: $translate.instant('areas.add'),
            allow: 'areas__manage'
        }]
    }, {
        id: 2,
        title: $translate.instant('groups'),
        icon: 'people',
        allow: 'groups__read | groups__read_all',
        link: 'restricted.groups',
        submenu: []
    }, {
        id: 3,
        title: $translate.instant('dictionaries'),
        icon: 'library_books',
        allow: 'dictionaries__read',
        link: 'restricted.dictionaries',
        submenu: []
    }, {
        id: 11,
        title: $translate.instant('reports'),
        icon: 'assignment',
        allow: 'reports__read',
        link: 'restricted.reports_period_summary',
        submenu: []
    }, {
        id: 12,
        title: $translate.instant('help'),
        icon: 'help',
        allow: 'true',
        link: 'restricted.help',
        submenu: []
    }];
});
'use strict';

angular.module('app.controllers').controller('AttachmentsCtrl', function () {});
'use strict';

angular.module('app.controllers').controller('AuthCheckCtrl', function ($rootScope, $state, $log, UserService, notify, $translate) {
    var redirect = function redirect() {
        var toState = $rootScope.referenceState || 'restricted.dashboard_main';
        var toParams = $rootScope.referenceStateParams || {};

        $rootScope.referenceState = null;
        $rootScope.referenceStateParams = null;

        $log.debug('check session: redirected', toState, toParams);
        $state.go(toState, toParams);
    };

    if (UserService.isAuthenticated()) {
        redirect();
    } else {
        // sprawdzamy, czy wymuszono zapamiętanie
        var info = notify.info($translate.instant('auth.signin_check_remembered'));
        UserService.checkSessions().then(function () {
            info.close();
            notify.info($translate.instant('auth.signin_ok'));
            redirect();
        }, function () {
            info.close();

            UserService.logout(function () {
                notify.danger($translate.instant('auth.no_auth'));
                $state.go('login', {}, { reload: true });
            });
        });
    }
});
'use strict';

angular.module('app.controllers').controller('AuthLoginCtrl', function (utils, $state, UserService, notify, $translate) {
    var vm = this;

    if (UserService.isAuthenticated()) {
        $state.go('restricted.dashboard_main');
    } else {
        // sprawdzamy, czy wymuszono zapamiętanie
        var info = notify.info($translate.instant('auth.signin_check_remembered'));
        UserService.checkSessions().then(function () {
            info.close();
            notify.info($translate.instant('auth.signin_ok'));
            $state.go('restricted.dashboard_main');
        }, function () {
            info.close();
        });
    }

    vm.registerFormActive = false;
    vm.credentials = {
        email: '',
        password: '',
        remember: ''
    };

    vm.doAuth = function () {
        var info = notify.info($translate.instant('auth.signing'));

        UserService.login(vm.credentials).then(function () {
            info.close();
            notify.success($translate.instant('auth.signin_ok'));
            $state.go('restricted.dashboard_main');
        }, function (data) {
            info.close();
            vm.credentials.password = '';
            notify.danger($translate.instant(data.message));
        });
    };

    var $loginCard = $('#Login-Card');
    var $loginForm = $('#Login-Form');
    var $loginPasswordReset = $('#Login-PasswordReset');

    // show login form (hide other forms)
    var loginFormShow = function loginFormShow() {
        $loginForm.show().siblings().hide();
    };

    // show password reset form (hide other forms)
    var passwordResetShow = function passwordResetShow() {
        $loginPasswordReset.show().siblings().hide();
    };

    vm.backToLogin = function ($event) {
        $event.preventDefault();
        vm.registerFormActive = false;
        utils.card_show_hide($loginCard, undefined, loginFormShow, undefined);
    };

    vm.passwordReset = function ($event) {
        $event.preventDefault();
        utils.card_show_hide($loginCard, undefined, passwordResetShow, undefined);
    };

    vm.emailForReset = '';
    vm.doPasswordReset = function () {
        var info = notify.info($translate.instant('sending'), notify.config('timeoutVeryLong'));
        UserService.passwordReset(vm.emailForReset).then(function () {
            info.close();
            notify.success($translate.instant('auth.reset_password_sent'), notify.config('timeoutLong'));
        }, function () {
            info.close();
            notify.danger($translate.instant('auth.reset_password_error'), notify.config('timeoutLong'));
        });
    };
});
'use strict';

angular.module('app.controllers').controller('InvestmentsController', function ($scope, $rootScope, $translate, notify, investmentsListFilterFactory, api, formValidator, UserService) {
    $scope.filter = investmentsListFilterFactory;
    $scope.clientOptions = [];
    $scope.statusOptions = [{ value: 'investment_active', label: $translate.instant('group_active') }, { value: 'investment_inactive', label: $translate.instant('group_inactive') }];

    var InvestmentModel = api('investments');

    $scope.investments = [];
    $scope.loadList = function () {
        var info = notify.info($translate.instant('loading'));
        InvestmentModel.list().then(function (response) {
            $scope.investments = response.data;
            info.close();
            notify.success($translate.instant('loaded'));
        });
    };
    $scope.loadList();

    $scope.editInvestment = function (id) {
        var model = _.find($scope.investments, { id: id }) || {
            status: 'investment_active'
        };
        $scope.currentInvestment = angular.extend({}, model);
        if (model.client) {
            $scope.clientsOptions = [{ id: model.client.id, name: model.client.name }];
        } else {
            $scope.clientsOptions = [];
        }
    };

    // form validation
    var fv = formValidator('#InvestmentForm', $scope);

    $scope.saveInvestment = function () {
        if (!fv.isValid()) {
            return;
        }

        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        InvestmentModel.save($scope.currentInvestment.id || 0, $scope.currentInvestment).then(function (response) {
            // zamiana/dodanie
            var index = _.findIndex($scope.investments, { id: $scope.currentInvestment.id || 0 });

            if (-1 !== index) {
                $scope.investments[index] = response;
            } else {
                $scope.investments.push(response);
            }

            InvestmentModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
        });
    };
});
'use strict';

angular.module('app.controllers').controller('EditClientCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, notify, api, UserService, formValidator, variables) {
    $scope.statusOptions = [{ value: 'client_active', label: $translate.instant('client_active') }, { value: 'client_inactive', label: $translate.instant('client_inactive') }, { value: 'client_deleted', label: $translate.instant('client_deleted') }, { value: 'client_suspended', label: $translate.instant('client_suspended') }];

    // dane
    var ClientModel = api('clients');

    $scope.client = {};
    if (0 < $stateParams.id) {
        var info = notify.info($translate.instant('loading'));
        ClientModel.get($stateParams.id).then(function (response) {
            $scope.client = response;
            info.close();
            notify.success($translate.instant('loaded'));
            $scope.setupPhotoUploader();
            $rootScope.$broadcast('edit-panel-ready');
        });
    } else {
        $scope.client = {
            id: 0,
            author_id: UserService.getUser().id,
            address_country_id: variables.defaults.country_id,
            contact_country_id: variables.defaults.country_id,
            status: 'client_active'
        };
    }

    $scope.userOptions = [];
    api('users').selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } }).then(function (response) {
        $scope.userOptions = response.data;
    });

    $scope.countryOptions = [];
    api('dictionaries/countries').selectize().then(function (response) {
        $scope.countryOptions = response.data;
    });

    // form validation
    var fv = formValidator('#ClientForm', $scope);

    $scope.saveClient = function () {
        if (!fv.isValid()) {
            return;
        }

        var redirectAfterSave = 0 == $scope.client.id;
        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        ClientModel.save($scope.client.id, $scope.client).then(function (response) {
            $scope.client = response;
            ClientModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
            $rootScope.$broadcast('edit-panel-ready');

            if (redirectAfterSave) {
                $state.go('restricted.clients_edit', { id: $scope.client.id });
            }
        });
    };

    $scope.setupPhotoUploader = function () {
        $scope.photoChanged = 0;

        var settings = {
            action: '/api/1/clients/$/photo'.replace('$', $scope.client.id),
            allow: '*.(jpg|jpeg|gif|png)',
            filelimit: 1,
            param: 'photo',
            single: true,
            loadstart: function loadstart() {
                notify.global(1);
            },
            progress: function progress(percent) {},
            allcomplete: function allcomplete() {
                notify.global(0);
                $scope.photoChanged++;
                $scope.client.photo = true;
            }
        };
        UIkit.uploadSelect($('#user_edit_avatar_control'), settings);
    };
});
'use strict';

angular.module('app.controllers').controller('ClientsCtrl', function ($translate, DataTablesFactory, clientsListFilter, clientsList) {
    var vm = this;

    vm.clients = clientsList;
    vm.filter = clientsListFilter;

    vm.dt = DataTablesFactory.init({
        scope: vm
    });
});
'use strict';

angular.module('app.controllers').controller('DashboardDefaultCtrl', function ($scope, $timeout, $q, api, notify, UserService, usersOptions) {
    var vm = this;

    vm.userOptions = usersOptions;
    vm.users = [];
    var currentUserId = UserService.getUser().id;
    var belongsToArea = _.find(usersOptions, function (o) {
        return o.id == currentUserId;
    });
    if (belongsToArea) {
        vm.users.push(currentUserId);
    }

    var DashboardModel = api('dashboard');
    var timeoutPromise = null;

    $scope.$watch('DashboardDefault.users', function () {
        timeoutPromise && $timeout.cancel(timeoutPromise);
        timeoutPromise = $timeout(function () {
            notify.global(1);

            var p1 = DashboardModel.get('tasks_all', { data: { users: vm.users } }).then(function (data) {
                vm.tasks_all = data.data;
                vm.tasks_all_labels = data.labels;
            });

            var p2 = DashboardModel.get('tasks_month', { data: { users: vm.users } }).then(function (data) {
                vm.tasks_month = data.data;
                vm.tasks_month_labels = data.labels;
            });

            var p3 = DashboardModel.get('interests_all', { data: { users: vm.users } }).then(function (data) {
                vm.interests_all = data.data;
                vm.interests_all_labels = data.labels;
            });

            var p4 = DashboardModel.get('interests_month', { data: { users: vm.users } }).then(function (data) {
                vm.interests_month = data.data;
                vm.interests_month_labels = data.labels;
            });

            $q.all([p1, p2, p3, p4]).then(function () {
                notify.global(0);
            }, function () {
                notify.global(0);
            });

            timeoutPromise = null;
        }, 1000);
    });
});
'use strict';

/**
 * 1. events are fetched for whole month
 * 2. angular-ui calendar is responsible for displaying data
 */
angular.module('app.controllers').controller('DashboardPhaseCtrl', function ($scope, $timeout, $translate, $state, $log, $localStorage, uiCalendarConfig, api, notify, UserService, variables, usersOptions, groupsOptions, phaseStatusOptions) {
    var vm = this;

    // @todo: cache for events
    vm.hash = 1;
    vm.eventSources = [[]];

    // dashboardType
    vm.type = $state.current.data.dashboardType || 'measurement';

    // settings
    var defaultSettings = function defaultSettings(type) {
        return {
            date: moment(),
            author_id: [UserService.getUser().id.toString()],
            manager_id: [UserService.getUser().id.toString()],
            crew_id: [variables.defaults['crew_id_' + type]],
            status_id: []
        };
    };

    $localStorage.$default({
        dashboardPhases: {
            measurement: defaultSettings('measurement'),
            installation: defaultSettings('installation'),
            transport: defaultSettings('transport'),
            service: defaultSettings('service')
        }
    });

    vm.userSettings = $localStorage.dashboardPhases[vm.type];
    vm.currentSettings = angular.copy(vm.userSettings);

    vm.usersOptions = usersOptions;
    vm.groupsOptions = groupsOptions;
    vm.phaseStatusOptions = phaseStatusOptions;

    vm.firstRender = true;

    vm.uiConfig = {
        calendar: {
            header: {
                left: 'chooseDate',
                center: 'title',
                right: 'month,listMonth,agendaWeek,listWeek,agendaDay prev,next'
            },
            buttonIcons: {
                prev: 'md-left-single-arrow',
                next: 'md-right-single-arrow',
                prevYear: 'md-left-double-arrow',
                nextYear: 'md-right-double-arrow'
            },
            customButtons: {
                chooseDate: {
                    text: ' '
                }
            },
            buttonText: {
                today: ' ',
                month: ' ',
                week: ' ',
                day: ' '
            },
            locale: 'pl',
            aspectRatio: 2.1,
            defaultDate: vm.userSettings.date || moment(),
            selectable: true,
            selectHelper: true,
            select: function select(start, end) {},
            viewRender: function viewRender(view) {
                $log.debug("Calendar's View Changed", view);
                if (vm.firstRender) {
                    // podmiana ikony
                    $timeout(function () {
                        angular.element('.fc-chooseDate-button').html('<em class="material-icons md-24">date_range</em>');
                    });
                    // przechodzenie do wybranej daty
                    $timeout(function () {
                        var datepicker = UIkit.datepicker(angular.element('.fc-chooseDate-button .material-icons'));
                        datepicker.on('hide.uk.datepicker', function () {
                            vm.goToDate(datepicker.current.format('YYYY-MM-DD'));
                        });
                    });
                }

                var typeMap = {
                    month: 'month',
                    agendaWeek: 'week',
                    agendaDay: 'day'
                };

                vm.timeUnit = typeMap[view.type] || 'month';
                vm.viewStart = view.start;
                vm.dateStart = view.start.format('YYYY-MM-DD');
                vm.viewEnd = view.end;
                vm.dateEnd = view.end.format('YYYY-MM-DD');

                debouncedFetchEvents();

                vm.firstRender = false;

                if ('month' === view.name) {
                    // zapamiętujemy datę ze środka miesiąca, aby uniknać skakania
                    vm.userSettings.date = view.start.add(14, 'days').format('YYYY-MM-DD');
                } else {
                    vm.userSettings.date = view.start.format('YYYY-MM-DD');
                }
            },
            eventRender: function eventRender(event, element) {
                element.attr('data-uk-tooltip', "{cls:'uk-tooltip long-text',pos:'bottom'}");
                element.attr('title', event.tooltip);
                element.find('.fc-list-item-title').append('; ' + $translate.instant('phases.time_of_service') + ': ' + event.desc);
            },

            editable: true,
            eventLimit: true,
            timeFormat: '(HH)(:mm)'
        }
    };

    var PhasesModel = api('phases');

    vm.timeSettings = null;
    vm.timeUnit = 'month';
    var eventDates = {};

    vm.recalculateUsage = function () {
        if (!vm.timeSettings) {
            return false;
        }

        var calculated = 0;
        var viewRange = moment.range(vm.viewStart, vm.viewEnd);

        angular.forEach(eventDates[vm.hash], function (event) {
            var range = moment.range(event.start, event.end);

            if (viewRange.intersect(range)) {
                calculated += event.time;
            }
        });

        var multi = {
            day: 1,
            week: 5,
            month: 22
        };

        vm.time = {
            available: vm.timeSettings.time * vm.timeSettings[vm.type] * multi[vm.timeUnit],
            used: calculated
        };
        vm.time.percent = Math.round(vm.time.used / vm.time.available * 100);

        switch (true) {
            case vm.time.percent > 80:
                vm.time.cssClass = 'uk-progress-danger';
                break;
            case vm.time.percent > 50:
                vm.time.cssClass = 'uk-progress-warning';
                break;
            default:
                vm.time.cssClass = 'uk-progress-success';
                break;
        }
    };

    vm.goToDate = function (date) {
        uiCalendarConfig.calendars['phasesCalendar'].fullCalendar('gotoDate', date);
    };

    vm.fetchEvents = function () {
        if (!_.isArray(vm.currentSettings.crew_id) || !vm.currentSettings.crew_id.length) {
            return false;
        }

        var info = notify.info($translate.instant('loading'));
        notify.global(1);

        PhasesModel.stop().list({
            pathSuffix: '/calendar',
            data: {
                type: vm.type,
                crew_id: vm.currentSettings.crew_id,
                author_id: vm.currentSettings.author_id,
                manager_id: vm.currentSettings.manager_id,
                status_id: vm.currentSettings.status_id,
                from: vm.dateStart,
                to: vm.dateEnd
            }
        }).then(function (response) {
            var phases = [];

            if (null === vm.timeSettings) {
                vm.timeSettings = response.data.workers;
            }

            var colorMap = {
                measurement: '#ffa000',
                installation: '#7cb342',
                transport: '#2196f3',
                service: '#e53935'
            };

            angular.forEach(response.data.events, function (phase) {
                var time = 0;

                if (0 < phase.time_recorded) {
                    time = parseFloat(phase.time_recorded);
                } else if (0 < phase.time_needed) {
                    time = parseFloat(phase.time_needed);
                } else if (0 < phase.time_calculated) {
                    time = parseFloat(phase.time_calculated);
                }

                phases.push({
                    id: phase.id,
                    title: phase.client_name + ' (' + time + 'm / ' + Math.round(100 * time / 60) / 100 + 'h)',
                    desc: phase.time_of_service,
                    start: phase.date_from.substr(0, 10),
                    end: phase.date_to.substr(0, 10),
                    allDay: true,
                    url: '/phases/edit/' + phase.id,
                    time: time,
                    color: colorMap[vm.type],
                    tooltip: [phase.client_name, ': ', phase.name, '<br>', phase.time_of_service || '-', ': ', phase.address || '-'].join('')
                });
            });

            $timeout(function () {
                eventDates[vm.hash] = phases;
                vm.eventSources[0] = eventDates[vm.hash];
                vm.recalculateUsage();
            }, 0);

            $timeout(function () {
                info.close();
                notify.success($translate.instant('loaded'));
                notify.global(0);
            }, 500);
        });
    };

    var debouncedFetchEvents = _.debounce(vm.fetchEvents, 750);
    $scope.$watch('DashboardPhase.currentSettings', debouncedFetchEvents, true);

    vm.rememberSettings = function () {
        vm.userSettings.crew_id = vm.currentSettings.crew_id;
        vm.userSettings.status_id = vm.currentSettings.status_id;
        vm.userSettings.author_id = vm.currentSettings.author_id;
        vm.userSettings.manager_id = vm.currentSettings.manager_id;
        $log.debug('saved settings', vm.userSettings);

        notify.info($translate.instant('saved'));
    };

    vm.resetSettings = function () {
        var settings = defaultSettings(vm.type);
        settings.date = vm.userSettings.date;

        vm.currentSettings = settings;
        $log.debug('reset settings', vm.currentSettings);

        notify.info($translate.instant('saved'));
    };
});
'use strict';

angular.module('app.controllers').controller('DashboardTasksCtrl', function ($scope, $timeout, $translate, $localStorage, $log, uiCalendarConfig, api, notify, UserService, usersOptions) {
    var vm = this;

    var defaultSettings = {
        date: moment(),
        users: [UserService.getUser().id.toString()]
    };

    $localStorage.$default({
        dashboardTasks: defaultSettings
    });

    vm.firstRender = true;
    vm.eventSources = [[]];
    vm.taskUsers = angular.copy($localStorage.dashboardTasks.users);
    vm.userOptions = usersOptions;

    $scope.$watch('DashboardTasks.taskUsers', _.debounce(function (users) {
        $log.debug('> reload list to show tasks for users: ', users);
        $localStorage.dashboardTasks.users = users;
        vm.loadList();
    }, 1000));

    var defaultDate = $localStorage.dashboardTasks.date;

    vm.uiConfig = {
        calendar: {
            header: {
                left: 'chooseDate',
                center: 'title',
                right: 'month,listMonth,agendaWeek,listWeek,agendaDay prev,next'
            },
            buttonIcons: {
                prev: 'md-left-single-arrow',
                next: 'md-right-single-arrow',
                prevYear: 'md-left-double-arrow',
                nextYear: 'md-right-double-arrow'
            },
            customButtons: {
                chooseDate: {
                    text: ' '
                }
            },
            buttonText: {
                today: ' ',
                month: ' ',
                week: ' ',
                day: ' '
            },
            locale: 'pl',
            aspectRatio: 2.1,
            defaultDate: defaultDate,
            selectable: true,
            selectHelper: true,
            select: function select(start, end) {},
            viewRender: function viewRender(view, element) {
                $log.debug("Calendar's View Changed", view);
                if (vm.firstRender) {
                    // podmiana ikony
                    $timeout(function () {
                        angular.element('.fc-chooseDate-button').html('<em class="material-icons md-24">date_range</em>');
                    });
                    // przechodzenie do wybranej daty
                    $timeout(function () {
                        var datepicker = UIkit.datepicker(angular.element('.fc-chooseDate-button .material-icons'));
                        datepicker.on('hide.uk.datepicker', function () {
                            vm.goToDate(datepicker.current.format('YYYY-MM-DD'));
                        });
                    });
                }

                if ('month' === view.name) {
                    // zapamiętujemy datę ze środka miesiąca, aby uniknać skakania
                    $localStorage.dashboardTasks.date = view.start.add(14, 'days').format('YYYY-MM-DD');
                } else {
                    $localStorage.dashboardTasks.date = view.start.format('YYYY-MM-DD');
                }

                vm.firstRender = false;
            },

            editable: true,
            eventLimit: true,
            timeFormat: '(HH)(:mm)'
        }
    };

    vm.goToDate = function (date) {
        uiCalendarConfig.calendars['tasksCalendar'].fullCalendar('gotoDate', date);
    };

    var TasksModel = api('tasks');
    vm.loadList = function () {
        var info = notify.info($translate.instant('loading'));
        notify.global(1);

        TasksModel.stop().list({ data: { users: vm.taskUsers } }).then(function (response) {
            var tasks = [];

            angular.forEach(response.data, function (task) {
                tasks.push({
                    title: task.name,
                    start: task.date_from.substr(0, 10),
                    end: task.date_to.substr(0, 10),
                    url: '/tasks/edit/' + task.id,
                    color: '#' + task.color
                });
            });

            info.close();
            notify.success($translate.instant('loaded'));
            notify.global(0);

            $timeout(function () {
                vm.eventSources[0] = tasks;
            }, 250);
        });
    };

    vm.resetSavedSettings = function () {
        $localStorage.dashboardTasks = defaultSettings;
        vm.taskUsers = $localStorage.dashboardTasks.users;

        vm.goToDate($localStorage.dashboardTasks.date);
    };
});
'use strict';

angular.module('app.controllers').controller('DictionariesListCtrl', function ($scope, $state, $translate, $timeout, notify, api, dragularService) {
    // dane
    var DictionariesModel = api('dictionaries');

    $scope.dictionaries = [];
    $scope.dirty = {};

    $scope.loadList = function () {
        var info = notify.info($translate.instant('loading'));
        notify.global(1);
        DictionariesModel.list().then(function (response) {
            $scope.dictionaries = angular.copy(response.data);
            info.close();
            notify.global(0);

            $timeout(function () {
                angular.forEach($scope.dictionaries, function (dictionary) {
                    var bag = '.dragular-' + dictionary.id;
                    $scope.dirty[dictionary.id] = false;

                    dragularService(bag, {
                        containersModel: [dictionary.items]
                    });
                });

                // odświeżamy accordion
                angular.element('.dictionaries').attr('data-uk-accordion', '{collapse: true, showfirst: false}');
                UIkit.rebuild('accordion');
            }, 250);
        });
    };
    $scope.loadList();

    $scope.addTo = function (dictionary) {
        UIkit.modal.prompt($translate.instant('dictionaries.add_instruction'), $translate.instant('new_value'), function (value) {
            dictionary.items.push({
                id: 0,
                key: '-',
                value: value
            });
            $scope.dirty[dictionary.id] = true;
            $scope.$apply();
        }, {
            labels: {
                Ok: $translate.instant('save'),
                Cancel: $translate.instant('cancel')
            }
        });
    };

    $scope.change = function (item, dictionary) {
        UIkit.modal.prompt($translate.instant('change'), item.value, function (value) {
            item.value = value;
            $scope.dirty[dictionary.id] = true;
            $scope.$apply();
        }, {
            labels: {
                Ok: $translate.instant('change'),
                Cancel: $translate.instant('cancel')
            }
        });
    };

    $scope.save = function (dictionary) {
        var info = notify.info($translate.instant('saving'));
        angular.forEach(dictionary.items, function (item, i) {
            item.order = i + 1;
        });
        DictionariesModel.save(dictionary.key, dictionary).then(function () {
            notify.success($translate.instant('saved'));
            info.close();
            DictionariesModel.clearCache();
            $scope.dirty[dictionary.id] = false;
        });
    };
});
'use strict';

angular.module('app.controllers').controller('GroupsListCtrl', function ($rootScope, $translate, notify, groupsListFilterFactory, api, formValidator, UserService, usersOptions) {
    var vm = this;

    vm.filter = groupsListFilterFactory;
    vm.usersOptions = usersOptions;
    vm.statusOptions = [{ value: 'group_active', label: $translate.instant('group_active') }, { value: 'group_inactive', label: $translate.instant('group_inactive') }, { value: 'group_deleted', label: $translate.instant('group_deleted') }];

    // dane użytkowników
    var GroupModel = api('groups');

    vm.groups = [];
    vm.loadList = function () {
        var info = notify.info($translate.instant('loading'));
        GroupModel.list().then(function (response) {
            vm.groups = response.data;
            info.close();
            notify.success($translate.instant('loaded'));
        });
    };
    vm.loadList();

    // obsługa akcji
    var user = UserService;

    vm.currentGroup = {};
    vm.editGroup = function (id) {
        vm.currentGroup = angular.extend({}, _.find(vm.groups, { id: id }) || {
            author_id: user.getUser().id,
            owner_id: user.getUser().id,
            area_id: $rootScope.$session.area.id,
            status: 'group_active'
        });
    };

    // form validation
    var fv = formValidator('#GroupForm', vm);

    vm.saveGroup = function () {
        if (!fv.isValid()) {
            return;
        }

        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        GroupModel.save(vm.currentGroup.id || 0, vm.currentGroup).then(function (response) {
            // zamiana/dodanie
            var index = _.findIndex(vm.groups, { id: vm.currentGroup.id || 0 });

            if (-1 !== index) {
                vm.groups[index] = response;
            } else {
                vm.groups.push(response);
            }

            GroupModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
        });
    };
});
'use strict';

angular.module('app.controllers').controller('MainHeaderCtrl', function ($timeout, $window, $translate, $state, UserService, api, notify, areasService, areasListForUser) {
    var vm = this;

    vm.userData = {
        user: UserService.getUser(),
        alerts: []
    };

    vm.areas = areasListForUser;
    vm.changeArea = function (newAreaId) {
        notify.global(1);
        notify.overlay(1);
        areasService.changeArea(newAreaId, true).then(function () {
            $window.location.reload();
        });
    };

    vm.logout = function () {
        UserService.logout(function () {
            $state.go('login');
        });
    };

    vm.clearCache = function () {
        UserService.getUser(true);

        var EmptyModel = api();
        EmptyModel.clearCache();
        notify.global(1);
        notify.overlay(1);
        $timeout(function () {
            $window.location.reload();
        }, 500);
    };

    $('#menu_top').children('[data-uk-dropdown]').on('show.uk.dropdown', function () {
        $timeout(function () {
            $($window).resize();
        }, 280);
    });

    // wyszukiwarka
    $timeout(function () {
        var searchInput = $('.header_main_search_input');

        searchInput.typeahead({
            highlight: false,
            hint: true,
            minLength: 2,
            classNames: {}
        }, {
            name: 'global-search',
            display: function display(record) {
                return record.value.replace(/<[^>]+>/g, '').replace(/^\s+|\s+$/g, '');
            },
            source: function source(q, sync, async) {
                var type = 'sphinx'; // db

                return $.ajax('/api/1/search/' + type + '/' + q, {
                    contentType: 'application/json'
                }).done(function (data) {
                    async(data);
                });
            },

            limit: 100,
            templates: {
                empty: ['<div class="tt-empty">', $translate.instant('filter.global_no_results'), '</div>'].join('\n'),

                suggestion: function suggestion(values) {
                    var template = '';
                    var compiled = null;

                    switch (values.type) {
                        case 'client':
                        case 'task':
                        case 'interest':
                        case 'project':
                        case 'phase':
                        case 'user':
                            values.typeTranslated = $translate.instant(values.type + 's');
                            template = '<div><u><%= typeTranslated %></u>: <%= value %></div>';
                            break;
                        default:
                            template = '<div></div>';
                            break;
                    }

                    compiled = _.template(template);
                    return compiled(values);
                }
            }
        });

        searchInput.bind('typeahead:active', function (event, data) {
            notify.overlay(1);
        });

        searchInput.bind('typeahead:open', function (event, data) {
            notify.overlay(1);
        });

        searchInput.bind('typeahead:close', function (event, data) {
            notify.overlay(0);
        });

        searchInput.bind('typeahead:asyncrequest', function (event, data) {
            notify.global(1);
            notify.overlay(1);
        });

        searchInput.bind('typeahead:asynccancel', function (event, data) {
            notify.global(0);
        });

        searchInput.bind('typeahead:render', function (event, data, a, b) {
            notify.global(0);
            notify.overlay(1);
        });

        searchInput.bind('typeahead:select', function (event, data) {
            var stateName = 'restricted.' + data.type + 's_edit';
            $state.go(stateName, { id: data.id });
        });
    });
});
'use strict';

angular.module('app.directives').directive('vpNotifications', function ($templateCache, $interpolate) {
    var template = $templateCache.get('/app/header/notifications.html');
    var interpolated = $interpolate(template)();
    var compiled = _.template(interpolated);
    var maxItems = 99;

    return {
        restrict: 'A',
        scope: {},
        bindToController: {},
        //template: '<a class="user_action_icon"><i class="material-icons md-24 md-light">notifications</i></a>',
        templateUrl: '/app/header/notifications.html',
        controllerAs: 'notifications',
        controller: function controller($interval, $state, UserService, api) {
            var vm = this;
            var notificationListModel = api('notifications/user');

            vm.notificationsLoaded = false;
            vm.notificationsCount = '-';
            vm.notifications = [];

            vm.getNotifications = function () {
                vm.notificationsLoaded = false;
                notificationListModel.get(UserService.getUser().id).then(function (response) {
                    vm.notifications = _.slice(response, 0, maxItems);
                    vm.notificationsLoaded = true;

                    vm.notificationsCount = maxItems < vm.notifications.length ? maxItems + '+' : vm.notifications.length;
                    vm.iconClassName = vm.getIconClassName();
                });
            };

            vm.getIconClassName = function () {
                switch (true) {
                    case vm.notifications.length < 5:
                        {
                            return 'uk-badge-info';
                        }
                    case vm.notifications.length < 20:
                        {
                            return 'uk-badge-warning';
                        }
                    default:
                        {
                            return 'uk-badge-danger';
                        }
                }
            };

            // sprawdzamy powiadomienia co minutę
            vm.getNotifications();
            $interval(function () {
                vm.getNotifications();
            }, 600 * 1000); // co 10 min

            vm.setNotificationAsReaded = function (id) {
                var notificationModel = api('notifications/' + id);

                notificationModel.post({
                    readed: true
                }).then(function () {
                    var i = _.findIndex(vm.notifications, { id: id });

                    if (-1 < i) {
                        vm.notifications.splice(i, 1);
                        vm.notificationsCount = maxItems < vm.notifications.length ? maxItems + '+' : vm.notifications.length;
                        notificationModel.clearCache();
                    }
                });
            };

            vm.setAllNotificationsAsReaded = function () {
                var notificationModel = api('notifications/all');

                notificationModel.post({
                    readed: true
                }).then(function () {
                    vm.notifications = [];
                    vm.notificationsCount = 0;
                    notificationModel.clearCache();
                });
            };

            vm.goTo = function (model, modelId) {
                var state = $state.get('restricted.' + model + '_edit');
                if (state) {
                    $state.go(state, { id: modelId });
                }
            };
        }
    };
});
'use strict';

angular.module('app.controllers').controller('HelpCtrl', function () {});
'use strict';

angular.module('app.controllers').controller('EditInterestCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, notify, api, formValidator, UserService, variables) {
    // dane
    var InterestModel = api('interests');

    $scope.clientOptions = [];
    $scope.projectOptions = [];

    $scope.interest = {};
    if (0 < $stateParams.id) {
        var info = notify.info($translate.instant('loading'));
        InterestModel.get($stateParams.id).then(function (response) {
            $scope.interest = response;

            $scope.clientOptions = [{
                id: $scope.interest.client_id,
                name: $scope.interest.client.name
            }];

            info.close();
            notify.success($translate.instant('loaded'));
            $rootScope.$broadcast('edit-panel-ready');
        });
    } else {
        $scope.interest = {
            id: 0,
            author_id: UserService.getUser().id,
            owner_id: UserService.getUser().id,
            manager_id: UserService.getUser().id,
            currency_id: variables.defaults.currency_id,
            status_id: variables.defaults.interest_status_id
        };

        if ($stateParams.client) {
            api('clients').get($stateParams.client).then(function (response) {
                $scope.clientOptions.push({
                    id: response.id,
                    name: response.name
                });
                $scope.interest.client_id = $stateParams.client;
            });
        }
    }

    $scope.statusOptions = [];
    api('dictionaries/interest_phases').selectize().then(function (response) {
        $scope.statusOptions = response.data;
    });

    $scope.userOptions = [];
    api('users').selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } }).then(function (response) {
        $scope.userOptions = response.data;
    });

    $scope.currencyOptions = [];
    api('dictionaries/currencies').selectize().then(function (response) {
        $scope.currencyOptions = response.data;
    });

    $scope.woodworkOptions = [];
    api('dictionaries/woodwork').selectize().then(function (response) {
        $scope.woodworkOptions = response.data;
    });

    $scope.interestLossOptions = [];
    api('dictionaries/interest_loss').selectize().then(function (response) {
        $scope.interestLossOptions = response.data;
    });

    // form validation
    var fv = formValidator('#InterestForm', $scope);

    $scope.saveInterest = function () {
        if (!fv.isValid()) {
            return;
        }

        var redirectAfterSave = 0 == $scope.interest.id;
        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        InterestModel.save($scope.interest.id, $scope.interest).then(function (response) {
            $scope.interest = response;
            InterestModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
            $rootScope.$broadcast('edit-panel-ready');

            if (redirectAfterSave) {
                $state.go('restricted.interests_edit', { id: $scope.interest.id });
            }
        });
    };

    $scope.showWhenLost = function () {
        return $scope.interest.status_id == variables.defaults.interest_loss_id;
    };

    $scope.showWhenWon = function () {
        return $scope.interest.status_id == variables.defaults.interest_win_id;
    };

    $scope.addProject = function () {
        $scope.interest.related_projects.push({});
    };

    $scope.removeProject = function (i) {
        $scope.interest.related_projects.splice(i, 1);
    };
});
'use strict';

angular.module('app.controllers').controller('InterestsCtrl', function (interestsListFilter, DataTablesFactory, interestsList) {
    var vm = this;

    vm.interests = interestsList.list;
    vm.stats = interestsList.stats;
    vm.filter = interestsListFilter;

    vm.dt = DataTablesFactory.init({
        scope: vm,
        columnDefs: [{ type: 'symbol', targets: 1 }, { type: 'value-pln', targets: 5 }, { type: 'value-pln', targets: 6 }]
    });
});
'use strict';

angular.module('app.controllers').controller('ApprovePhasesCtrl', function ($scope, $stateParams, $http, $window) {
    $scope.type = $stateParams.type;
    $scope.week = $stateParams.week;

    $scope.dateFrom = moment().week($scope.week).startOf('week');
    $scope.dateTo = moment().week($scope.week).endOf('week');

    $scope.previousWeek = $scope.dateFrom.clone().subtract(6, 'days').week();
    $scope.nextWeek = $scope.dateTo.clone().add(6, 'days').week();

    $scope.weekPhases = {};

    var loadData = function loadData() {
        $http.get('/api/1/phases/limits/get/' + $scope.type + '/' + $scope.dateFrom.format('YYYY-MM-DD')).then(function (response) {
            $scope.weekPhases = response.data;
        });
    };

    $scope.updateLockStatus = function (day, lock) {
        $http.post('/api/1/phases/limits/update-limit/' + $scope.type + '/' + day + '/' + (lock ? 1 : 0)).then(function () {
            loadData();
        });
    };

    $scope.updateApproval = function (id, status) {
        $http.post('/api/1/phases/limits/update-phase/' + id + '/' + (status ? 1 : 0)).then(function () {
            loadData();
        });
    };

    $scope.formatDay = function (day) {
        return moment(day).format('DD.MM, dddd');
    };
    $scope.isLocked = function (limit) {
        return limit === 0;
    };
    $scope.canBeChanged = function (date) {
        return date >= moment().format('YYYY-MM-DD');
    };

    loadData();
});
'use strict';

angular.module('app.controllers').controller('EditPhaseCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, $http, notify, api, formValidator, UserService, variables) {
    // dane
    var PhaseModel = api('phases');
    var ProjectModel = api('projects');

    $scope.$state = $state;

    $scope.phase = {};
    $scope.phaseOptions = [];
    $scope.isStolcadRequired = false;

    if (0 < $stateParams.id) {
        var info = notify.info($translate.instant('loading'));
        PhaseModel.get($stateParams.id).then(function (response) {
            $scope.phase = response;
            $scope.phase.symbol_code = response.project.symbol_code;
            $scope.phase.area_code = response.project.area_code;
            $scope.clientOptions = [];
            if ($scope.phase.client_id) {
                $scope.clientOptions = [{
                    id: $scope.phase.client_id,
                    name: $scope.phase.client.name
                }];
            }

            if (!$scope.phase.stands) {
                $scope.phase.stands = [];
            }
            if (!$scope.phase.dispatched_woodwork) {
                $scope.phase.dispatched_woodwork = [];
            }

            $scope.isStolcadRequired = $scope.phase.project.type === 'installation' || $scope.phase.project.type === 'service';

            $scope.loadTransportEmailLogs();

            info.close();
            notify.success($translate.instant('loaded'));
            $rootScope.$broadcast('edit-panel-ready');

            if (!$scope.phase.project) {
                notify.error($translate.instant('projects.no_project'));
                $state.go('restricted.projects');
            }

            // related phases
            api('phases').selectize({
                transform: { id: 'id', value: ':symbol :name' },
                data: { ignore: [$scope.phase.id] }
            }).then(function (response) {
                $scope.phaseOptions = response.data;
            });
        });
    } else {
        $scope.phase = {
            id: 0,
            author_id: UserService.getUser().id,
            owner_id: UserService.getUser().id,
            manager_id: UserService.getUser().id,
            status_id: variables.defaults.phase_status_started,
            currency_id: variables.defaults.currency_id,
            country_id: variables.defaults.country_id,
            date_from: moment().format('YYYY-MM-DD'),
            date_to: moment().format('YYYY-MM-DD'),
            realisation: 'unconditional',
            project: {},
            woodworks: [],
            dispatched_woodwork: [],
            stands: [],
            related: [],
            crew_ids: []
        };

        // related phases
        api('phases').selectize({
            transform: { id: 'id', value: ':symbol :name' },
            data: { ignore: [$scope.phase.id] }
        }).then(function (response) {
            $scope.phaseOptions = response.data;
        });

        ProjectModel.get($stateParams.pid).then(function (response) {
            $scope.phase.project = response;
            $scope.phase.symbol_code = response.symbol_code;
            $scope.phase.area_code = response.area_code;
            $scope.isStolcadRequired = $scope.phase.project.type === 'installation' || $scope.phase.project.type === 'service';

            var defaultCrew = 'crew_ids_' + $scope.phase.project.type;
            if (variables.defaults[defaultCrew]) {
                $scope.phase.crew_ids.push(variables.defaults[defaultCrew]);
            }

            if (!response.id) {
                $state.go('restricted.projects');
                notify.error($translate.instant('projects.no_project'));
            }
        }, function () {
            $state.go('restricted.projects');
            notify.error($translate.instant('projects.no_project'));
        });
    }

    $scope.groupOptions = [];
    api('groups').selectize({ transform: { id: 'id', value: ':name' } }).then(function (response) {
        $scope.groupOptions = response.data;
    });

    $scope.statusOptions = [];
    api('dictionaries/phase_status').selectize().then(function (response) {
        $scope.statusOptions = response.data;
    });

    $scope.carrierOptions = [];
    api('dictionaries/carriers').selectize().then(function (response) {
        $scope.carrierOptions = response.data;
    });

    $scope.gradeOptions = [];
    api('dictionaries/phase_grade').selectize().then(function (response) {
        $scope.gradeOptions = response.data;
    });

    $scope.countryOptions = [];
    api('dictionaries/countries').selectize().then(function (response) {
        $scope.countryOptions = response.data;
    });

    $scope.locationOptions = [];
    api('dictionaries/locations').selectize().then(function (response) {
        $scope.locationOptions = response.data;
    });

    $scope.currencyOptions = [];
    api('dictionaries/currencies').selectize().then(function (response) {
        $scope.currencyOptions = response.data;
    });

    $scope.vatOptions = [];
    api('dictionaries/vat').selectize().then(function (response) {
        $scope.vatOptions = response.data;
    });

    $scope.userOptions = [];
    api('users').selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } }).then(function (response) {
        $scope.userOptions = response.data;
    });

    $scope.woodworkOptions = [];
    $scope.$watch('phase.project.type', function (type) {
        api('dictionaries/woodwork').selectize().then(function (response) {
            $scope.woodworkOptions = response.data;
        });

        // uproszczony słownik
        $scope.forced_unit_id = null;
        if (type && type.length && 'installation' !== type) {
            $scope.forced_unit_id = variables.defaults.unit_piece_id;
        }
    });

    // autokorekta daty rozpoczęcia/zakończenia
    $scope.$watch('phase.date_from', function (dateValue) {
        if (dateValue) {
            var date_from = moment(dateValue);
            var date_to = moment($scope.phase.date_to);

            if (date_from.isAfter(date_to)) {
                $scope.phase.date_to = date_from.format('YYYY-MM-DD');
            }

            if (date_from < moment().format('YYYY-MM-DD') || $scope.phase.project.type !== 'transport' && $scope.phase.project.type !== 'installation') {
                $scope.phase_daily_limit = {};
                return;
            }

            $http.get('/api/1/phases/limits/check/' + $scope.phase.project.type + '/' + date_from.format('YYYY-MM-DD') + '/' + ($scope.phase.id || 0)).then(function (response) {
                $scope.phase_daily_limit = response.data;
                if (response.data.min_day_buffer) {
                    var minDate = moment().add(response.data.min_day_buffer, 'days').format('YYYY-MM-DD');
                    document.getElementById('dateFrom').dataset.ukDatepicker = "{minDate: '" + minDate + "'}";
                } else {
                    document.getElementById('dateFrom').dataset.ukDatepicker = '';
                }
            }, function () {
                $scope.phase_daily_limit = {};
            });
        }
    });
    $scope.$watch('phase.date_to', function (dateValue) {
        if (dateValue) {
            var date_to = moment(dateValue);
            var date_from = moment($scope.phase.date_from);

            if (date_to.isBefore(date_from)) {
                $scope.phase.date_from = date_to.format('YYYY-MM-DD');
            }
        }
    });

    $scope.gross = 0;
    var calculateGross = function calculateGross() {
        // @todo: refactor
        var value = parseFloat($scope.phase.value);

        var vatCond = { id: parseInt($scope.phase.vat_id) };
        var vatValue = _.find($scope.vatOptions, vatCond);

        if (vatValue) {
            var parsed = parseInt(vatValue.label) || 0;
            $scope.gross = value + value * parsed / 100;
        }
    };
    $scope.$watch('phase.value', calculateGross);
    $scope.$watch('phase.vat_id', calculateGross);

    $scope.calculations = [];
    api('areas').get('calculations').then(function (data) {
        $scope.calculations = data;
    });

    $scope.units = [];
    api('dictionaries/units').select().then(function (response) {
        $scope.units = response.data;
    });

    $scope.installationOptions = [];
    api('dictionaries/installation_type').selectize().then(function (response) {
        $scope.installationOptions = response.data;
    });

    $scope.serviceWorkOptions = [];
    api('dictionaries/service_work').selectize().then(function (response) {
        $scope.serviceWorkOptions = response.data;
    });

    $scope.serviceTypeOptions = [];
    api('dictionaries/service_type').selectize().then(function (response) {
        $scope.serviceTypeOptions = response.data;
    });

    $scope.serviceReasonOptions = [];
    api('dictionaries/service_reason').selectize().then(function (response) {
        $scope.serviceReasonOptions = response.data;
    });

    $scope.warrantyReasonOptions = [];
    api('dictionaries/warranty_reason').selectize().then(function (response) {
        $scope.warrantyReasonOptions = response.data;
    });

    $scope.transportTypeOptions = [];
    api('dictionaries/transport_type').selectize().then(function (response) {
        $scope.transportTypeOptions = response.data;
    });

    $scope.packagingMethodOptions = [];
    api('dictionaries/packaging_method').selectize().then(function (response) {
        $scope.packagingMethodOptions = response.data;
    });

    $scope.clientOptions = [];

    $scope.transportEmail = { to: '', title: '', body: '' };
    $scope.transportEmailSending = false;
    $scope.transportEmailLogs = [];
    $scope.loadTransportEmailLogs = function () {
        if (!$scope.phase || !$scope.phase.id) return;
        $http.get('/api/1/phases/' + $scope.phase.id + '/transport-emails').then(function (response) {
            $scope.transportEmailLogs = response.data || [];
        }, function () {
            $scope.transportEmailLogs = [];
        });
    };

    $scope.$watchGroup(['phase.symbol', 'calculations'], function () {
        var p = $scope.phase;

        if (!p || !p.project || !$scope.calculations) {
            return;
        }

        if (p.project.client && p.project.client.email) {
            $scope.transportEmail.to = p.project.client.email;
        }

        if (p.symbol && !$scope.transportEmail.title) {
            var stolcad = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = p.woodworks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var woodwork = _step.value;

                    var calc = $scope.calculations[woodwork.woodwork_id];
                    var unit = calc && calc.unit_id ? $scope.units[calc.unit_id] : '';
                    stolcad.push(woodwork.stolcad_number + ': ' + woodwork.value + ' ' + unit);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            console.debug('qqq', { stolcad: stolcad });
            console.debug('qqq', { p: p });

            var phone = p.manager.company_phone || p.manager.company_cellphone || p.manager.private_phone;
            $scope.transportEmail.title = $translate.instant('phases.transport_email_template_title') + p.symbol;
            $scope.transportEmail.body = $translate.instant('phases.transport_email_template_body').replace('%stolcad%', stolcad.join('\n- ')).replace('%phone%', phone || '[telefon]').replace('%date%', p.date_from || '[data]');
        }
    });

    $scope.isClosed = function () {
        return $scope.phase.status_id == variables.defaults.phase_status_closed;
    };

    // form validation
    var fv = formValidator('#PhaseForm', $scope);

    var fDetails = formValidator('#PhaseDetailsForm', $scope);

    $scope.savePhase = function () {
        if (!fv.isValid() || !fDetails.isValid()) {
            return;
        }

        if (!$scope.phase.date_to) {
            $scope.phase.date_to = $scope.phase.date_from;
        }
        $scope.phase.project_id = $scope.phase.project.id;

        var redirectAfterSave = 0 == $scope.phase.id;
        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        PhaseModel.save($scope.phase.id, $scope.phase).then(function (response) {
            $scope.phase = response;
            PhaseModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
            $rootScope.$broadcast('edit-panel-ready');

            if (redirectAfterSave) {
                $state.go('restricted.phases_edit', { id: $scope.phase.id });
            }
        });
    };

    $scope.addWoodwork = function () {
        $scope.phase.woodworks.push({});
    };

    $scope.removeWoodwork = function (i) {
        $scope.phase.woodworks.splice(i, 1);
    };

    $scope.addServiceWork = function () {
        var service_work_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var service_reason_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        $scope.phase.service_works.push({
            service_work_id: service_work_id,
            service_reason_id: service_reason_id,
            service_amount: 1,
            service_value: 0
        });
    };

    $scope.removeServiceWork = function (i) {
        $scope.phase.service_works.splice(i, 1);
    };

    $scope.addStand = function () {
        $scope.phase.stands.push({
            amount: 1,
            width: 10,
            height: 10,
            depth: 10
        });
    };

    $scope.removeStand = function (i) {
        $scope.phase.stands.splice(i, 1);
    };

    $scope.addDispatchedWoodwork = function () {
        $scope.phase.dispatched_woodwork.push({
            number: 0,
            amount: 0
        });
    };

    $scope.removeDispatchedWoodwork = function (i) {
        $scope.phase.dispatched_woodwork.splice(i, 1);
    };

    $scope.addRelated = function () {
        $scope.phase.related.push({});
    };

    $scope.removeRelated = function (i) {
        $scope.phase.related.splice(i, 1);
    };

    $scope.phase.service_works = [{}];

    $scope.sendTransportEmail = function () {
        if (!$scope.phase.id) {
            notify.danger($translate.instant('phases.transport_email_save_first'));
            return;
        }
        if (!$scope.transportEmail.to) {
            notify.danger($translate.instant('phases.transport_email_to_required'));
            return;
        }
        $scope.transportEmailSending = true;
        notify.global(1);
        $http.post('/api/1/phases/' + $scope.phase.id + '/transport-email', {
            to: $scope.transportEmail.to,
            title: $scope.transportEmail.title,
            body: $scope.transportEmail.body
        }).then(function () {
            $scope.transportEmailSending = false;
            notify.global(0);
            notify.success($translate.instant('sent'));
            $scope.loadTransportEmailLogs();
        }, function (err) {
            $scope.transportEmailSending = false;
            notify.global(0);
            notify.danger(err.data && err.data.message ? err.data.message : $translate.instant('request_error'));
        });
    };

    $scope.copyClientData = function (field) {
        notify.global(1);
        var clientId = $stateParams.client || ($scope.phase.project ? $scope.phase.project.client_id : 0);

        api('clients').get(clientId).then(function (client) {
            if (field.includes('address')) {
                var address = [client.address_name || '', client.address_street || '', (client.address_postcode || '') + ' ' + (client.address_city || '')].join('\n').replace(/\s+^|\s+$/gi, '');

                if (address) {
                    $scope.phase[field] = address;
                } else {
                    notify.danger($translate.instant('clients.copy_data_empty'));
                }
            } else if ('phone' === field) {
                var phone = (client.phone || '').replace(/\s+^|\s+$/gi, '');

                if (phone) {
                    $scope.phase.phone = phone;
                } else {
                    notify.danger($translate.instant('clients.copy_data_empty'));
                }
            }

            notify.global(0);
        });
    };
});
'use strict';

angular.module('app.controllers').controller('PhasesCtrl', function (DataTablesFactory, phasesListFilter, phasesList) {
    var vm = this;

    vm.phases = phasesList.list;
    vm.stats = phasesList.stats;
    vm.filter = phasesListFilter;

    vm.moreStats = 0;
    vm.getMoreStats = function () {
        vm.moreStats = 1;
        // todo: fetching stats
    };

    vm.dt = DataTablesFactory.init({
        scope: vm
    });
});
'use strict';

angular.module('app.controllers').controller('PrintPhasesCtrl', function ($httpParamSerializerJQLike, usersOptions, groupsOptions) {
    var vm = this;

    vm.for_who = '';
    vm.print = {
        date: moment().format('YYYY-MM-DD')
    };
    vm.types = ['measurement', 'installation', 'transport', 'service'];

    vm.groupsOptions = groupsOptions;
    vm.usersOptions = usersOptions;

    vm.getUrl = function () {
        return '/print/phases/day?' + $httpParamSerializerJQLike(vm.print);
    };
});
'use strict';

angular.module('app.controllers').controller('ShowProjectCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, notify, api, formValidator, UserService, variables) {
    // dane
    var ProjectModel = api('projects');

    $scope.clientOptions = [];
    $scope.relatedInterest = null;
    $scope.areAllPhasesClosed = true;
    $scope.project = {};
    $scope.investments = [];
    $scope.investmentOptions = [];

    api('investments').list().then(function (response) {
        $scope.investments = response.data;
    });

    $scope.$watch('project.client_id', function (client_id) {
        $scope.updateInvestments(client_id);
    });

    $scope.updateInvestments = function (client_id) {
        if (!client_id) {
            $scope.project.investment_id = 0;
            $scope.investmentOptions = [];
        } else {
            $scope.investmentOptions = $scope.investments.filter(function (investment) {
                return investment.client_id == $scope.project.client_id;
            }).map(function (investment) {
                return {
                    value: investment.id,
                    label: investment.name
                };
            });
        }
    };

    $scope.isDisabled = false;
    if (0 < $stateParams.id) {
        var info = notify.info($translate.instant('loading'));
        $scope.isDisabled = true;
        ProjectModel.get($stateParams.id).then(function (response) {
            $scope.project = response;
            $scope.relatedInterest = $scope.project.interest;

            $scope.clientOptions = [{
                id: $scope.project.client_id,
                name: $scope.project.client.name
            }];

            angular.forEach($scope.project.phases || [], function (phase) {
                if (phase.status_id != variables.defaults.phase_status_closed) {
                    $scope.areAllPhasesClosed = false;
                }
            });

            info.close();
            notify.success($translate.instant('loaded'));
            $rootScope.$broadcast('edit-panel-ready');
        });
    } else {
        $scope.project = {
            id: 0,
            type: $stateParams.type || 'measurement',
            author_id: UserService.getUser().id,
            owner_id: UserService.getUser().id,
            status_id: variables.defaults.project_status_started
        };

        if ($stateParams.client) {
            api('clients').get($stateParams.client).then(function (response) {
                $scope.clientOptions.push({
                    id: response.id,
                    name: response.name
                });
                $scope.project.client_id = $stateParams.client;
            });
        }

        if ($stateParams.interest) {
            api('interests').get($stateParams.interest).then(function (response) {
                $scope.relatedInterest = response;
                $scope.project.related_interest_id = $stateParams.interest;
            });
        }
    }

    $scope.statusOptions = [];
    api('dictionaries/project_status').selectize().then(function (response) {
        $scope.statusOptions = response.data;
    });

    // blokowanie przed zakończeniem zlecenia, jeżeli etapy nie są jeszcze gotowe
    $scope.$watch('project.status_id', function (value) {
        if (value == variables.defaults.project_status_closed && !$scope.areAllPhasesClosed) {
            $scope.project.status_id = null;
            notify.danger($translate.instant('projects.not_all_phases_ready'));
        }
    });

    $scope.typeOptions = [{ value: 'measurement', label: $translate.instant('projects.measurement') }, { value: 'installation', label: $translate.instant('projects.installation') }, { value: 'transport', label: $translate.instant('projects.transport') }, { value: 'service', label: $translate.instant('projects.service') }];

    $scope.userOptions = [];
    api('users').selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } }).then(function (response) {
        $scope.userOptions = response.data;
    });

    // form validation
    var fv = formValidator('#ProjectForm', $scope);

    $scope.saveProject = function () {
        if (!fv.isValid()) {
            return;
        }

        var redirectAfterSave = 0 == $scope.project.id;
        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        ProjectModel.save($scope.project.id, $scope.project).then(function (response) {
            $scope.project = response;
            ProjectModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
            $rootScope.$broadcast('edit-panel-ready');

            if (redirectAfterSave) {
                $state.go('restricted.projects_edit', { id: $scope.project.id });
            }
        });
    };

    $scope.showPhases = false;
    $scope.setTab = function (tab) {
        $scope.showPhases = 2 == tab;
    };
});
'use strict';

angular.module('app.controllers').controller('ProjectsCtrl', function (DataTablesFactory, projectsListFilter, projectsList) {
    var vm = this;

    vm.projects = projectsList.list;
    vm.stats = projectsList.stats;
    vm.filter = projectsListFilter;

    vm.dt = DataTablesFactory.init({
        scope: vm
    });
});
'use strict';

angular.module('app.controllers').controller('ReportsPeriodSummaryCtrl', function ($rootScope, $scope, $translate, $httpParamSerializerJQLike, api, usersOptions, groupsOptions, phaseStatusOptions) {
    var vm = this;

    vm.for_who = 'crew_id';
    vm.print = {
        date_from: moment().format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD')
    };
    vm.types = ['measurement', 'installation', 'transport', 'service'];

    vm.usersOptions = usersOptions;
    vm.groupsOptions = groupsOptions;
    vm.phaseStatusOptions = phaseStatusOptions;

    vm.getUrl = function () {
        return '/reports/download/period_summary?' + $httpParamSerializerJQLike(vm.print);
    };

    vm.clientsOptions = [];
    vm.investments = [];
    vm.investmentOptions = [];

    api('investments').list().then(function (response) {
        vm.investments = response.data;
    });

    $scope.$watch('ReportsPeriodSummary.client_id', function (client_id) {
        vm.updateInvestments(client_id);
    });
    vm.updateInvestments = function (client_id) {
        if (!client_id) {
            vm.investment_id = 0;
            vm.investmentOptions = [];
        } else {
            vm.investmentOptions = vm.investments.filter(function (investment) {
                return investment.client_id == vm.client_id;
            }).map(function (investment) {
                return {
                    value: investment.id,
                    label: investment.name
                };
            });
        }
    };

    vm.getUrl2 = function () {
        return '/reports/download/service_work?investment_id=' + vm.investment_id;
    };
});
'use strict';

angular.module('app.directives').directive('vpReminders', function () {
    return {
        restrict: 'E',

        scope: {
            task: '='
        },

        controller: function controller($scope, $timeout, $translate, $filter, notify, api, formValidator) {
            $scope.loaded = false;
            $scope.reminders = [];
            $scope.currentReminder = {};
            $scope.repeatOptions = [{ value: 'day', label: $translate.instant('reminders.day') }, { value: 'week', label: $translate.instant('reminders.week') }, { value: 'month', label: $translate.instant('reminders.month') }, { value: 'year', label: $translate.instant('reminders.year') }, { value: 'days', label: $translate.instant('reminders.days') }];

            var fv = formValidator('#ReminderForm', $scope);

            $scope.refresh = function (clearCache) {
                var path = 'reminders/task/' + ($scope.task.id || '');
                $scope.loaded = false;

                var model = api(path);

                if (clearCache) {
                    model.clearCache();
                }

                model.list().then(function (response) {
                    $scope.reminders = response.data;
                    $scope.loaded = true;
                }, function () {
                    $scope.loaded = true;
                });
            };

            $timeout(function () {
                $scope.refresh();
            });

            $scope.addReminder = function () {
                var reminderName = ($scope.task.category ? $translate.instant($scope.task.category.key) + ': ' : '') + $scope.task.name;

                $scope.currentReminder = {
                    id: 0,
                    task_id: $scope.task.id,
                    name: reminderName,
                    repeat: 'day',
                    repeat_by: 1,
                    start_from: moment().format('YYYY-MM-DD'),
                    until: moment().format('YYYY-MM-DD'),
                    at_time: '08:00'
                };
            };

            $scope.editReminder = function (id) {
                $scope.currentReminder = $filter('getById')($scope.reminders, id) || { id: 0 };
            };

            $scope.removeReminder = function (id) {
                UIkit.modal.confirm($translate.instant('sure_to_remove'), function () {
                    var info = notify.info($translate.instant('removing'));
                    notify.global(1);

                    api('reminders/delete/' + id).post({}).then(function (response) {
                        info.close();
                        notify.success($translate.instant('removed'));
                        notify.global(0);

                        $scope.refresh();
                    });
                }, {
                    labels: {
                        Ok: $translate.instant('yes'),
                        Cancel: $translate.instant('cancel')
                    }
                });
            };

            $scope.saveReminder = function () {
                if (!fv.isValid()) {
                    return;
                }

                var info = notify.info($translate.instant('saving'));
                notify.global(1);

                api('reminders').post($scope.currentReminder).then(function (response) {
                    $scope.currentReminder = response;

                    info.close();
                    notify.success($translate.instant('saved'));
                    notify.global(0);

                    $scope.refresh();
                });
            };
        },


        templateUrl: '/app/tasks/reminders.html'
    };
});
'use strict';

angular.module('app.directives').directive('vpRemindersNotify', function ($rootScope, $timeout, $interval, $compile, $templateCache, api) {
    return {
        restrict: 'E',

        scope: {
            target: '@'
        },

        link: function link(scope, element, attrs) {
            scope.showReminders = false;
            scope.reminders = [];

            scope.setupReminders = function () {
                $timeout(function () {
                    // generujemy widok
                    var html = $templateCache.get('/app/tasks/reminders_notify.html');

                    // umieszczamy na samej górze
                    angular.element(scope.target).prepend($compile(html)(scope));
                });
            };

            scope.getReminders = function () {
                var remindersModel = api('reminders');

                remindersModel.list().then(function (response) {
                    scope.reminders = response.data;
                    scope.showReminders = scope.reminders.length;
                });
            };

            scope.setReminderAsReaded = function (id) {
                var remindersModel = api('evaluated-reminders/' + id);

                remindersModel.post({
                    readed: true
                }).then(function () {
                    var i = _.findIndex(scope.reminders, { id: id });

                    if (-1 < i) {
                        scope.reminders.splice(i, 1);
                        scope.showReminders = scope.reminders.length;
                        remindersModel.clearCache();
                    }
                });
            };

            // run

            $timeout(function () {
                scope.setupReminders();
                scope.getReminders();

                // przy każdej zmianie widoku umieszczamy na jego górze
                $rootScope.$on('$stateChangeSuccess', function () {
                    scope.setupReminders();
                });

                // sprawdzamy przypomnienia co minutę
                $interval(function () {
                    scope.getReminders();
                }, 60000);
            });
        }
    };
});
'use strict';

angular.module('app.controllers').controller('EditTaskCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, notify, api, formValidator, UserService, variables, selectize) {
    // dane
    var TaskModel = api('tasks');
    $scope.about_who = 'client_id';

    $scope.clientOptions = [];
    $scope.interestOptions = [];

    var setupTask = function setupTask() {
        $scope.clientOptions = [];
        if ($scope.task.client_id) {
            $scope.clientOptions = [{
                id: $scope.task.client_id,
                name: $scope.task.client.name
            }];
            $scope.about_who = 'client_id';
        }

        $scope.interestOptions = [];
        if ($scope.task.interest_id) {
            $scope.interestOptions = [{
                id: $scope.task.interest_id,
                name: $scope.task.interest.name
            }];
            $scope.about_who = 'interest_id';
        }

        $scope.task.date_from = $scope.task.date_from.substr(0, 16);
        $scope.task.date_to = $scope.task.date_to.substr(0, 16);
    };

    $scope.task = {};
    if (0 < $stateParams.id) {
        var info = notify.info($translate.instant('loading'));
        TaskModel.get($stateParams.id).then(function (response) {
            $scope.task = response;

            setupTask();

            info.close();
            notify.success($translate.instant('loaded'));
            $rootScope.$broadcast('edit-panel-ready');
        });
    } else {
        $scope.task = {
            id: 0,
            author_id: UserService.getUser().id,
            owner_id: UserService.getUser().id,
            status_id: variables.defaults.task_status_id,
            category_id: variables.defaults.task_category_id,
            date_from: moment().format('YYYY-MM-DD 08:00'),
            date_to: moment().format('YYYY-MM-DD 08:00')
        };

        if ($stateParams.client) {
            api('clients').get($stateParams.client).then(function (response) {
                $scope.clientOptions.push({
                    id: response.id,
                    name: response.name
                });
                $scope.task.client_id = $stateParams.client;
            });
        }

        if ($stateParams.interest) {
            api('interests').get($stateParams.interest).then(function (response) {
                $scope.interestOptions.push({
                    id: response.id,
                    name: response.name
                });
                $scope.task.interest_id = $stateParams.interest;
            });
        }
    }

    $scope.writePermissions = {
        tasks__write_all: 0,
        tasks__write: [$scope.task.author_id, $scope.task.owner_id]
    };

    $scope.statusOptions = [];
    api('dictionaries/task_status').selectize().then(function (response) {
        $scope.statusOptions = response.data;
    });

    $scope.categoryOptions = [];
    api('dictionaries/task_types').selectize().then(function (response) {
        $scope.categoryOptions = response.data;
    });

    $scope.userOptions = [];
    api('users').selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } }).then(function (response) {
        $scope.userOptions = response.data;
    });

    // jedno z dwóch
    $scope.$watch('task.client_id', function (n, o) {
        if (0 < n) {
            $scope.task.interest_id = 0;
        }
    });
    $scope.$watch('task.interest_id', function (n, o) {
        if (0 < n) {
            $scope.task.client_id = 0;
        }
    });

    // autokorekta daty rozpoczęcia/zakończenia
    $scope.$watch('task.date_from', function (dateValue) {
        if (dateValue) {
            var date_from = moment(dateValue);
            var date_to = moment($scope.task.date_to);

            if (date_from.isAfter(date_to)) {
                $scope.task.date_to = date_from.format('YYYY-MM-DD HH:mm');
            }
        }
    });
    $scope.$watch('task.date_to', function (dateValue) {
        if (dateValue) {
            var date_to = moment(dateValue);
            var date_from = moment($scope.task.date_from);

            if (date_to.isBefore(date_from)) {
                $scope.task.date_from = date_to.format('YYYY-MM-DD HH:mm');
            }
        }
    });

    // form validation
    var fv = formValidator('#TaskForm', $scope);

    $scope.saveTask = function () {
        if (!fv.isValid()) {
            return;
        }

        var redirectAfterSave = 0 == $scope.task.id;
        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        TaskModel.save($scope.task.id, $scope.task).then(function (response) {
            $scope.task = response;

            setupTask();

            TaskModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
            $rootScope.$broadcast('edit-panel-ready');

            if (redirectAfterSave) {
                $state.go('restricted.tasks_edit', { id: $scope.task.id });
            }
        });
    };

    $scope.colorOptions = [{ value: 'e53935' }, { value: 'd81b60' }, { value: '8e24aa' }, { value: '5e35b1' }, { value: '3949ab' }, { value: '1e88e5' }, { value: '039be5' }, { value: '0097a7' }, { value: '00897b' }, { value: '43a047' }, { value: '689f38' }, { value: 'ef6c00' }, { value: 'f4511e' }, { value: '6d4c41' }, { value: '757575' }, { value: '546e7a' }];
    $scope.selectize_config_colors = selectize.createConfigFromDefault({
        render: {
            item: function item(_item, escape) {
                var color = '#' + _item.value;

                return '<div class="selectize-colors" style="background: ' + color + ';">&nbsp;</div>';
            },
            option: function option(item, escape) {
                var color = '#' + item.value;

                return '<div class="selectize-colors" style="background: ' + color + ';">&nbsp;</div>';
            }
        }
    });
});
'use strict';

angular.module('app.controllers').controller('TasksCtrl', function (DataTablesFactory, tasksList, tasksListFilter) {
    var vm = this;

    vm.tasks = tasksList.list;
    vm.stats = tasksList.stats;
    vm.filter = tasksListFilter;

    vm.isUnfinished = function (task) {
        return task.status_id == variables.defaults.task_unfinished_id;
    };

    vm.dt = DataTablesFactory.init({
        scope: vm
    });
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.controllers').controller('ProfileCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, $timeout, notify, api, formValidator, $localStorage, UserService) {
    $scope.statusOptions = [{ value: 'user_active', label: $translate.instant('user_active') }, { value: 'user_inactive', label: $translate.instant('user_inactive') }, { value: 'user_deleted', label: $translate.instant('user_deleted') }, { value: 'user_suspended', label: $translate.instant('user_suspended') }];

    $scope.jobOptions = [];
    api('dictionaries/jobs').selectize().then(function (response) {
        $scope.jobOptions = response.data;
    });

    // dane użytkowników
    $scope.user = {};
    var UserModel = api('users');
    var info = notify.info($translate.instant('loading'));
    UserModel.get(UserService.getUser().id).then(function (response) {
        $scope.user = response;
        if ('object' !== _typeof($scope.user.settings)) {
            $scope.user.settings = {};
        }

        angular.extend($scope.user.settings, UserService.getUser().settings || {});

        $timeout(function () {
            info.close();
            notify.success($translate.instant('loaded'));
            $rootScope.$broadcast('edit-panel-ready');
            $scope.setupPhotoUploader();
        });
    });

    var fv = formValidator('#ProfileForm', $scope);

    $scope.saveProfile = function () {
        if (!fv.isValid()) {
            return;
        }

        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        UserModel.save($scope.user.id, $scope.user).then(function (response) {
            $scope.user = response;
            // aktualizacja danych profilu
            UserService.setUser(response);
            UserModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);

            $rootScope.$broadcast('edit-panel-ready');
        });
    };

    $scope.changePassword = function () {
        if ($scope.password.one.length < 8) {
            notify.warning($translate.instant('users.password_too_easy'));
            return false;
        } else if ($scope.password.one !== $scope.password.two) {
            notify.warning($translate.instant('users.password_doesnt_match'));
            return false;
        }

        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        UserModel.post({ id: $scope.user.id, password: $scope.password.one }, { pathSuffix: '/password' }).then(function (response) {
            info.close();
            if (response.result) {
                notify.success($translate.instant('users.password_changed'));
            } else {
                notify.warning($translate.instant('request_error'));
            }
            notify.global(0);
        });
    };

    $scope.setupPhotoUploader = function () {
        $scope.photoChanged = 0;

        var settings = {
            action: '/api/1/users/$/photo'.replace('$', $scope.user.id),
            allow: '*.(jpg|jpeg|gif|png)',
            filelimit: 1,
            param: 'photo',
            single: true,
            loadstart: function loadstart() {
                notify.global(1);
            },
            progress: function progress(percent) {},
            allcomplete: function allcomplete() {
                notify.global(0);
                $scope.photoChanged++;
                $scope.user.photo = true;
            }
        };
        UIkit.uploadSelect($('#user_edit_avatar_control'), settings);
    };

    $scope.removePhoto = function () {
        notify.global(1);

        UserModel.post({}, { pathSuffix: '/$/photo'.replace('$', $scope.user.id) }).then(function () {
            notify.global(0);
            $scope.photoChanged++;
            $scope.user.photo = 0;
        });
    };

    // ustawienia
    $scope.themes = ['app_theme', 'app_theme_a', 'app_theme_b', 'app_theme_c', 'app_theme_d', 'app_theme_e', 'app_theme_f', 'app_theme_g'];

    $scope.changeTheme = function ($event, theme) {
        $event.preventDefault();
        var $this = $($event.currentTarget);

        $this.addClass('active_theme').siblings().removeClass('active_theme');

        $scope.user.settings.theme = theme.class;

        $timeout(function () {
            UserService.setupUser($scope.user.settings);
        });
    };

    $scope.$watch(function () {
        return angular.toJson($scope.user.settings);
    }, function () {
        $timeout(function () {
            UserService.setupUser($scope.user.settings);
        });
    });
});
'use strict';

angular.module('app.controllers').controller('EditUserCtrl', function ($rootScope, $state, $translate, notify, api, usersService, formValidator, areasOptions, groupsOptions, jobsOptions, userStatusOptions, userData, permissionsList) {
    var vm = this;

    vm.statusOptions = userStatusOptions;
    vm.groupsOptions = groupsOptions;
    vm.areasOptions = areasOptions;
    vm.jobsOptions = jobsOptions;
    vm.permissions = permissionsList;

    // dane użytkowników
    var UserModel = api('users');
    vm.saveUser = function () {
        if (!fv.isValid()) {
            return;
        }

        var redirectAfterSave = 0 == vm.user.id;
        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        UserModel.save(vm.user.id, vm.user).then(function (response) {
            vm.user = usersService.transform(response);
            UserModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);

            if (redirectAfterSave) {
                $state.go('restricted.users_edit', { id: vm.user.id });
            }

            $rootScope.$broadcast('edit-panel-ready');
        }, function (response) {
            info.close();
            notify.danger($translate.instant(response.error));
            notify.global(0);
        });
    };

    vm.setupPhotoUploader = function () {
        vm.photoChanged = 0;

        var settings = {
            action: '/api/1/users/$/photo'.replace('$', vm.user.id),
            allow: '*.(jpg|jpeg|gif|png)',
            filelimit: 1,
            param: 'photo',
            single: true,
            loadstart: function loadstart() {
                notify.global(1);
            },
            progress: function progress(percent) {},
            allcomplete: function allcomplete() {
                notify.global(0);
                vm.photoChanged++;
                vm.user.photo = true;
            }
        };
        UIkit.uploadSelect($('#user_edit_avatar_control'), settings);
    };

    vm.user = userData;
    vm.setupPhotoUploader();

    var fv = formValidator('#UserForm', vm);
});
'use strict';

angular.module('app.controllers').controller('UsersListCtrl', function ($rootScope, $state, $timeout, $translate, notify, api, usersListFilter, usersList) {
    var vm = this;

    // konfiguracja filtra
    vm.filter = usersListFilter;
    vm.users = _.sortBy(usersList, ['fullname']);

    vm.filter.onRefresh(function () {
        var selectorsToShow = _.filter(_.map(vm.users, listFilter)).join(',');

        jQuery('.users-list > [data-user-id]').hide();
        jQuery(selectorsToShow).show();
    });

    var listFilter = function listFilter(user) {
        if (!user) {
            return false;
        }

        var name = true;
        var status = true;
        var job_id = true;
        var group_id = true;
        var area_id = true;

        // name
        if (vm.filter.fields.filter && vm.filter.fields.filter.value) {
            var parts = vm.filter.fields.filter.value.replace(/^\s+|\s+$/g).split(/\+\s+/g);
            var regExp = new RegExp(parts.join('|'), 'i');
            var subject = [user.fullname, user.job, user.stolcad_name].join(' ');

            name = regExp.test(subject);
        }

        // job_id
        if (vm.filter.fields.job_id && _.isArray(vm.filter.fields.job_id.value) && vm.filter.fields.job_id.value.length) {
            job_id = vm.filter.fields.job_id.value.includes(user.job_id ? user.job_id.toString() : '');
        }

        // group_id
        if (vm.filter.fields.group_id && _.isArray(vm.filter.fields.group_id.value) && vm.filter.fields.group_id.value.length) {
            var userGroups = _.map(user.groups, function (group) {
                return group.id.toString();
            });

            group_id = _.intersection(userGroups, vm.filter.fields.group_id.value).length;
        }

        // area_id
        if (vm.filter.fields.area_id && _.isArray(vm.filter.fields.area_id.value) && vm.filter.fields.area_id.value.length) {
            var userAreas = _.map(user.areas, function (area) {
                return area.id.toString();
            });

            area_id = _.intersection(userAreas, vm.filter.fields.area_id.value).length;
        }

        // status
        if (vm.filter.fields.status && _.isArray(vm.filter.fields.status.value) && vm.filter.fields.status.value.length) {
            status = vm.filter.fields.status.value.includes(user.status);
        }

        return name && status && job_id && group_id && area_id ? '.users-list > [data-user-id="' + user.id + '"]' : '';
    };
});
'use strict';

angular.module('app.controllers').controller('MassEditUserCtrl', function ($scope, $stateParams, $state, $translate, notify, api) {
    $scope.statusOptions = [{ value: 'user_active', label: $translate.instant('user_active') }, { value: 'user_inactive', label: $translate.instant('user_inactive') }, { value: 'user_deleted', label: $translate.instant('user_deleted') }, { value: 'user_suspended', label: $translate.instant('user_suspended') }];

    $scope.userOptions = [];
    api('users').selectize({
        transform: {
            id: 'id',
            value: ':fullname (:job.value)'
        }
    }).then(function (response) {
        $scope.userOptions = response.data;
        $scope.users = {};
        _.map(response.data, function (user) {
            $scope.users[user.value] = user.label;
        });
    });

    $scope.jobOptions = [];
    api('dictionaries/jobs').selectize().then(function (response) {
        $scope.jobOptions = response.data;
    });

    $scope.groupOptions = [];
    api('groups').selectize({ transform: { id: 'id', value: ':name' } }).then(function (response) {
        $scope.groupOptions = response.data.sort(function (a, b) {
            return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });

        $scope.groups = {};
        _.map(response.data, function (group) {
            $scope.groups[group.value] = group.label;
        });
    });

    $scope.permissionOptions = [];
    api('dictionaries/permissions').selectize().then(function (response) {
        // budujemy
        $scope.permissionOptions = _.map(response.data, function (row) {
            var pair = row.label.split('__');
            row.label = [$translate.instant(pair[0]), $translate.instant('permissions.' + pair[1])].join(': ');

            return row;
        });

        // sortujemy
        $scope.permissionOptions = $scope.permissionOptions.sort(function (a, b) {
            return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });

        $scope.permissions = {};
        _.map(response.data, function (permission) {
            $scope.permissions[permission.value] = permission.label;
        });
    });

    $scope.changes = {};
    $scope.action_all = {};
    $scope.prm_all = {};
    $scope.grp_all = {};

    // zmiany pól wyboru - czyścimy $scope.changes
    $scope.$watch('change_users', function (nv, ov) {
        angular.forEach(_.difference(ov, nv), function (uidToRemove) {
            delete $scope.changes[uidToRemove];
        });
    });
    $scope.$watch('change_permissions', function (nv, ov) {
        angular.forEach(_.difference(ov, nv), function (pidToRemove) {
            angular.forEach($scope.change_users, function (u) {
                if ($scope.changes[u] && $scope.changes[u].permissions) {
                    delete $scope.changes[u].permissions[pidToRemove];
                }
            });
        });
    });
    $scope.$watch('change_groups', function (nv, ov) {
        angular.forEach(_.difference(ov, nv), function (gidToRemove) {
            angular.forEach($scope.change_users, function (u) {
                if ($scope.changes[u] && $scope.changes[u].groups) {
                    delete $scope.changes[u].groups[gidToRemove];
                }
            });
        });
    });

    $scope.$watch('action_all', function (nv, ov) {
        angular.forEach($scope.change_users, function (u) {
            if (!$scope.changes[u]) {
                $scope.changes[u] = {};
            }

            $scope.changes[u].action = nv;
        });
    });
    $scope.togglePerm = function (u) {
        $scope.prm_all[u] = !$scope.prm_all[u];
        angular.forEach($scope.change_permissions, function (p) {
            if (!$scope.changes[u]) {
                $scope.changes[u] = {};
            }
            if (!$scope.changes[u].permissions) {
                $scope.changes[u].permissions = {};
            }

            $scope.changes[u].permissions[p] = $scope.prm_all[u] ? p : 0;
        });
    };
    $scope.toggleGrp = function (u) {
        $scope.grp_all[u] = !$scope.grp_all[u];
        angular.forEach($scope.change_groups, function (g) {
            if (!$scope.changes[u]) {
                $scope.changes[u] = {};
            }
            if (!$scope.changes[u].groups) {
                $scope.changes[u].groups = {};
            }

            $scope.changes[u].groups[g] = $scope.grp_all[u] ? g : 0;
        });
    };

    // zapis
    $scope.saveChanges = function () {
        var info = notify.info($translate.instant('saving'));
        notify.global(1);

        api('users/mass-edit').post({ changes: $scope.changes }).then(function () {
            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
        });
    };
});
'use strict';

angular.module('app.directives').directive('vpAreaMove', function ($window, $translate, notify, api) {
    return {
        restrict: 'EA',

        scope: {
            model: '=?'
        },

        controller: function controller($scope) {
            var AreaModel = api('areas');
            $scope.step = 1;

            $scope.areaOptions = [];
            AreaModel.selectize().then(function (response) {
                $scope.areaOptions = response.data;
            });

            $scope.moveToArea = function () {
                if (1 == $scope.step) {
                    if (!$scope.area_id) {
                        notify.danger($translate.instant('areas.choose_area'));
                    } else {
                        $scope.step = 2;
                    }
                } else if (2 == $scope.step) {
                    var info = notify.info($translate.instant('saving'));
                    notify.global(1);

                    AreaModel.post({ model: $scope.model, area_id: $scope.area_id }, { pathSuffix: '/move' }).then(function (response) {
                        $scope.model.area_id = response.area_id;
                        api($scope.model._model).clearCache();

                        info.close();
                        notify.overlay(1);
                        notify.success($translate.instant('areas.moved'));
                        $window.location.hash = '';
                        $window.location.reload();
                    });
                }
            };
        },


        templateUrl: '/directives/area/area-move.html'
    };
});
'use strict';

angular.module('app.directives').directive('vpAreaReadonly', function () {
    return {
        restrict: 'EA',

        scope: {
            model: '<'
        },

        controller: function controller($scope) {},


        templateUrl: '/directives/area/area-readonly.html'
    };
});
'use strict';

angular.module('app.directives').directive('vpAreaSymbol', function ($rootScope) {
    return {
        restrict: 'E',
        scope: {},

        bindToController: {
            model: '<'
        },

        controllerAs: 'vm',

        controller: function controller() {
            var vm = this;

            vm.icon = '';
            vm.iconClass = '';
            vm.title = '';

            // moved from somewhere
            if (vm.model.previous_area_id > 0 && vm.model.previous_area_id != $rootScope.$session.area.id && vm.model.area_id == $rootScope.$session.area.id) {
                vm.icon = 'call_missed';
                vm.iconClass = 'material-icons md-success-color';
                vm.title = vm.model.previous_area.symbol + ' ' + vm.model.previous_area.name;

                // moved to somewhere
            } else if (vm.model.previous_area_id == $rootScope.$session.area.id) {
                vm.icon = 'call_missed_outgoing';
                vm.iconClass = 'material-icons md-danger-color';
                vm.title = vm.model.area.symbol + ' ' + vm.model.area.name;
            }
        },


        template: '{{ :: vm.model.area_symbol }} &nbsp; <span ng-class=":: vm.iconClass" data-uk-tooltip="{cls:\'uk-tooltip-small\',pos:\'bottom\'}" title="{{ :: vm.title }}">{{ :: vm.icon }}</span>'
    };
});
'use strict';

angular.module('app.directives').directive('addAttachment', function () {
    return {
        restrict: 'E',

        scope: {
            model: '@',
            modelId: '@',
            allow: '@?',
            addClass: '@?',
            onComplete: '&?',
            changed: '=?'
        },

        controller: function controller($scope, $timeout, $translate, notify) {
            $scope.loaded = false;

            $scope.$watch('modelId', function (modelId) {
                if (0 < modelId && !$scope.loaded) {
                    $scope.uploaderId = 'uploader_' + $scope.model + '_' + modelId;

                    $timeout(function () {
                        var progressbar = $('#' + $scope.uploaderId + '-progressbar');
                        var bar = progressbar.find('.uk-progress-bar');
                        var info = void 0;

                        var settings = {
                            action: '/api/1/attachments',
                            single: false,
                            param: 'files[]',
                            params: {
                                model: $scope.model,
                                model_id: modelId
                            },
                            allow: $scope.allow || '*.*',
                            loadstart: function loadstart() {
                                bar.css('width', '0%').text('0%');
                                progressbar.removeClass('uk-hidden');
                                notify.global(1);
                                info = notify.info($translate.instant('attachments.uploading'));
                            },
                            progress: function progress(percent) {
                                percent = Math.ceil(percent);
                                bar.css('width', percent + '%').text(percent + '%');
                            },
                            allcomplete: function allcomplete(response) {
                                bar.css('width', '100%').text('100%');
                                notify.global(0);
                                info.close();
                                notify.success($translate.instant('attachments.uploaded'));

                                $timeout(function () {
                                    progressbar.addClass('uk-hidden');
                                }, 250);

                                if ('function' === typeof $scope.onComplete) {
                                    $scope.onComplete({ response: response });
                                }
                                $scope.changed = Math.round(1 + Math.random() * 99);
                            }
                        };

                        var select = UIkit.uploadSelect(angular.element('#' + $scope.uploaderId + '-select'), settings);
                        var drop = UIkit.uploadDrop(angular.element('#' + $scope.uploaderId + '-drop'), settings);

                        $scope.loaded = true;
                    });
                }
            });

            // czekamy 2s
            $timeout(function () {
                $scope.loaded = true;
            }, 2000);
        },


        templateUrl: '/directives/attachment/add-attachment.html',
        transclude: false
    };
});
'use strict';

angular.module('app.directives').directive('attachments', function () {
    return {
        restrict: 'E',

        scope: {
            all: '@?',
            model: '@?',
            modelId: '@?',
            addClass: '@?',
            changed: '<?'
        },

        controller: function controller($scope, $timeout, $translate, notify, api) {
            $scope.loaded = false;

            $scope.iconClass = function (type) {
                var pairs = (type || '').split('/');

                if ('image' == pairs[0]) {
                    return 'fa-file-image-o';
                } else if ('audio' == pairs[0]) {
                    return 'fa-file-audio-o';
                } else if ('video' == pairs[0]) {
                    return 'fa-file-video-o';
                } else if ('application/pdf' == type) {
                    return 'fa-file-pdf-o';
                } else if ('text/plain' == type || 'text/html' == type || 'application/json' == type) {
                    return 'fa-file-text-o';
                } else if ('application/gzip' == type || 'application/zip' == type) {
                    return 'fa-file-archive-o';
                } else if ('application/octet-stream' == type) {
                    return 'fa-file-o';
                }

                return 'fa-file-o';
            };

            $scope.refresh = function (clearCache) {
                var path = ('attachments/' + ($scope.model || '') + '/' + ($scope.modelId || '')).replace(/\/+$/, '');
                $scope.loaded = false;

                var model = api(path);

                if (clearCache) {
                    model.clearCache();
                }

                model.list().then(function (response) {
                    $scope.attachments = response.data;
                    $scope.loaded = true;
                }, function () {
                    $scope.loaded = true;
                });
            };

            $scope.attachments = [];
            $scope.$watch('modelId', function (modelId) {
                if (0 < modelId && !$scope.loaded) {
                    $timeout(function () {
                        $scope.refresh();
                    });
                }
            });

            $scope.$watch('changed', function (value, old) {
                if (value != old) {
                    $scope.refresh(true);
                }
            });

            $scope.$watch('all', function (value, old) {
                if (value) {
                    $scope.refresh(true);
                }
            });

            // czekamy 3s
            $timeout(function () {
                $scope.loaded = true;
            }, 3000);

            $scope.delete = function (id) {
                var info = notify.info($translate.instant('removing'));
                api('attachments').remove(id).then(function (response) {
                    if (response.result) {
                        $scope.attachments = _.reject($scope.attachments, { id: id });
                        notify.success($translate.instant('removed'));
                    }
                });
            };
        },


        templateUrl: '/directives/attachment/attachments.html',
        transclude: false
    };
});
'use strict';

angular.module('app.directives').directive('editClientSmallLink', function () {
    return {
        restrict: 'EA',

        scope: {
            clientId: '<clientId'
        },

        templateUrl: '/directives/buttons/edit_client.html'
    };
});
'use strict';

angular.module('app.directives').directive('panelDeleteButton', function ($translate, api, notify) {
    return {
        restrict: 'E',

        scope: {
            model: '='
        },

        link: function link(scope, element, attrs) {
            scope.permissions = '';

            scope.$watch('model', function (model) {
                if (model && model.id && !scope.permissions) {
                    var modelPlural = model._model.toLowerCase() + 's';

                    scope.permissions = {};
                    scope.permissions[modelPlural + '__manage_all'] = 0;
                    scope.permissions[modelPlural + '__manage'] = _.filter([model.author_id, model.owner_id]);
                }
            });

            scope.toggleDelete = function () {
                var question = scope.model._deleted ? 'sure_to_restore' : 'sure_to_remove';
                var saving = scope.model._deleted ? 'restoring' : 'removing';
                var saved = scope.model._deleted ? 'restored' : 'removed';
                var func = scope.model._deleted ? 'restore' : 'remove';

                UIkit.modal.confirm($translate.instant(question), function () {
                    var modelPlural = scope.model._model.toLowerCase() + 's';
                    var apiModel = api(modelPlural);
                    var info = notify.info($translate.instant(saving));
                    notify.global(1);

                    apiModel[func](scope.model.id).then(function (response) {
                        scope.model = response;
                        apiModel.clearCache();

                        info.close();
                        notify.success($translate.instant(saved));
                        notify.global(0);
                    });
                }, {
                    labels: {
                        Ok: $translate.instant('yes'),
                        Cancel: $translate.instant('cancel')
                    }
                });
            };
        },


        templateUrl: '/directives/buttons/panel_delete_button.html'
    };
});
'use strict';

angular.module('app.factories').factory('DataTablesFactory', function ($templateCache, $interpolate, $timeout, $translate, notify, DTOptionsBuilder, DTColumnBuilder, variables) {
    var DataTables = {
        dtInstance: {},
        dtOptions: {},
        refreshCallback: angular.noop,
        initCallback: angular.noop
    };

    return {
        init: function init(options) {
            if (options.refreshCallback) {
                DataTables.refreshCallback = options.refreshCallback || angular.noop;
            }

            if (options.initCallback) {
                DataTables.initCallback = options.initCallback || angular.noop;
            }

            DataTables.dtOptions = DTOptionsBuilder.newOptions().withOption('stateSave', true).withPaginationType('full_numbers').withColumnFilter({}).withOption('columnDefs', options.columnDefs || {}).withOption('initComplete', function (settings) {
                var dtApi = new $.fn.dataTable.Api(settings);
                var columns = [];

                dtApi.columns().header().to$().each(function (i, th) {
                    columns.push({
                        label: th.innerText,
                        checked: dtApi.column(i).visible() ? 'checked' : ''
                    });
                });

                // @todo: refactor
                jQuery('.dt-uikit').on('click', '[data-column]', function (e) {
                    var el = jQuery(e.currentTarget);
                    var i = el.data('column');
                    var state = !dtApi.column(i).visible();

                    dtApi.column(i).visible(state);
                    el.find('input').prop('checked', state);

                    e.preventDefault();
                    e.stopPropagation();
                });

                // dodajemy listę kolumn do pokazania
                $timeout(function () {
                    var templateItem = $templateCache.get('/directives/datatables/datatables-colvis-element.html');
                    var templateList = $templateCache.get('/directives/datatables/datatables-colvis.html');
                    var interpolatedItem = $interpolate(templateItem);
                    var interpolatedList = $interpolate(templateList);
                    var list = columns.map(function (column, i) {
                        return interpolatedItem({ i: i, column: column });
                    }).join('');
                    var parent = angular.element('div.dt-custom-header');

                    if (!parent.children().length) {
                        angular.element('div.dt-custom-header').append(interpolatedList({ list: list }));
                    }
                }, 250);
            });

            return DataTables;
        },
        prepareStats: function prepareStats(source, options) {
            var defaultColors = ['#2196f3', '#e53935', '#ffa000', '#7cb342', '#bdbdbd'];

            var stats = {
                fields: {}
            };

            var fieldsToPrepare = options.fields || {};
            var callback = options.callback || null;

            fieldsToPrepare.forEach(function (field) {
                stats.fields[field] = {};
                stats.fields[field].data = source[field];

                stats.fields[field].values = _.map(source[field], function (row) {
                    return row.c;
                });

                stats.fields[field].labels = _.map(source[field], function (row) {
                    return row.value;
                });

                if (source[field].css_class) {
                    stats.fields[field].colors = _.map(source[field], function (row) {
                        var cssClassSuffix = (row.css_class || '').replace(/uk-badge-|uk-/, '');

                        return variables.colors[cssClassSuffix] || variables.colors.primary;
                    });
                } else {
                    stats.fields[field].colors = defaultColors;
                }
            });

            if (callback) {
                stats = callback(stats);
            }

            return stats;
        }
    };
});

angular.module('app.directives').directive('vpDtChartTable', function () {
    return {
        restrict: 'E',

        scope: {
            model: '=model'
        },

        controller: function controller($scope) {
            $scope.$watch('model.data', function () {
                var sum = 0;

                angular.forEach($scope.model.data, function (row) {
                    sum += parseFloat(row.c);
                });

                $scope.sum = sum;
            });
        },


        templateUrl: '/directives/datatables/datatables-chart-table.html'
    };
});

// @todo: refactor
jQuery.extend(jQuery.fn.dataTable.defaults.oLanguage, {
    sProcessing: 'Przetwarzanie...',
    sLengthMenu: 'Pokaż _MENU_ pozycji',
    sZeroRecords: 'Nie znaleziono pasujących pozycji',
    sInfoThousands: ' ',
    sInfo: 'Pozycje od _START_ do _END_ z _TOTAL_ łącznie',
    sInfoEmpty: 'Pozycji 0 z 0 dostępnych',
    sInfoFiltered: '(filtrowanie spośród _MAX_ dostępnych pozycji)',
    sInfoPostFix: '',
    sSearch: 'Szukaj:',
    sUrl: '',
    oPaginate: {
        sFirst: 'Pierwsza',
        sPrevious: 'Poprzednia',
        sNext: 'Następna',
        sLast: 'Ostatnia'
    },
    sEmptyTable: 'Brak danych',
    sLoadingRecords: 'Wczytywanie...',
    oAria: {
        sSortAscending: ': aktywuj, by posortować kolumnę rosnąco',
        sSortDescending: ': aktywuj, by posortować kolumnę malejąco'
    }
});

// error handling
jQuery.fn.dataTable.ext.errMode = function (settings, helpPage, message) {
    notify.danger($translate.instant('request_error_refresh'));
};

// sortowanie kwot
jQuery.fn.dataTable.ext.type.order['value-pln-pre'] = function (d) {
    return parseFloat(d.replace(/[^0-9]/g, ''));
};

// sortowanie symboli
jQuery.fn.dataTable.ext.type.order['symbol-pre'] = function (html) {
    var matches = html.match(/\"\>([^\s]+)\s&nbsp;/);
    var sum = 0;

    if (matches) {
        var parts = matches[1].split('/');
        var m = 1000000;

        for (var i = 0; i < parts[0].length; ++i) {
            sum += (255 - parts[0].charCodeAt(i)) * m;
            m /= 10;
        }
        sum += parseInt(parts[3]);
    }

    return sum;
};
'use strict';

angular.module('app.directives').directive('vpDateTimePicker', function () {
    return {
        restrict: 'E',

        scope: {
            model: '=',
            label: '@?',
            required: '@?'
        },

        controller: function controller($scope, $element, $window) {
            $scope.id = Math.round(1000 + Math.random() * 8999);

            // assign this event only ONCE
            if (!$window.vpDateTimePickerEventSetup) {
                $window.vpDateTimePickerEventSetup = true;

                // show tp window after dp one
                jQuery('body').on('pick.uk.datepicker', function (event) {
                    var $input = angular.element(event.target);
                    var dpId = $input.attr('id') || '';

                    // czy nasz komponent?
                    if (0 !== dpId.indexOf('vp-datepicker')) {
                        return true;
                    }

                    var selector = '#' + dpId.replace(/vp-datepicker/, 'vp-timepicker');
                    var element = angular.element(selector);

                    $window.UIkit.dropdown(element).show();
                });
            }

            $scope.$watch('model', function (nv, ov) {
                if (nv && ov && 10 === nv.length && 16 === ov.length) {
                    // zmiana daty - przywracamy czas
                    $scope.model = nv + ov.substr(10, 6);
                } else if (nv && !ov && 10 === nv.length) {
                    // zmiana daty - dodajemy domyślny czas
                    $scope.model = nv + ' 08:00';
                } else if (!nv) {
                    // brak daty - wstawiamy aktualną
                    $scope.model = moment().format('YYYY-MM-DD 08:00');
                }

                if ($scope.model && 16 === $scope.model.length) {
                    $scope.hour = $scope.model.substr(11, 2);
                    $scope.minute = $scope.model.substr(14, 2);
                }
            });

            $scope.hourOptions = [];
            $scope.hourOptions = _.map(_.range(0, 24, 1), function (hour) {
                hour = hour < 10 ? '0' + hour : hour;

                return {
                    value: hour,
                    label: hour
                };
            });

            $scope.minuteOptions = [];
            $scope.minuteOptions = _.map(_.range(0, 55, 5), function (minute) {
                minute = minute < 10 ? '0' + minute : minute;

                return {
                    value: minute,
                    label: minute
                };
            });

            $scope.$watch('hour', function (v) {
                if ($scope.model) {
                    $scope.model = $scope.model.substr(0, 11) + v + $scope.model.substr(13);
                }
            });
            $scope.hour = '08';

            $scope.$watch('minute', function (v) {
                if ($scope.model) {
                    $scope.model = $scope.model.substr(0, 14) + v + $scope.model.substr(16);
                }
            });
            $scope.minute = '00';
        },


        templateUrl: '/directives/date-time-picker/date_time_picker.html'
    };
});
'use strict';

angular.module('app.directives').directive('vpDictItem', function () {
    return {
        restrict: 'EA',

        scope: {
            cssClass: '@'
        },

        link: function link(scope) {
            scope.classes = [];

            if (scope.cssClass.includes('uk-badge')) {
                scope.classes.push('uk-badge');
            }

            scope.cssClass.split(' ').forEach(function (className) {
                scope.classes.push(className);
            });
        },


        templateUrl: '/directives/dict-item/dict-item.html',
        transclude: true
    };
});
'use strict';

angular.module('app.directives').directive('vpSimpleFilter', function ($rootScope) {
    return {
        restrict: 'EA',

        scope: {
            filter: '=model',
            noCard: '@?'
        },

        controller: function controller($scope) {
            $scope.useCard = $rootScope.isParamFalse($scope.noCard);

            $scope.fillUsing = function (name) {
                $scope.filter.fillUsing(name);
            };

            $scope.clear = function (name) {
                delete $scope.filterStorage[name];
            };

            $scope.filterStorage = $scope.filter.getStorage();
            $scope.$watch('filterStorage', function (newValue) {
                $scope.filterList = newValue['filter_' + $scope.filter.name] || {};
            }, true);
        },


        templateUrl: '/directives/filter/simple.html',
        transclude: false
    };
});

angular.module('app.directives').directive('vpSimpleFilterLoading', function () {
    return {
        restrict: 'A',

        scope: {
            filter: '<vpSimpleFilterLoading'
        },

        link: function link(scope, element, attrs) {
            var e = angular.element(element);

            scope.$watch('filter.loading', function (value) {
                if (value) {
                    e.addClass('vp-simple-filter-loading');
                } else {
                    e.removeClass('vp-simple-filter-loading');
                }
            });
        }
    };
});

angular.module('app.directives').directive('vpSimpleFilterBanner', function () {
    return {
        restrict: 'E',

        scope: {
            filter: '<model'
        },

        templateUrl: '/directives/filter/simple-banner.html'
    };
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.directives').directive('vpHistory', function ($window, $translate, $timeout, api) {
    return {
        restrict: 'EA',

        scope: {
            for: '=?',
            model: '@?',
            modelId: '@?',
            hideDates: '@?'
        },

        controller: function controller($scope) {
            $scope.loaded = false;
            $scope.history = [];

            if ('object' === _typeof($scope.for)) {
                // przekazanie obiektu
                $scope.$watch('for', function (modelData) {
                    if (modelData._model) {
                        $scope.modelData = modelData;
                        $scope.model = modelData._model;
                        $scope.modelId = modelData.id;

                        $scope.refresh();
                    }
                });
            } else {
                // przekazanie opisu obiektu
                $scope.modelData = $scope.$parent[$scope.model] || {};

                $scope.$watch('modelId', function (newValue) {
                    if (0 < newValue || 'all' === newValue) {
                        $scope.refresh();
                    }
                });
            }

            $scope.refresh = function () {
                var HistoryModel = api('history/' + $scope.model);

                HistoryModel.get($scope.modelId).then(function (data) {
                    angular.forEach(data, function (row) {
                        var isDict = row.field && '_id' === row.field.substr(-3, 3);
                        var isDate = row.field && row.field.includes('date');
                        var isSymbol = row.field && row.field.includes('code');
                        var isNumber = row.field && 0 < parseFloat(row.from_value);
                        var diff = void 0;

                        row.diff = '';
                        row.changed_at_desc = $window.timeago.format(row.changed_at);

                        // wartość słownikowa/data/liczba
                        if (isDict || isSymbol || isDate || isNumber) {
                            diff = [{ removed: true, value: row.from_value || '' }, { added: true, value: row.to_value || '' }];
                        } else {
                            diff = JsDiff.diffWordsWithSpace(row.from_value || '', row.to_value || '');
                        }

                        diff.forEach(function (part) {
                            var elCls = 'part-unchanged';
                            if (part.added) {
                                elCls = 'part-added';
                            } else if (part.removed) {
                                elCls = 'part-removed';
                            }

                            row.diff += '<span class="' + elCls + '">' + part.value + '</span>';
                        });
                    });

                    $scope.history = data;
                    $scope.loaded = true;
                });
            };
        },


        templateUrl: '/directives/history/history.html'
    };
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.directives').directive('vpLoading', function () {
    return {
        restrict: 'EA',

        scope: {
            model: '=',
            elementSelector: '@',
            addClass: '@?'
        },

        controller: function controller($window, $rootScope, $scope, $timeout, $filter) {
            $scope.show = true;
            $scope.element = null;

            if ($scope.elementSelector) {
                $scope.element = angular.element($scope.elementSelector);
            }

            $scope.$watch('show', function (newValue, oldValue) {
                if (newValue) {
                    $rootScope.content_preloader_show();
                    $scope.element && $scope.element.hide();
                    $timeout(function () {
                        $(window).trigger('resize');
                    }, 500);
                } else {
                    $rootScope.content_preloader_hide();
                    $scope.element && $scope.element.show();
                    $timeout(function () {
                        $(window).trigger('resize');
                    }, 500);
                }
            });

            if ('object' === _typeof($scope.model) && $scope.model.then) {
                $scope.model.then(function () {
                    $scope.show = false;
                });
            } else {
                $scope.$watch(function () {
                    return $filter('count')($scope.model);
                }, function (newValue, oldValue) {
                    $timeout(function () {
                        $scope.show = 0 < newValue ? false : true;
                    }, 750);
                });
            }
        }
    };
});
'use strict';

angular.module('app.directives').directive('clientPreview', function ($templateCache, $interpolate) {
    var id = 'preview_client_modal';
    var wrapper = $templateCache.get('/directives/preview/client_preview_wrapper.html');
    var template = $templateCache.get('/directives/preview/client_preview_template.html');
    var interpolated = $interpolate(template)();
    var compiled = _.template(interpolated);

    angular.element('body').append(wrapper);

    return {
        restrict: 'EA',
        scope: {},
        bindToController: {
            client: '<',
            iconClass: '@'
        },
        templateUrl: '/directives/preview/client_preview_link.html',
        controllerAs: 'clientPreview',
        controller: function controller() {
            var vm = this;

            vm.id = id;
            vm.previewClient = function () {
                var html = compiled({
                    client: vm.client || {}
                });
                document.getElementById(id).innerHTML = html;
            };
        }
    };
});
'use strict';

angular.module('app.directives').directive('interestPreview', function ($templateCache, $compile) {
    return {
        restrict: 'EA',

        scope: {
            interest: '=',
            iconClass: '@'
        },

        templateUrl: '/directives/preview/interest_preview_link.html',

        link: function link(scope, element, attrs) {
            scope.preview = {
                name: 'name',
                author_id: 'author.fullname',
                client_id: 'client.name',
                status_id: 'status.value',
                woodwork_id: 'woodwork.value',
                value: 'value'
            };

            scope.previewInterest = function ($event) {
                var html = $templateCache.get('/directives/preview/interest_preview.html');
                angular.element('#preview_interest_modal').html($compile(html)(scope));

                return true;
            };

            scope.setupTemplate = function () {
                if (angular.element('#preview_interest_wrapper').length) {
                    return true;
                }

                angular.element('body').append('<div id="preview_interest_wrapper"><div class="uk-modal" id="preview_interest_modal" aria-hidden="true"></div></div>');
            };

            scope.setupTemplate();
        }
    };
});
'use strict';

angular.module('app.directives').directive('taskPreview', function ($templateCache, $compile) {
    return {
        restrict: 'EA',

        scope: {
            task: '=',
            iconClass: '@'
        },

        templateUrl: '/directives/preview/task_preview_link.html',

        link: function link(scope, element, attrs) {
            scope.preview = [{
                field: 'name',
                value: 'name',
                cssClass: 'uk-width-1-1'
            }, {
                field: 'date_from',
                value: 'date_from'
            }, {
                field: 'date_to',
                value: 'date_to'
            }, {
                field: 'category_id',
                value: 'category.value'
            }, {
                field: 'status_id',
                value: 'status.value'
            }, {
                field: 'interest_id',
                value: 'project.name'
            }, {
                field: 'client_id',
                value: 'client.name'
            }, {
                field: 'author_id',
                value: 'author.fullname'
            }, {
                field: 'color',
                value: '',
                cssStyle: 'display: block; width: 50px; height: 18px; background-color: #' + scope.task.color
            }, {
                field: 'notes',
                value: 'notes',
                cssClass: 'uk-width-1-1'
            }];

            scope.previewTask = function ($event) {
                var html = $templateCache.get('/directives/preview/task_preview.html');
                angular.element('#preview_task_modal').html($compile(html)(scope));

                return true;
            };

            scope.setupTemplate = function () {
                if (angular.element('#preview_task_wrapper').length) {
                    return true;
                }

                angular.element('body').append('<div id="preview_task_wrapper"><div class="uk-modal" id="preview_task_modal" aria-hidden="true"></div></div>');
            };

            scope.setupTemplate();
        }
    };
});
'use strict';

angular.module('app.directives').directive('userPreview', function ($templateCache, $interpolate, $translate) {
    var id = 'preview_user_modal';
    var wrapper = $templateCache.get('/directives/preview/user_preview_wrapper.html');
    var template = $templateCache.get('/directives/preview/user_preview_template.html');
    var interpolated = $interpolate(template)();
    var compiled = _.template(interpolated);

    angular.element('body').append(wrapper);

    return {
        restrict: 'EA',
        scope: {},
        bindToController: {
            user: '<',
            iconClass: '@'
        },
        templateUrl: '/directives/preview/user_preview_link.html',
        controllerAs: 'userPreview',
        controller: function controller() {
            var vm = this;

            vm.id = id;
            vm.previewUser = function () {
                var html = compiled({
                    user: vm.user || ''
                });
                document.getElementById(id).innerHTML = html;
                document.getElementById('user-status').innerText = $translate.instant(document.getElementById('user-status').innerText);
            };
        }
    };
});
'use strict';

angular.module('app.directives').directive('vpPrintPanel', function (api) {
    return {
        restrict: 'EA',

        scope: {
            model: '@',
            modelId: '@'
        },

        templateUrl: '/directives/print-panel/print_panel.html',
        transclude: true,

        link: function link(scope, element, attrs) {
            scope.attachments = [];
            scope.selectedAttachments = [];
            scope.withAttachmentsHref = '';
            scope.loaded = false;

            scope.refresh = function (clearCache) {
                var path = ('attachments/' + (scope.model || '') + '/' + (scope.modelId || '')).replace(/\/+$/, '');
                var AttachmentsModel = api(path);

                if (clearCache) {
                    AttachmentsModel.clearCache();
                }

                scope.loaded = false;
                AttachmentsModel.list().then(function (response) {
                    // important: filter out attachments that are not PDFs
                    scope.attachments = response.data.filter(function (attachment) {
                        return attachment.as_pdf || 'pdf' === attachment.file_ext;
                    });
                    scope.loaded = true;
                }, function () {
                    scope.loaded = true;
                });
            };

            scope.generateLinkForAttachmentsDownload = function () {
                var values = scope.selectedAttachments.filter(function (element) {
                    return 0 < element;
                });

                scope.withAttachmentsHref = ['/print', scope.model, scope.modelId].join('/') + '?aid=' + values.join(',');
            };

            scope.$watch('modelId', function (value) {
                if (value) {
                    scope.refresh();
                    scope.generateLinkForAttachmentsDownload();
                }
            });

            scope.$watch(function () {
                return angular.toJson(scope.selectedAttachments);
            }, function () {
                scope.generateLinkForAttachmentsDownload();
            });
        }
    };
});
'use strict';

angular.module('app.directives').directive('vpSavePanel', function ($rootScope, $timeout) {
    return {
        restrict: 'A',

        scope: {
            model: '='
        },

        link: function link(scope, element, attrs) {
            scope.isDirty = false;
            scope.original = '';

            $rootScope.$on('edit-panel-ready', function () {
                $timeout(function () {
                    scope.original = angular.toJson(scope.model);
                    scope.isDirty = false;
                    angular.element(element).removeClass('md-accent');
                }, 250);
            });

            scope.$watch(function () {
                return angular.toJson(scope.model);
            }, function (newValue) {
                scope.isDirty = newValue !== scope.original;

                if (scope.isDirty) {
                    angular.element(element).addClass('md-accent');
                } else {
                    angular.element(element).removeClass('md-accent');
                }
            });
        }
    };
});
'use strict';

angular.module('app.factories').factory('ToastService', function ($mdToast) {
    var delay = 6000;
    var position = 'right bottom';
    var action = 'ok';

    return {
        info: function info(content) {
            return $mdToast.show($mdToast.simple().content(content).position(position).theme('info').action(action).hideDelay(delay));
        },
        success: function success(content) {
            return $mdToast.show($mdToast.simple().content(content).position(position).theme('success').action(action).hideDelay(delay));
        },
        error: function error(content) {
            return $mdToast.show($mdToast.simple().content(content).position(position).theme('error').action(action).hideDelay(delay));
        }
    };
});
'use strict';

angular.module('app.services').service('areasService', function ($rootScope, api, areas, UserService) {
    var Service = this;

    Service._model = api('areas');
    Service._areas = areas;

    Service.getAll = function () {
        return Service._areas;
    };

    Service.selectize = function () {
        return Service._model.selectize({
            transform: {
                id: 'id',
                value: 'value'
            }
        }).then(function (response) {
            return _.sortBy(response.data, 'label');
        });
    };

    Service.find = function (id) {
        var idAsInt = parseInt(id);
        var area = _.find(Service._areas, { id: idAsInt });

        if (!area) {
            return Service._model.get(idAsInt).then(function (response) {
                Service._areas.push(response);
                return response;
            });
        }

        return area;
    };

    Service.save = function (area) {
        var promise = Service._model.save(area.id, area);

        promise.then(function () {
            Service._model.clearCache();
        });

        return promise;
    };

    Service.changeArea = function (newAreaId, changeOnServer) {
        var defaultArea = 1;

        var areaId = (newAreaId || $rootScope.userAreaId || defaultArea).toString();

        var locally = function locally() {
            $rootScope.$session.area = _.find(Service._areas, function (area) {
                return area.id.toString() === areaId;
            });
        };

        if (changeOnServer) {
            return Service._model.post({
                area_id: areaId
            }, {
                pathSuffix: '/change'
            }).then(function (userData) {
                UserService.refreshData({ data: userData });
                locally();
            });
        } else {
            locally();
        }
    };

    Service.current = function () {
        return $rootScope.$session.area ? $rootScope.$session.area : { id: 1 };
    };

    Service.currentId = function () {
        return $rootScope.$session.area && $rootScope.$session.area && $rootScope.$session.area.id ? $rootScope.$session.area.id.toString() : 1;
    };
});
'use strict';

angular.module('app.services').service('clientsService', function (api) {
    var Service = this;

    Service._model = api('client');

    Service.getAll = function () {
        return Service._model.list().then(function (response) {
            return response.data;
        });
    };

    Service.getFiltered = function (values) {
        var params = {
            data: {
                filter: values
            }
        };

        return Service._model.filter(params).then(function (response) {
            return response.data;
        });
    };

    Service.selectize = function () {
        return Service._model.selectize({
            transform: {
                id: 'id',
                value: ':name'
            }
        }).then(function (response) {
            return _.sortBy(response.data, 'label');
        });
    };

    Service.find = function (id) {
        return Service._model.get(id).then(function (response) {
            return response.data;
        });
    };

    Service.findForFilter = function (id) {
        return Service._model.get(id).then(function (client) {
            return [{
                id: client.id,
                name: client.name
            }];
        });
    };

    Service.save = function (group) {
        return Service._model.post(group);
    };
});
'use strict';

angular.module('app.services').service('dictionaryItemsService', function (api) {
    var Service = this;

    Service.selectize = function (dictionaryName) {
        return api('dictionaries/' + dictionaryName).selectize().then(function (response) {
            return response.data;
        });
    };
});
'use strict';

angular.module('app.services').service('groupsService', function (api) {
    var Service = this;

    Service._model = api('groups');

    Service.getAll = function () {
        return Service._model.list().then(function (response) {
            return response.data;
        });
    };

    Service.selectize = function () {
        return Service._model.selectize({
            transform: {
                id: 'id',
                value: ':name'
            }
        }).then(function (response) {
            return _.sortBy(response.data, 'label');
        });
    };

    Service.find = function (id) {
        return Service._model.get(id).then(function (response) {
            return response.data;
        });
    };

    Service.save = function (group) {
        return Service._model.post(group);
    };
});
'use strict';

angular.module('app.services').service('interestsService', function (DataTablesFactory, api) {
    var Service = this;

    Service._model = api('interest');

    Service.getAll = function () {
        return Service._model.list().then(function (response) {
            return response.data;
        });
    };

    Service.getFiltered = function (values) {
        var params = {
            data: {
                filter: values
            }
        };

        return Service._model.filter(params).then(function (response) {
            // statystyki
            var stats = DataTablesFactory.prepareStats(response.data.stats, {
                fields: ['loss_id', 'status_id', 'woodwork_id', 'estimated', 'value']
            });

            return {
                list: response.data.data,
                stats: stats
            };
        });
    };

    Service.selectize = function () {
        return Service._model.selectize({
            transform: {
                id: 'id',
                value: ':name'
            }
        }).then(function (response) {
            return _.sortBy(response.data, 'label');
        });
    };

    Service.find = function (id) {
        return Service._model.get(id).then(function (response) {
            return response.data;
        });
    };

    Service.save = function (group) {
        return Service._model.post(group);
    };
});
'use strict';

angular.module('app.services').service('investmentsService', function (api) {
    var Service = this;

    Service._model = api('investments');

    Service.getAll = function () {
        return Service._model.list().then(function (response) {
            return response.data;
        });
    };

    Service.selectize = function () {
        return Service._model.selectize({
            transform: {
                id: 'id',
                value: ':name'
            }
        }).then(function (response) {
            return _.sortBy(response.data, 'label');
        });
    };

    Service.find = function (id) {
        return Service._model.get(id).then(function (response) {
            return response.data;
        });
    };

    Service.save = function (group) {
        return Service._model.post(group);
    };
});
'use strict';

angular.module('app.services').service('permissionsService', function ($translate, api) {
    var Service = this;

    Service._model = api('permissions');

    Service.getAll = function () {
        return Service._model.list().then(function (response) {
            // budujemy
            var permissions = _.map(response.data, function (permission) {
                var pair = permission.name.split('__');

                permission.translation = $translate.instant(pair[0]) + ': ' + $translate.instant('permissions.' + pair[1]);

                return permission;
            });

            // sortujemy
            permissions = permissions.sort(function (a, b) {
                return a.translation < b.translation ? -1 : a.translation > b.translation ? 1 : 0;
            });

            // grupujemy
            var lastGroupName = null;
            return _.map(permissions, function (permission) {
                var groupName = permission.translation.substr(0, permission.translation.indexOf(':'));

                if (null === lastGroupName || lastGroupName !== groupName) {
                    lastGroupName = groupName;
                    permission.groupName = lastGroupName;
                } else {
                    permission.groupName = '';
                }

                return permission;
            });
        });
    };
});
'use strict';

angular.module('app.services').service('phasesService', function ($translate, DataTablesFactory, variables, api) {
    var Service = this;

    Service._model = api('phase');

    Service.getAll = function () {
        return Service._model.list().then(function (response) {
            return response.data;
        });
    };

    Service.getFiltered = function (values) {
        var params = {
            data: {
                filter: values
            }
        };

        return Service._model.filter(params).then(function (response) {
            // tłumaczenie typów projektów
            response.data.stats.type = _.map(response.data.stats.type, function (row) {
                row.value = $translate.instant('projects.' + row.value);

                return row;
            });

            // statystyki
            var stats = DataTablesFactory.prepareStats(response.data.stats, {
                fields: ['status_id', 'type', 'service_work_id', 'service_type_id', 'transport_type_id', 'packaging_method_id'],
                callback: function callback(stats) {
                    // colors
                    var types = ['measurement', 'installation', 'transport', 'service'];
                    stats.fields['type'].colors = _.map(stats.fields['type'].data, function (row) {
                        var map = {};
                        angular.forEach(types, function (type) {
                            map[$translate.instant('projects.' + type)] = variables.colors[type];
                        });

                        return map[row.value] || variables.colors.primary;
                    });

                    return stats;
                }
            });

            return {
                list: response.data.data,
                stats: stats
            };
        });
    };

    Service.selectize = function () {
        return Service._model.selectize({
            transform: {
                id: 'id',
                value: ':name'
            }
        }).then(function (response) {
            return _.sortBy(response.data, 'label');
        });
    };

    Service.find = function (id) {
        return Service._model.get(id).then(function (response) {
            return response.data;
        });
    };

    Service.save = function (group) {
        return Service._model.post(group);
    };
});
'use strict';

angular.module('app.services').service('projectsService', function ($translate, DataTablesFactory, variables, api) {
    var Service = this;

    Service._model = api('project');

    Service.getAll = function () {
        return Service._model.list().then(function (response) {
            return response.data;
        });
    };

    Service.getFiltered = function (values) {
        var params = {
            data: {
                filter: values
            }
        };

        return Service._model.filter(params).then(function (response) {
            // tłumaczenie typów projektów
            response.data.stats.type = _.map(response.data.stats.type, function (row) {
                row.value = $translate.instant('projects.' + row.value);

                return row;
            });

            // statystyki
            var stats = DataTablesFactory.prepareStats(response.data.stats, {
                fields: ['status_id', 'type'],
                callback: function callback(stats) {
                    // colors
                    var types = ['measurement', 'installation', 'transport', 'service'];
                    stats.fields['type'].colors = _.map(stats.fields['type'].data, function (row) {
                        var map = {};
                        angular.forEach(types, function (type) {
                            map[$translate.instant('projects.' + type)] = variables.colors[type];
                        });

                        return map[row.value] || variables.colors.primary;
                    });

                    return stats;
                }
            });

            return {
                list: response.data.data,
                stats: stats
            };
        });
    };

    Service.selectize = function () {
        return Service._model.selectize({
            transform: {
                id: 'id',
                value: ':name'
            }
        }).then(function (response) {
            return _.sortBy(response.data, 'label');
        });
    };

    Service.find = function (id) {
        return Service._model.get(id).then(function (response) {
            return response.data;
        });
    };

    Service.save = function (group) {
        return Service._model.post(group);
    };
});
'use strict';

angular.module('app.services').service('tasksService', function (DataTablesFactory, api) {
    var Service = this;

    Service._model = api('task');

    Service.getAll = function () {
        return Service._model.list().then(function (response) {
            return response.data;
        });
    };

    Service.getFiltered = function (values) {
        var params = {
            data: {
                filter: values
            }
        };

        return Service._model.filter(params).then(function (response) {
            // statystyki
            var stats = DataTablesFactory.prepareStats(response.data.stats, {
                fields: ['category_id', 'status_id']
            });

            return {
                list: response.data.data,
                stats: stats
            };
        });
    };

    Service.selectize = function () {
        return Service._model.selectize({
            transform: {
                id: 'id',
                value: ':name'
            }
        }).then(function (response) {
            return _.sortBy(response.data, 'label');
        });
    };

    Service.find = function (id) {
        return Service._model.get(id).then(function (response) {
            return response.data;
        });
    };

    Service.save = function (group) {
        return Service._model.post(group);
    };
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.services').service('usersService', function (api) {
    var _this = this;

    var Service = this;

    var array_combine = function array_combine(keys, values) {
        var result = {};

        if ('object' !== (typeof keys === 'undefined' ? 'undefined' : _typeof(keys)) || 'object' !== (typeof values === 'undefined' ? 'undefined' : _typeof(values)) || !keys.length || keys.length !== values.length) {
            return {};
        }

        for (var i = 0; i < keys.length; ++i) {
            result[keys[i]] = values[i];
        }

        return result;
    };

    Service._model = api('users');

    Service.getAll = function () {
        return Service._model.list().then(function (response) {
            return response.data;
        });
    };

    Service.selectize = function (userOptions) {
        var defaultOptions = {
            data: {
                all: 0
            },
            transform: {
                id: 'id',
                value: ':fullname (:job.value)',
                area_id: 'area_id'
            }
        };

        var options = angular.extend({}, defaultOptions, userOptions);

        return Service._model.selectize(options).then(function (response) {
            return response.data;
        });
    };

    Service.find = function (id) {
        return Service._model.get(id).then(_this.transform);
    };

    Service.transform = function (userData) {
        userData.permissions_id = array_combine(userData.permissions_id, userData.permissions_id);
        userData.groups_id = array_combine(userData.groups_id, userData.groups_id);

        return userData;
    };

    Service.save = function (user) {
        return Service._model.post(user);
    };
});
'use strict';

angular.module('app.factories').factory('clientsListFilterFactory', function ($translate, $state, $log, listFilter) {
    var clientsListFilter = listFilter;

    clientsListFilter.setAttributes({
        name: 'clientsListFilter',
        providers: ['usersOptions']
    }).setFields({
        filter: {
            type: 'text',
            class: 'uk-width-medium-10-10',
            label: $translate.instant('search'),
            default: ''
        },
        search_in: {
            type: 'checkbox-list',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('search_in'),
            names: [{ name: 'name', label: $translate.instant('clients.name') }, { name: 'nip', label: $translate.instant('clients.nip') }, { name: 'email', label: $translate.instant('clients.email') }, { name: 'address_city', label: $translate.instant('clients.address_city') }],
            default: { name: true }
        },
        author_id: {
            type: 'multiuserlist',
            operator: 'in',
            class: 'uk-width-medium-6-10',
            label: $translate.instant('clients.author_id'),
            optionsProvider: 'usersOptions',
            options: [],
            default: ''
        }
    }).onRefresh(function () {
        var filterParams = clientsListFilter.getValues(true);
        $log.debug('--> apply filter', filterParams);
        $state.applyFilter(filterParams);
    }).ready();

    return clientsListFilter;
});
'use strict';

angular.module('app.factories').factory('groupsListFilterFactory', function ($translate, $state, $log, listFilter) {
    var groupsListFilter = listFilter;

    groupsListFilter.setAttributes({
        extendByDates: false,
        name: 'groupsListFilter',
        providers: []
    }).setFields({
        filter: {
            type: 'text',
            class: 'uk-width-medium-3-4',
            label: $translate.instant('search'),
            default: ''
        },
        reset: {
            type: 'reset',
            class: 'uk-width-medium-1-4'
        }
    }).listFilter = function (group) {
        if (!group || !groupsListFilter.fields.filter.value) {
            return true;
        }

        var parts = groupsListFilter.fields.filter.value.split('+');
        var regExp = new RegExp(parts.join('|'), 'i');
        var subject = [group.name, group.description, group.owner.fullname].join(' ');

        return regExp.test(subject);
    };

    return groupsListFilter;
});
'use strict';

angular.module('app.factories').factory('interestsListFilterFactory', function ($translate, $state, $log, listFilter) {
    var interestsListFilter = listFilter;

    interestsListFilter.setAttributes({
        name: 'interestsListFilter',
        providers: ['filterAreasOptions', 'usersOptions', 'interestStatusOptions', 'lossOptions', 'clientOptionsForInterestFilter']
    }).setFields({
        filter: {
            type: 'text',
            class: 'uk-width-medium-6-10',
            label: $translate.instant('search'),
            default: ''
        },
        search_in: {
            type: 'checkbox-list',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('search_in'),
            names: [{ name: 'name', label: $translate.instant('interests.name') }, { name: 'client.name', label: $translate.instant('interests.client_id') }, { name: 'description', label: $translate.instant('interests.description') }, { name: 'notes', label: $translate.instant('interests.notes') }],
            default: { name: true }
        },

        area: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-10-10',
            label: $translate.instant('areas'),
            default: '',
            optionsProvider: 'filterAreasOptions',
            options: []
        },

        date_from: {
            type: 'date',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('filter.date_from')
        },
        date_to: {
            type: 'date',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('filter.date_to')
        },

        author_id: {
            type: 'multiuserlist',
            operator: 'in',
            class: 'uk-width-medium-3-10',
            label: $translate.instant('interests.author_id'),
            optionsProvider: 'usersOptions',
            options: [],
            default: ''
        },
        manager_id: {
            type: 'multiuserlist',
            operator: 'in',
            class: 'uk-width-medium-3-10',
            label: $translate.instant('interests.manager_id'),
            optionsProvider: 'usersOptions',
            options: [],
            default: ''
        },
        owner_id: {
            type: 'multiuserlist',
            operator: 'in',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('interests.owner_id'),
            optionsProvider: 'usersOptions',
            options: [],
            default: ''
        },

        status_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-3-10',
            label: $translate.instant('interests.status_id'),
            optionsProvider: 'interestStatusOptions',
            options: [],
            default: ''
        },
        loss_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-3-10',
            label: $translate.instant('interests.loss_id'),
            optionsProvider: 'lossOptions',
            options: [],
            default: ''
        },
        client_id: {
            type: 'clientslist',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('projects.client_id'),
            optionsProvider: 'clientOptionsForInterestFilter',
            options: [],
            default: ''
        }
    }).onRefresh(function () {
        var filterParams = interestsListFilter.getValues(true);
        interestsListFilter.updateClientsOptions('client_id');
        $log.debug('--> apply filter', filterParams);
        $state.applyFilter(filterParams);
    }).ready();

    return interestsListFilter;
});
'use strict';

angular.module('app.factories').factory('investmentsListFilterFactory', function ($translate, $state, $log, listFilter) {
    var investmentsListFilter = listFilter;

    investmentsListFilter.setAttributes({
        extendByDates: false,
        name: 'investmentsListFilter',
        providers: []
    }).setFields({
        filter: {
            type: 'text',
            class: 'uk-width-medium-3-4',
            label: $translate.instant('search'),
            default: ''
        },
        reset: {
            type: 'reset',
            class: 'uk-width-medium-1-4'
        }
    }).listFilter = function (investment) {
        if (!investment || !investmentsListFilter.fields.filter.value) {
            return true;
        }

        var parts = investmentsListFilter.fields.filter.value.split('+');
        var regExp = new RegExp(parts.join('|'), 'i');
        var subject = [investment.name, investment.description, investment.client.name].join(' ');

        return regExp.test(subject);
    };

    return investmentsListFilter;
});
'use strict';

angular.module('app.factories').factory('phasesListFilterFactory', function ($translate, $state, $log, listFilter) {
    var phasesListFilter = listFilter;

    phasesListFilter.setAttributes({
        name: 'phasesListFilter',
        providers: ['usersOptions', 'phaseStatusOptions', 'projectTypeOptions', 'serviceWorkOptions', 'serviceTypeOptions', 'transportTypeOptions', 'packagingMethodOptions', 'clientOptionsForPhasesFilter', 'locationOptions', 'countryOptions']
    }).setFields({
        // row 1
        filter: {
            type: 'text',
            class: 'uk-width-medium-6-10',
            label: $translate.instant('search'),
            default: ''
        },
        search_in: {
            type: 'checkbox-list',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('search_in'),
            names: [{ name: 'name', label: $translate.instant('phases.name') }, { name: 'symbol', label: $translate.instant('phases.symbol') }, { name: 'client.name', label: $translate.instant('phases.client_id') }],
            default: { name: true }
        },

        // row 2
        owner_id: {
            type: 'multiuserlist',
            operator: 'in',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('phases.owner_id'),
            optionsProvider: 'usersOptions',
            options: [],
            default: ''
        },
        manager_id: {
            type: 'multiuserlist',
            operator: 'in',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('phases.manager_id'),
            optionsProvider: 'usersOptions',
            options: [],
            default: ''
        },
        status_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-2-10',
            label: $translate.instant('phases.status_id'),
            optionsProvider: 'phaseStatusOptions',
            options: [],
            default: ''
        },

        // row 3
        'project.type': {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('phases.type'),
            maxItems: 4,
            optionsProvider: 'projectTypeOptions',
            options: [],
            default: ''
        },
        'project.client_id': {
            type: 'clientslist',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('phases.client_id'),
            optionsProvider: 'clientOptionsForPhasesFilter',
            options: [],
            operator: '=',
            default: ''
        },

        // row 4
        date_from: {
            type: 'date',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('phases.date_from')
        },
        date_to: {
            type: 'date',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('phases.date_to')
        },

        // row 5
        service_work_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-1-4',
            label: $translate.instant('phases.service_work_id'),
            optionsProvider: 'serviceWorkOptions',
            options: [],
            default: ''
        },
        service_type_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-1-4',
            label: $translate.instant('phases.service_type_id'),
            optionsProvider: 'serviceTypeOptions',
            options: [],
            default: ''
        },
        transport_type_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-1-4',
            label: $translate.instant('phases.transport_type_id'),
            optionsProvider: 'transportTypeOptions',
            options: [],
            default: ''
        },
        packaging_method_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-1-4',
            label: $translate.instant('phases.packaging_method_id'),
            optionsProvider: 'packagingMethodOptions',
            options: [],
            default: ''
        },
        // row 6
        location_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-1-2',
            label: $translate.instant('phases.location_id'),
            optionsProvider: 'locationOptions',
            options: [],
            default: ''
        },
        country_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-1-2',
            label: $translate.instant('phases.country_id'),
            optionsProvider: 'countryOptions',
            options: [],
            default: ''
        }
    }).onRefresh(function () {
        var filterParams = phasesListFilter.getValues(true);
        phasesListFilter.updateClientsOptions('project.client_id');
        $log.debug('--> apply filter', filterParams);
        $state.applyFilter(filterParams);
    }).ready();

    return phasesListFilter;
});
'use strict';

angular.module('app.factories').factory('projectsListFilterFactory', function ($translate, $state, $log, listFilter) {
    var projectsListFilter = listFilter;

    projectsListFilter.setAttributes({
        name: 'projectsListFilter',
        providers: ['filterAreasOptions', 'projectTypeOptions', 'projectStatusOptions', 'usersOptions', 'clientOptionsForProjectsFilter', 'investmentOptionsForProjectsFilter']
    }).setFields({
        // row 1
        filter: {
            type: 'text',
            class: 'uk-width-medium-6-10',
            label: $translate.instant('search'),
            default: ''
        },
        search_in: {
            type: 'checkbox-list',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('search_in'),
            names: [{ name: 'name', label: $translate.instant('projects.name') }, { name: 'symbol', label: $translate.instant('projects.symbol') }, { name: 'client.name', label: $translate.instant('projects.client_id') }, { name: 'description', label: $translate.instant('projects.notes') }],
            default: { name: true }
        },

        // row 2
        area: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('areas'),
            optionsProvider: 'filterAreasOptions',
            options: [],
            default: ''
        },
        type: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('projects.type'),
            maxItems: 4,
            optionsProvider: 'projectTypeOptions',
            options: [],
            default: ''
        },

        // row 3
        status_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('projects.status_id'),
            optionsProvider: 'projectStatusOptions',
            options: [],
            default: ''
        },
        owner_id: {
            type: 'multiuserlist',
            operator: 'in',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('projects.owner_id'),
            optionsProvider: 'usersOptions',
            options: [],
            default: ''
        },

        // row 4
        client_id: {
            type: 'clientslist',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('projects.client_id'),
            optionsProvider: 'clientOptionsForProjectsFilter',
            options: [],
            default: ''
        },
        investment_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-5-10',
            label: $translate.instant('projects.investment_id'),
            optionsProvider: 'investmentOptionsForProjectsFilter',
            options: [],
            default: ''
        }
    }).onRefresh(function () {
        var filterParams = projectsListFilter.getValues(true);
        projectsListFilter.updateClientsOptions('client_id');
        $log.debug('--> apply filter', filterParams);
        $state.applyFilter(filterParams);
    }).ready();

    return projectsListFilter;
});
'use strict';

angular.module('app.factories').factory('tasksListFilterFactory', function ($translate, $state, $log, listFilter) {
    var tasksListFilter = listFilter;

    tasksListFilter.setAttributes({
        name: 'tasksListFilter',
        providers: ['filterAreasOptions', 'categoryOptions', 'taskStatusOptions', 'usersOptions']
    }).setFields({
        // row 1
        filter: {
            type: 'text',
            class: 'uk-width-medium-6-10',
            label: $translate.instant('search'),
            default: ''
        },
        search_in: {
            type: 'checkbox-list',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('search_in'),
            names: [{ name: 'name', label: $translate.instant('tasks.name') }, { name: 'interest.name', label: $translate.instant('tasks.interest_id') }, { name: 'client.name', label: $translate.instant('tasks.client_id') }, { name: 'notes', label: $translate.instant('tasks.notes') }],
            default: { name: true }
        },

        // row 2
        area: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-10-10',
            label: $translate.instant('areas'),
            optionsProvider: 'filterAreasOptions',
            options: [],
            default: ''
        },

        // row 3
        date_from: {
            type: 'date',
            class: 'uk-width-medium-3-10',
            label: $translate.instant('filter.date_from')
        },
        date_to: {
            type: 'date',
            class: 'uk-width-medium-3-10',
            label: $translate.instant('filter.date_to')
        },
        category_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('tasks.category_id'),
            optionsProvider: 'categoryOptions',
            options: [],
            default: ''
        },

        // row 4
        status_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-4-10',
            label: $translate.instant('tasks.status_id'),
            optionsProvider: 'taskStatusOptions',
            options: [],
            default: ''
        },
        author_id: {
            type: 'multiuserlist',
            operator: 'in',
            class: 'uk-width-medium-3-10',
            label: $translate.instant('tasks.author_id'),
            optionsProvider: 'usersOptions',
            options: [],
            default: ''
        },
        owner_id: {
            type: 'multiuserlist',
            operator: 'in',
            class: 'uk-width-medium-3-10',
            label: $translate.instant('tasks.owner_id'),
            optionsProvider: 'usersOptions',
            options: [],
            default: ''
        }
    }).onRefresh(function () {
        var filterParams = tasksListFilter.getValues(true);
        $log.debug('--> apply filter', filterParams);
        $state.applyFilter(filterParams);
    }).ready();

    return tasksListFilter;
});
'use strict';

angular.module('app.factories').factory('usersListFilterFactory', function ($rootScope, $translate, $state, $log, listFilter, areasService) {
    var usersListFilter = listFilter;

    usersListFilter.setAttributes({
        extendByDates: false,
        name: 'usersListFilter',
        providers: ['jobsOptions', 'areasOptions', 'groupsOptions', 'userStatusOptions']
    }).setFields({
        filter: {
            type: 'text',
            class: 'uk-width-medium-3-5',
            label: $translate.instant('search'),
            default: ''
        },
        area_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-2-5',
            label: $translate.instant('areas'),
            optionsProvider: 'areasOptions',
            options: [],
            default: [areasService.currentId()]
        },
        group_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-1-4',
            label: $translate.instant('users.groups'),
            optionsProvider: 'groupsOptions',
            options: [],
            default: ''
        },
        job_id: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-1-4',
            label: $translate.instant('users.job_id'),
            optionsProvider: 'jobsOptions',
            options: [],
            default: ''
        },
        status: {
            type: 'multilist',
            operator: 'in',
            class: 'uk-width-medium-1-4',
            label: $translate.instant('users.status'),
            optionsProvider: 'userStatusOptions',
            options: [],
            default: ''
        },
        reset: {
            type: 'reset',
            class: 'uk-width-medium-1-4'
        }
    });

    return usersListFilter;
});
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.factories').factory('listFilter', function ($q, $injector, $localStorage, $translate, $stateParams, $timeout, $log, clientsService, routeResolver, notify, variables) {
    var filter = {
        name: 'simpleFilter',
        visible: false,
        active: false,
        extendByDates: true,
        fields: {},
        saveLastConfig: true,
        currentConfigName: '',
        lastChange: 0,
        changeCallback: angular.noop,
        refreshCallback: angular.noop,
        showStats: !variables.mobileMode,
        providers: [],

        isVisible: function isVisible() {
            return filter.visible;
        },
        isActive: function isActive(check) {
            if ('undefined' !== typeof check && check) {
                var active = false;
                var ignore = ['changed'];

                angular.forEach(filter.fields, function (field, name) {
                    if (ignore.includes(name)) {
                        return false;
                    }

                    if (_typeof(field.value) !== 'object' && field.value && field.value != field.default) {
                        active = true;
                        return true;
                    }
                });
                filter.active = active;
            }

            return filter.active;
        },
        setName: function setName(name) {
            filter.name = name;

            return filter;
        },
        setAttributes: function setAttributes(attributes) {
            angular.forEach(attributes, function (value, name) {
                if (filter.hasOwnProperty(name)) {
                    filter[name] = value;
                }
            });

            return filter;
        },
        setFields: function setFields(fields) {
            filter.fields = fields;

            angular.extend(filter.fields, {
                changed: {
                    type: 'hidden'
                }
            });

            // przygotowujemy pola
            angular.forEach(filter.fields, function (properties, field) {
                if ('checkbox-list' == properties.type) {
                    properties.value = {};

                    angular.forEach(properties.names, function (checkbox) {
                        properties.value[checkbox.name] = properties.value[checkbox.name] || properties.default[checkbox.name] || '0';
                    });
                } else {
                    properties.value = properties.value || properties.default || '';
                }
            });

            if (filter.extendByDates) {
                angular.extend(filter.fields, {
                    created_at_from: {
                        type: 'date',
                        class: 'uk-width-medium-1-4',
                        label: $translate.instant('filter.created_at_from')
                    },
                    created_at_to: {
                        type: 'date',
                        class: 'uk-width-medium-1-4',
                        label: $translate.instant('filter.created_at_to')
                    },
                    updated_at_from: {
                        type: 'date',
                        class: 'uk-width-medium-1-4',
                        label: $translate.instant('filter.updated_at_from')
                    },
                    updated_at_to: {
                        type: 'date',
                        class: 'uk-width-medium-1-4',
                        label: $translate.instant('filter.updated_at_to')
                    },
                    deleted_at_from: {
                        type: 'date',
                        class: 'uk-width-medium-1-4',
                        label: $translate.instant('filter.deleted_at_from')
                    },
                    deleted_at_to: {
                        type: 'date',
                        class: 'uk-width-medium-1-4',
                        label: $translate.instant('filter.deleted_at_to')
                    },
                    with_deleted: {
                        type: 'list',
                        class: 'uk-width-medium-1-4',
                        label: $translate.instant('filter.with_deleted'),
                        options: [{ value: 'none', label: $translate.instant('filter.with_deleted_none') }, { value: 'also', label: $translate.instant('filter.with_deleted_also') }, { value: 'only', label: $translate.instant('filter.with_deleted_only') }],
                        value: ''
                    },
                    limit: {
                        type: 'list',
                        class: 'uk-width-medium-1-4',
                        label: $translate.instant('filter.max_results'),
                        options: [{ value: 10, label: 10 }, { value: 30, label: 30 }, { value: 50, label: 50 }, { value: 100, label: 100 }, { value: 150, label: 150 }, { value: 200, label: 200 }, { value: 300, label: 300 }, { value: 500, label: 500 }],
                        default: variables.mobileMode ? 10 : 30
                    },
                    reset: {
                        type: 'reset',
                        class: 'uk-width-medium-1-1'
                    }
                });
            }

            return filter;
        },
        toggle: function toggle(state) {
            if ('undefined' === typeof state) {
                state = !filter.visible;
            }

            filter.visible = state;

            return filter;
        },
        clear: function clear(refresh) {
            angular.forEach(filter.fields, function (field) {
                field.value = field.default || '';
            });
            filter.active = false;

            if ('undefined' !== typeof refresh && refresh) {
                filter.refresh();
            }

            return filter;
        },
        refresh: function refresh() {
            filter.fields.changed.value = moment().format('x');

            if (filter.saveLastConfig) {
                filter.autosave();
            }

            $timeout(function () {
                $log.debug('filter.refresh: ' + filter.name);
                filter.refreshCallback();
            }, 250);

            return filter;
        },
        changed: function changed() {
            filter.changeCallback();

            if (filter.saveLastConfig) {
                filter.autosave();
            }

            filter.isActive(true);
            filter.lastChange = moment().format('x');

            return filter;
        },
        autosave: function autosave(rowName) {
            var data = {};
            var name = rowName || $translate.instant('filter.last_used');
            var storage = filter.getStorage();

            angular.forEach(filter.fields, function (attributes, field) {
                if ('undefined' !== typeof attributes.value) {
                    data[field] = attributes.value;
                }
            });

            $log.debug('autosaved filter: ' + name, data);
            storage[name] = data;

            return filter;
        },
        save: function save() {
            UIkit.modal.prompt($translate.instant('filter.name'), '', function (filterName) {
                filter.autosave(filterName);
                notify.success($translate.instant('filter.saved'));
            });

            return filter;
        },
        getStorage: function getStorage() {
            var cacheKey = 'filter_' + filter.name;

            if ('object' !== _typeof($localStorage[cacheKey])) {
                $localStorage[cacheKey] = {};
            }

            return $localStorage[cacheKey];
        },
        onChange: function onChange(callback) {
            filter.changeCallback = callback;

            return filter;
        },
        onRefresh: function onRefresh(callback) {
            filter.refreshCallback = callback;

            return filter;
        },
        getValues: function getValues(strict) {
            var fields = {};

            angular.forEach(filter.fields, function (field, name) {
                if (strict) {
                    if (field.value !== field.default) {
                        fields[name] = field.value || '';
                    }
                } else {
                    fields[name] = {
                        operator: field.operator || 'like',
                        value: field.value || ''
                    };
                }
            });
            $log.debug('get values: strict? ', strict ? 'yes' : 'no', fields);

            return fields;
        },
        fieldId: function fieldId(fieldName) {
            return 'vpsf_' + filter.name + '_' + fieldName;
        },
        prefill: function prefill() {
            // 1. $stateParams
            if (Object.keys($stateParams.filter || {}).length) {
                $log.debug('prefilled with params: ', $stateParams.filter);
                return filter.fillWithValues($stateParams.filter);
            }

            // 2. last used config
            var filterName = $translate.instant('filter.last_used');
            filter.fillUsing(filterName);
            $log.debug('prefilled with filter: ' + filterName, filter.getValues());

            return filter;
        },
        fillUsing: function fillUsing(filterName) {
            var storage = filter.getStorage();

            if (!angular.isUndefined(storage[filterName])) {
                angular.forEach(storage[filterName], function (value, fieldName) {
                    if (filter.fields[fieldName]) {
                        filter.fields[fieldName].value = value;
                    }
                });
                filter.currentConfigName = filterName;
            }

            filter.isActive(true);

            return filter;
        },
        fillWithValues: function fillWithValues(filterData) {
            angular.forEach(filterData, function (value, name) {
                if ('object' === _typeof(filter.fields[name])) {
                    filter.fields[name].value = value;
                }
            });

            filter.isActive(true);

            return filter;
        },
        updateClientsOptions: function updateClientsOptions(field) {
            var clientId = parseInt(filter.fields[field].value || 0);

            if (clientId) {
                clientsService.findForFilter(clientId).then(function (options) {
                    filter.fields[field].options = options;
                });
            }
        },
        getProviders: function getProviders(deferred) {
            if (_.isArray(filter.providers) && filter.providers.length) {
                var promises = [];
                var options = {};

                $log.debug('provider to fetch', filter.providers);
                angular.forEach(filter.providers, function (providerName) {
                    $log.debug('get provider for filter ' + providerName, routeResolver[providerName]);

                    var injected = $injector.invoke(routeResolver[providerName]);
                    if (_.isObject(injected.$$state)) {
                        promises.push(injected.then(function (data) {
                            options[providerName] = data;
                            $log.debug('fetched by promise ' + providerName + ': ', data);
                        }));
                    } else {
                        options[providerName] = injected;
                        $log.debug('fetched directly ' + providerName + ': ', injected);
                    }
                });

                $q.all(promises).then(function () {
                    filter.setAttributes({
                        providers: options
                    }).ready();

                    return deferred.resolve(filter);
                });
            } else {
                // jeżeli jest już obiektem, to od razu zwracamy
                deferred.resolve(filter);
            }
        },
        ready: function ready(callback) {
            // przygotowujemy pola
            angular.forEach(filter.fields, function (properties, field) {
                if ('string' === typeof properties.optionsProvider && 'undefined' !== typeof filter.providers[properties.optionsProvider]) {
                    properties.options = filter.providers[properties.optionsProvider];
                }
            });

            if (filter.saveLastConfig && '' === filter.currentConfigName) {
                filter.fillUsing($translate.instant('filter.last_used'));
            }

            if ('function' === typeof callback) {
                callback();
            }

            return filter;
        }
    };

    return filter;
});